import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // ==================== BOTTOM NAVIGATION ====================
      home: "Home",
      shop: "Shop",
      addAd: "Add Ad",
      bookingHub: "Booking Hub",
      navAccount: "Account",
      navStudentHub: "Student Central",
      navFarmHub: "Farm",
      
      // ==================== SELECT COMPONENT ====================
      select: "Select",
      search: "Search…",
      noResults: "No results",
      close: "Close",
      apply: "Apply",
      selectCategory: "Select category",
      selectState: "Select state",
      selectCity: "Select city",
      selectOption: "Select an option",
      
      // ==================== HEADER ====================
      login: "Log in / Sign up",
      logout: "Logout",
      
      // ==================== NOTIFICATIONS ====================
      notifications: "Notifications",
      notifTitle: "Notifications",
      notifEmpty: "No notifications yet",
      notifClear: "Clear all",
      notifClearTitle: "Clear all notifications?",
      notifClearMessage: "This will remove all your notifications. This action cannot be undone.",
      notifClearCancel: "Cancel",
      notifClearConfirm: "Yes, clear all",
      no_notifications: "No notifications",
      clear_notifications: "Clear notifications",
      notification_ad_published: "Your ad '{{title}}' has been published successfully",
      notification_ad_pending: "Your ad '{{title}}' is pending review",
      notification_ad_approved: "Your ad '{{title}}' has been approved",
      notification_ad_rejected: "Your ad '{{title}}' was rejected{{reasonSuffix}}",
      notification_ad_rejected_reason_suffix: ". Reason: {{reason}}",
      notification_ad_limited: "Your ad '{{title}}' visibility has been limited",
      notification_ad_under_review: "Your ad '{{title}}' is under review",
      notification_booking_confirmed: "Your booking has been confirmed",
      notification_account_banned: "Your account has been banned",
      notification_account_suspended: "Your account has been temporarily suspended",
      notification_ad_removed: "Your ad '{{title}}' has been removed",
      notification_ad_flagged: "Your ad '{{title}}' has been flagged for review",
      notification_welcome: "Welcome to Wassla!",
      notification_message_received: "You received a message from {{from}}",
      notification_generic: "Notification",
      
      // ==================== CATEGORIES (nested for dropdown) ====================
      categoriesTitle: "Categories",
      seeAll: "See All",
      allCategories: "All Categories",
      cat: {
        // ===== SIMPLIFIED CATEGORY KEYS (matching constants/categories.js) =====
        "vehicles": "Vehicles & Motorbikes",
        "spare_parts": "Vehicle Spare Parts & Accessories",
        "electronics": "Electronics & Accessories",
        "industrial": "Industrial Machinery",
        "equipment": "Equipment & Tools",
        "real_estate": "Real Estate",
        "agriculture": "Agriculture",
        "food": "Food & Beverages",
        "jewelry": "Jewelry",
        "gifts": "Gifts & Crafts",
        "pets": "Pets & Cattle",
        "metals": "Metals & Alloys",
        "fabrics": "Fabrics & Raw Materials",
        "garden": "Garden & Decorations",
        "it": "IT Equipment & Software Services",
        "manufacturing": "Manufacturing",
        "jobs": "Jobs",
        "medical": "Medical Devices",
        "security": "Security & Safety",
        "energy": "Energy",
        "services": "Services",
        "home": "Home Supplies",
        "furniture": "Furniture",
        "office": "Office & School Supplies",
        "apparel": "Apparel & Accessories",
        "beauty": "Women's & Beauty",
        "environment": "Environment",
        // New categories
        "commodities": "Commodities",
        "mobile_accessories": "Mobile & Accessories",
        "laptops_accessories": "Laptops & Accessories",
        "sports_equipment": "Sports Equipment & Supplies",
        "games_toys": "Games & Toys",
        "clothes_shoes": "Clothes & Shoes",
        "health_fitness": "Health & Fitness",
        
        // ===== LADIES HUB CATEGORIES =====
        "bags": "Bags",
        "shoes": "Shoes",
        "wedding": "Wedding Dresses",
        "wedding_dress": "Wedding Dresses",
        "dresses": "Dresses",
        "henna": "Henna",
        "perfume": "Perfume & Bakhour",
        "toub": "Sudanese Toub",
        "gold": "Gold & Jewelry",
        "african_fabric": "African Fabrics",
        "muslim_wear": "Muslim Wear & Hijab",
        "makeup": "Makeup",
        "hair": "Hair & Care",
        "skincare": "Skincare",
        "underwear": "Underwear",
        "salons": "Salons & Beauty",
        "home_business": "Home Businesses",
        
        // ===== LEGACY KEYS for backward compatibility =====
        "electronics_accessories": "Electronics & Accessories",
        "vehicles_motorbikes": "Vehicles & Motorbikes",
        "vehicle_spare_parts": "Vehicle Spare Parts & Accessories",
        "industrial_machinery": "Industrial Machinery",
        "equipment_tools": "Equipment & Tools",
        "food_beverage": "Food & Beverages",
        "gifts_crafts": "Gifts & Crafts",
        "pets_livestock": "Pets & Cattle",
        "pets_cattle": "Pets & Cattle",
        "metals_alloys": "Metals & Alloys",
        "fabrics_raw_materials": "Fabrics & Raw Materials",
        "fabric_raw_materials": "Fabrics & Raw Materials",
        "garden_decorations": "Garden & Decorations",
        "it_equipment_software": "IT Equipment & Software Services",
        "it_equipment_software_services": "IT Equipment & Software Services",
        "medical_devices": "Medical Devices",
        "security_safety": "Security & Safety",
        "home_supplies": "Home Supplies",
        "office_school_supplies": "Office & School Supplies",
        "apparel_accessories": "Apparel & Accessories",
        "womens_beauty": "Women's & Beauty",
        "jewellery": "Jewelry",
        
        // Legacy dash-based keys (for existing ads in DB)
        "cv-builder": "CV Builder",
        "food-beverages": "Food & Beverages",
        "others": "Others"
      },
      // Legacy flat keys for backward compat
      categories: "Categories",
      vehicles: "Vehicles & Motorbikes",
      spareParts: "Vehicle Spare Parts & Accessories",
      electronics: "Electronics & Accessories",
      industrialMachinery: "Industrial Machinery",
      equipmentTools: "Equipment & Tools",
      realEstate: "Real Estate",
      agriculture: "Agriculture",
      foodBeverage: "Food & Beverage",
      energy: "Energy",
      services: "Services",
      medicalDevices: "Medical Devices",
      apparel: "Apparel & Accessories",
      womensBeauty: "Women's & Beauty",
      furniture: "Furniture",
      homeSupplies: "Home Supplies",
      officeSchool: "Office Supplies & Schools",
      jewellery: "Jewellery",
      giftsCrafts: "Gifts & Crafts",
      petsCattle: "Pets & Cattle",
      metalsAlloys: "Metals & Alloys",
      fabricMaterials: "Fabric & Raw Materials",
      gardenDecorations: "Garden and Decorations",
      itEquipmentSoftware: "IT equipments and software services",
      securitySafety: "Security and Sefty",
      jobs: "Jobs",
      others: "Others",
      noAdsYet: "No ads yet – be the first!",
      
      // ==================== COMMON ====================
      cancel: "Cancel",
      delete: "Delete",
      loading: "Loading...",
      back: "Back",
      edit: "Edit",
      save: "Save",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      clear: "Clear",
      confirm: "Confirm",
      success: "Success!",
      error: "An error occurred",
      tryAgain: "Try Again",
      noResults: "No results found",
      comingSoon: "Coming Soon",
      name: "Name",
      searchCurrency: "Search currency or code...",
      selectCurrency: "Select Currency",
      chat: "Chat",
      call: "Call",
      phone: "Phone Number",
      phoneRequired: "Phone number required for this contact method",
      state: "State",
      selectState: "Select State",
      allStates: "All States",
      close: "Close",
      coins: "coins",
      free: "Free",
      recommended: "Recommended",
      premium: "Premium",
      unitMinutes: "minutes",
      unitPoints: "points",
      unitAds: "ads",
      unitOpens: "opens",
      unitClicks: "clicks",
      unitWeek: "week",
      orDivider: "or",
      boostValidDays: "Valid for {{days}} days",

      // ==================== AD DETAILS PAGE ====================
      adDetails: {
        // Availability statuses
        sold: "Sold",
        expired: "Expired",
        unavailable: "Unavailable",
        reserved: "Reserved",
        available: "Available",
        // Banners
        notAvailable: "Not available",
        soldOrExpiredBanner: "This ad is sold or expired. Contact is disabled.",
        priceWarning: "Price much lower than typical market value. Verify seller before paying.",
        mayBeUnavailable: "This listing may be unavailable",
        adNotFound: "Ad not found",
        listingHidden: "Listing hidden",
        hideConfirmTitle: "Hide this listing?",
        hideConfirmSubtext: "This will hide the listing from your browsing view. It will not delete or report the ad.",
        hideConfirmBtn: "Hide",
        hideCancel: "Cancel",
        signInToContact: "Sign in to contact seller",
        // Price
        priceOnRequest: "Price on request",
        // Facts row
        condition: "Condition",
        negotiable: "Negotiable",
        views: "views",
        // Price Insight
        priceInsight: "Price Insight",
        typicalRange: "Typical range",
        belowTypical: "Below typical",
        aboveTypical: "Above typical",
        fairPrice: "Fair price",
        // Safety tip (replaces Price Insight on public Ad Details, MVP)
        safetyTipTitle: "Safety Tip",
        safetyTipBody: "Compare similar listings before paying. Avoid advance payments and meet the seller in a safe public place.",
        // Actions
        report: "Report",
        reported: "Reported",
        hide: "Hide",
        save: "Save",
        saved: "Saved",
        message: "Message",
        savedToFavorites: "Saved to your favorites",
        browseSimilar: "Browse similar",
        boostAd: "Boost Ad",
        // Description
        descriptionTitle: "Description",
        noDescription: "No description yet.",
        readMore: "Read more",
        readLess: "Read less",
        // Seller
        seller: "Seller",
        memberSince: "Member since",
        notAvailableShort: "Not available",
        viewProfile: "View profile",
        peopleContacted: "{{count}} people contacted this seller",
        phoneVerified: "Phone verified",
        repliesFast: "Replies fast",
        // Share
        shareThisAd: "Share this Ad",
        // iter312 — Social sharing upgrade
        promoteThisAd: "Promote this Ad",
        // Post Details Modal
        postDetails: "Post details",
        postedAt: "Posted at",
        lastUpdated: "Last updated",
        done: "Done",
        // WhatsApp
        whatsappMessage: "Hi, I'm interested in this listing: {{title}}",
        // Similar/Related Ads
        similarAds: "Similar ads you may like",
        moreInCategory: "More in this category",
        sponsored: "Sponsored",
        seeAll: "See all",
        noSimilarAds: "No similar ads right now.",
        couldNotLoadRelated: "Couldn't load related ads. Please try again later.",
        noImage: "No image",
        ad: "Ad",
        priceNotSet: "Price not set",
        locationNotSet: "Location not set",
        // More from seller
        moreFromSeller: "More from this seller",
        seeAllListings: "See all listings",
        // Last active
        activeToday: "Active today",
        activeThisWeek: "Active this week",
        activeRecently: "Active recently",
        // Profile completeness
        profileCompleteness: "Profile strength",
        // Safety tips
        safetyTipsTitle: "Safety tips",
        safetyTip1: "Meet in a safe public place",
        safetyTip2: "Verify the item before payment",
        safetyTip3: "Avoid advance payment to strangers",
        // Seller profile page
        sellerListings: "Listings",
        activeListings: "active listings",
        showMore: "Show more",
        noListings: "No listings yet",
        joinedOn: "Joined",
        responseVeryFast: "Very fast responder",
        responseFast: "Fast responder",
        responseHours: "Responds within hours",
      },

      // ==================== CURRENCIES (ISO 4217) ====================
      currency: {
        // Africa - East
        SDG: "Sudanese Pound",
        SSP: "South Sudanese Pound",
        KES: "Kenyan Shilling",
        UGX: "Ugandan Shilling",
        TZS: "Tanzanian Shilling",
        ETB: "Ethiopian Birr",
        ERN: "Eritrean Nakfa",
        DJF: "Djiboutian Franc",
        SOS: "Somali Shilling",
        RWF: "Rwandan Franc",
        BIF: "Burundian Franc",
        // Africa - Central
        CDF: "Congolese Franc",
        XAF: "Central African CFA Franc",
        // Africa - West
        XOF: "West African CFA Franc",
        NGN: "Nigerian Naira",
        GHS: "Ghanaian Cedi",
        SLL: "Sierra Leonean Leone",
        LRD: "Liberian Dollar",
        GMD: "Gambian Dalasi",
        GNF: "Guinean Franc",
        CVE: "Cape Verdean Escudo",
        MRU: "Mauritanian Ouguiya",
        // Africa - North
        EGP: "Egyptian Pound",
        LYD: "Libyan Dinar",
        TND: "Tunisian Dinar",
        DZD: "Algerian Dinar",
        MAD: "Moroccan Dirham",
        // Africa - Southern
        ZAR: "South African Rand",
        ZMW: "Zambian Kwacha",
        MWK: "Malawian Kwacha",
        MZN: "Mozambican Metical",
        AOA: "Angolan Kwanza",
        BWP: "Botswanan Pula",
        NAD: "Namibian Dollar",
        SZL: "Swazi Lilangeni",
        LSL: "Lesotho Loti",
        ZWL: "Zimbabwean Dollar",
        // Africa - Islands
        MUR: "Mauritian Rupee",
        SCR: "Seychellois Rupee",
        KMF: "Comorian Franc",
        MGA: "Malagasy Ariary",
        STN: "São Tomé Dobra",
        // MENA - Gulf
        SAR: "Saudi Riyal",
        AED: "UAE Dirham",
        QAR: "Qatari Riyal",
        KWD: "Kuwaiti Dinar",
        BHD: "Bahraini Dinar",
        OMR: "Omani Rial",
        // MENA - Levant
        JOD: "Jordanian Dinar",
        LBP: "Lebanese Pound",
        SYP: "Syrian Pound",
        IQD: "Iraqi Dinar",
        ILS: "Israeli Shekel",
        // MENA - Other
        YER: "Yemeni Rial",
        IRR: "Iranian Rial",
        // Global - Major
        USD: "US Dollar",
        EUR: "Euro",
        GBP: "British Pound",
        CHF: "Swiss Franc",
        JPY: "Japanese Yen",
        CNY: "Chinese Yuan",
        INR: "Indian Rupee",
        PKR: "Pakistani Rupee",
        BDT: "Bangladeshi Taka",
        TRY: "Turkish Lira",
        RUB: "Russian Ruble",
        BRL: "Brazilian Real",
        MXN: "Mexican Peso",
        CAD: "Canadian Dollar",
        AUD: "Australian Dollar",
        NZD: "New Zealand Dollar",
        SGD: "Singapore Dollar",
        HKD: "Hong Kong Dollar",
        KRW: "South Korean Won",
        THB: "Thai Baht",
        MYR: "Malaysian Ringgit",
        IDR: "Indonesian Rupiah",
        PHP: "Philippine Peso",
        VND: "Vietnamese Dong"
      },
      
      // Currency region labels
      currencyRegionAfrica: "Africa",
      currencyRegionMena: "Middle East & North Africa",
      currencyRegionGlobal: "Global Currencies",
      
      // ==================== WELCOME PAGE ====================
      welcomePageTitle: "Welcome to Wassla",
      welcomePageSubtitle: "One Link. Many Opportunities.",
      signUpWithGoogle: "Continue with Google",
      signUpWithEmail: "Continue with Email",
      alreadyAccount: "Already have an account? ",
      signInLink: "Sign In",
      
      // ==================== ADD AD ====================
      addAdTitle: "Add Ad",
      step1Title: "Ad Details",
      step2Title: "Price & Location",
      step3Title: "Description & Photos",
      step4Title: "Preview",
      editBtn: "Edit",
      publishBtn: "Publish",
      previewTitle: "Preview",
      assistantPriceTip: "Set a fair price to get faster responses",
      assistantStart: "Let's create your ad! Start by selecting a category.",
      assistantPhotoTip: "Good photos help sell faster! Clear photos get more views.",
      
      // Location warnings and messages
      locationWarning: "Please add your location so buyers can find you easily.",
      locationRequired: "Location is required to publish your ad.",
      
      // Distance display
      distanceAway: "{{distance}} km away",
      distanceUnknown: "Distance unknown",
      
      // Image quality warnings
      imageQualityWarning: "Image looks blurry or dark. Clear photos get more views.",
      imageBlurry: "Blurry",
      imageDark: "Too dark",
      imageQualityTip: "Good quality photos get more responses",
      
      // Moderation flags
      flagMissingLocation: "Missing location",
      flagNoImages: "No images uploaded",
      flagLowQualityImages: "Low quality images detected",
      flagShortTitle: "Title too short",
      flagShortDescription: "Description too short",
      
      currencyLabel: "Currency",
      currencySdg: "Sudanese Pound (SDG)",
      currencyUsd: "US Dollar (USD)",
      currencyEgp: "Egyptian Pound (EGP)",
      currencyEth: "Ethiopian Birr (ETB)",
      currencySsp: "South Sudanese Pound (SSP)",
      currencySar: "Saudi Riyal (SAR)",
      currencyAed: "UAE Dirham (AED)",
      currencyEur: "Euro (EUR)",
      currencyGbp: "British Pound (GBP)",
      currencyQar: "Qatari Riyal (QAR)",
      currencyKwd: "Kuwaiti Dinar (KWD)",
      currencyBhd: "Bahraini Dinar (BHD)",
      currencyOmr: "Omani Rial (OMR)",
      currencyJod: "Jordanian Dinar (JOD)",
      currencyLbp: "Lebanese Pound (LBP)",
      currencyIqd: "Iraqi Dinar (IQD)",
      currencyTry: "Turkish Lira (TRY)",
      currencyMad: "Moroccan Dirham (MAD)",
      currencyTnd: "Tunisian Dinar (TND)",
      currencyDzd: "Algerian Dinar (DZD)",
      currencyLyd: "Libyan Dinar (LYD)",
      currencyEtb: "Ethiopian Birr (ETB)",
      currencyKes: "Kenyan Shilling (KES)",
      currencyUgx: "Ugandan Shilling (UGX)",
      currencyTzs: "Tanzanian Shilling (TZS)",
      currencyNgn: "Nigerian Naira (NGN)",
      currencyGhs: "Ghanaian Cedi (GHS)",
      currencyZar: "South African Rand (ZAR)",
      currencyZmw: "Zambian Kwacha (ZMW)",
      currencyRwf: "Rwandan Franc (RWF)",
      currencySos: "Somali Shilling (SOS)",
      currencyXof: "West African CFA (XOF)",
      currencyXaf: "Central African CFA (XAF)",
      currencyGroupPopular: "Popular",
      currencyGroupMena: "Middle East & North Africa",
      currencyGroupAfrica: "Africa",
      priceLabel: "Price",
      pricePlaceholder: "Enter price",
      discountLabel: "Discount %",
      discountPlaceholder: "0-100",
      locationLabel: "Location",
      locationHint: "Enter your city/area",
      locationPlaceholder: "Enter location",
      useMyLocation: "Use my location",
      pickFromMap: "Pick from map",
      gettingLocation: "Getting your location...",
      locationPermissionDenied: "Location permission denied. Please enter manually.",
      locationError: "Could not get location. Please try again.",
      locationFound: "Location found!",
      mapPickerHint: "Enter coordinates to set your location",
      mapComingSoon: "Interactive map coming soon",
      latitude: "Latitude",
      longitude: "Longitude",
      
      // Preview Step
      noImagesYet: "No images uploaded yet",
      imagesLabel: "Images",
      
      descLabel: "Description",
      descPlaceholder: "Describe your item...",
      descHint: "Write a detailed description",
      descHelper: "Describe the condition, features, size, price details, location, or service details.",
      titleLabel: "Product / Service Name *",
      titlePlaceholder: "e.g. iPhone 13 Pro, Wedding Hall, Plumbing Service",
      titleHelper: "Use a short, clear name only",
      categoryLabel: "Category",
      categoryPlaceholder: "Select a category",
      categoryTitle: "Choose Category",
      selectCategory: "Select a category",
      imagesLabel: "Images",
      imagesHint: "Upload up to 5 images",
      imagesTitle: "Photos",
      imagesMax: "max 5",
      network: {
        offline: "No internet connection",
        restored: "Connection restored",
        loadError: "Could not load data. Please retry",
        retry: "Retry",
        submitFailed: "Submission failed due to connection loss. Your draft was saved",
        publishFailed: "Ad was not published. Check your connection and try again",
        uploadFailed: "Image upload failed. Please retry",
      },
      cb: {
        pageTitle: "Post a Book",
        pageSubtitle: "Share books, summaries, notebooks, or study materials with students.",
        uploadTitle: "Upload Preview",
        uploadSubtitle: "Add a cover or sample pages",
        tapToUpload: "Tap to upload images",
        uploadHint: "Optional — add preview images of your content",
        upTo5: "up to 5 images",
        maxSize: "max 5 MB each",
        maxImages: "You can upload up to 5 images",
        maxFileSize: "Each image must be less than 5 MB",
        invalidFormat: "Only JPG, PNG, and WEBP files are supported",
        uploadFailed: "Image upload failed. Please try again.",
        basicTitle: "Basic Details",
        titlePlaceholder: "e.g. Physics Summary Notes",
        authorPlaceholder: "Author name",
        selectSubject: "Select subject",
        selectCondition: "Select condition",
        conditionUsedExcellent: "Used - Excellent",
        conditionUsedGood: "Used - Good",
        conditionUsedFair: "Used - Fair",
        listingTitle: "Listing Setup",
        listingType: "Listing Type",
        modeSell: "Sell",
        modeRent: "Rent",
        modeFree: "Free",
        modeDownload: "Download",
        academicLevel: "Academic Level",
        selectLevel: "Select level",
        levelPrimary: "Primary",
        levelSecondary: "Secondary",
        levelUniversity: "University",
        levelPostgrad: "Postgraduate",
        contentType: "Content Type",
        selectType: "Select type",
        typeTextbook: "Book",
        typeNotes: "Study Summary",
        typePastPapers: "Exam Sheets",
        typeLectureNotes: "Lecture Notes",
        typeSummary: "Study Summary",
        typeSlides: "Slides",
        typeLabManual: "Lab Manual",
        typeNotebook: "Notebook",
        typePdf: "PDF",
        typeMagazine: "Magazine",
        typeOther: "Other",
        classificationTitle: "Academic Classification",
        classificationHelper: "This helps students find materials relevant to their level, state, or university.",
        universityHint: "Add a university only if this material is specific to that institution.",
        selectUniversity: "Select university",
        detailsLabel: "Details",
        descPlaceholder: "Describe the book, subject coverage, edition, condition, and anything useful for students.",
        contactTitle: "Contact Method",
        preferredContact: "Preferred contact",
        contactChat: "Chat",
        contactPhone: "Phone",
        contactWhatsApp: "WhatsApp",
        contactChatPhone: "Chat & Phone",
        contactChatWhatsApp: "Chat & WhatsApp",
        contactEmail: "Email",
        contactHint: "Select all the ways buyers can reach you",
        whatsappLabel: "WhatsApp number",
        whatsappFallbackHint: "Leave empty to use your phone number",
        emailLabel: "Contact email",
        previewBtn: "Preview",
        previewTitle: "Review Listing",
        previewSubtitle: "Check the details before publishing.",
        editBtn: "Edit",
        publishBtn: "Publish Listing",
        confirmTitle: "Confirm posting",
        confirmMsg: "Are you sure you want to publish this book listing?",
        confirmPublish: "Confirm Publish",
        submitHint: "Make sure your title, subject, and description are accurate before posting.",
        fixErrors: "Please fix the errors before continuing",
        validationBanner: "Please complete the highlighted required fields.",
        currency: "Currency",
        success: "Congratulations! Your listing has been posted publicly.",
        submitError: "Failed to publish listing. Please try again.",
        errTitle: "Book title is required",
        errAuthor: "Author is required",
        errSubject: "Subject is required",
        errCondition: "Condition is required",
        errListingType: "Listing type is required",
        errAcademicLevel: "Academic level is required",
        errContentType: "Content type is required",
        errState: "State is required",
        errContactMethod: "Contact method is required",
        errPrice: "Price is required for sell or rent listings",
        errPhone: "Phone number is required for this contact method",
        errPhoneInvalid: "Enter a valid phone number (e.g. +249 9xx xxx xxx)",
        errWhatsapp: "WhatsApp number is required for this contact method",
        errWhatsappInvalid: "Enter a valid WhatsApp number (e.g. +249 9xx xxx xxx)",
        errEmail: "A valid email is required for this contact method",
      },
      imagesQualityTip: "Use clear, well-lit photos",
      uploadImages: "Upload Images",
      next: "Next",
      nextStep: "Next",
      prevStep: "Previous",
      step: "Step",
      of: "of",
      exitTitle: "Discard changes?",
      exitMessage: "If you leave, your changes will be lost.",
      exitCancel: "Cancel",
      exitConfirm: "Leave",
      previewHint: "Review your ad before publishing",
      publishSuccessTitle: "Ad Published!",
      publishSuccessMsg: "Your ad is now live and visible to buyers.",
      viewAdBtn: "View Ad",
      myAdsBtn: "My Ads",
      addAdStartBtn: "Add Another Ad",
      errPublishFailed: "Failed to publish. Please try again.",
      
      // Category-specific description examples
      descExampleElectronics: "Used iPhone 13 Pro, 256GB, clean condition, original charger included, price negotiable, Gedarif.",
      descExampleVehicles: "Toyota Corolla 2012, automatic, good condition, registered, price negotiable, Gedarif.",
      descExampleRealEstate: "2-bedroom apartment for rent, electricity and water available, near market, monthly rent, Gedarif.",
      descExampleServices: "Professional plumbing service, home visits available, fast response, affordable prices.",
      descExampleJobs: "Restaurant needs a cashier, full-time, experience preferred, salary discussed after interview.",
      descExampleFashion: "Gold necklace, new condition, elegant design, suitable for gifts, price negotiable.",
      descExampleDefault: "Provide details about your product or service to help buyers make an informed decision.",
      
      // ==================== AD DETAILS ====================
      contactSeller: "Contact Seller",
      saveToFavorites: "Save to Favorites",
      removeFromFavorites: "Remove from Favorites",
      description: "Description",
      price: "Price",
      location: "Location",
      postedOn: "Posted on",
      noImageAvailable: "No image available",
      
      // ==================== CONTACT MODAL ====================
      contactOptions: "Contact Options",
      emailSeller: "Email",
      callSeller: "Call",
      whatsappSeller: "WhatsApp",
      messengerSeller: "Messenger",
      noContactInfo: "Seller contact info not available",
      inquirySubject: "Inquiry about",
      interestedIn: "Hi, I'm interested in",
      
      // ==================== FEATURED ====================
      featuredAds: "Featured Ads",
      noListings: "No listings yet",
      
      // ==================== SEARCH ====================
      searchPlaceholder: "Search for products or services",
      searchHelper: "Search, sell, or book with AI assistance",
      
      // ==================== WALLET ====================
      walletPageTitle: "My Wallet",
      balanceLabel: "Your Balance",
      walletCoinsLabel: "coins",
      earnTitle: "Earn Coins",
      earnDailyTitle: "Daily Check-in",
      walletDailyRate: "+1 coin",
      earnDailyDesc: "Check in daily to earn free coins",
      earnDailySuccess: "You earned {{amount}} coin(s)!",
      earnDailyDone: "Already checked in today",
      earnProfileTitle: "Complete Profile",
      earnProfileDesc: "Add your name and photo",
      earnFirstAdTitle: "Post Your First Ad",
      earnFirstAdDesc: "Create and publish an ad",
      earnRefTitle: "Refer a Friend",
      earnRefDesc: "Invite friends to join",
      bookingFirstTitle: "Make a Booking",
      bookingFirstDesc: "Book a service",
      claim: "Claim",
      claiming: "Claiming...",
      rulesTitle: "Coin Rules",
      rules1: "Coins can be used for featured ads",
      rules2: "Daily check-in resets at midnight",
      rules3: "Coins cannot be transferred",
      historyTitle: "Transaction History",
      viewAllHistory: "View All",
      noTransactions: "No transactions yet",
      reasonReward: "Reward",
      reasonUsage: "Usage",
      reasonSignup: "Welcome bonus",
      reasonDaily: "Daily check-in",
      reasonFirstAd: "First ad posted",
      reasonFirstBooking: "First booking",
      reasonProfile: "Profile completed",
      reasonReferral: "Friend referral",
      reasonWatchAd: "Watched ad",
      reasonFeatured: "Featured ad",
      // Transaction reason codes (used by backend reason_code field)
      tx: {
        DAILY_CHECKIN: "Daily Check-in",
        PROFILE_COMPLETE: "Profile Completed",
        FIRST_AD_POST: "First Ad Posted",
        PHONE_VERIFIED: "Phone Verified",
        REFERRAL_AFTER_AD_POST: "Referral Bonus",
        BOOST_HIGHLIGHT_24H: "Boost - Highlight",
        BOOST_TOP_CATEGORY_24H: "Boost - Top of Category",
        BOOST_HOMEPAGE_24H: "Boost - Homepage",
        BADGE_URGENT_7D: "Urgent Badge",
        AUTO_REFRESH_24H: "Auto Refresh",
        UNLOCK_ANALYTICS_7D: "Unlock Insights",
        EXTRA_IMAGES_1: "Extra Image",
        AI_REWRITE_TITLE: "AI Title Rewrite",
        AI_REWRITE_DESC: "AI Description Rewrite",
        signup_bonus: "Welcome Bonus",
        daily_checkin: "Daily Check-in",
        first_ad_posted: "First Ad Posted",
        profile_completed: "Profile Completed",
        referral_signup: "Friend Referral"
      },
      
      // ==================== ACCOUNT ====================
      myAds: {
        title: "My Ads",
        statusPublished: "Published",
        statusActive: "Active",
        statusPending: "Under Review",
        statusUnderReview: "Under Review",
        rejectionReasonLabel: "Reason",
        statusLimited: "Limited",
        statusHidden: "Hidden",
        statusRejected: "Rejected",
        statusDraft: "Draft",
        statusSold: "Sold",
        statusRemoved: "Removed",
      },
      // iter352 — Saved/Favorites page namespace (approved copy). The page
      // previously referenced non-existent `homePage.*` keys and leaked raw
      // translation keys into the UI.
      favoritesPage: {
        title: "Saved",
        emptyTitle: "No saved ads yet",
        emptySubtitle: "Tap the heart on any ad to save it here.",
        browseCta: "Browse ads",
        loading: "Loading your saved ads…",
        errorTitle: "Couldn't load your saved ads",
        errorSubtitle: "Please check your connection and try again.",
        retryCta: "Try again",
        signInRequired: "Sign in to view your saved ads",
        signInCta: "Sign in",
      },
      myBookings: "My Bookings",
      favorites: "Favorites",
      noAdsYet: "No ads yet",
      noAdsSubtitle: "Start selling by creating your first ad",
      noBookingsYet: "No bookings yet",
      noBookingsSubtitle: "Explore and book services",
      noFavoritesYet: "No favorites yet",
      noFavoritesSubtitle: "Browse the shop and save items you like",
      favoritesLoading: "Loading...",
      favoritesSignInRequired: "Sign in to view your saved items",
      favoritesSignInCta: "Sign in",
      favoritesBrowseCta: "Browse Shop",
      deleteAdTitle: "Delete this ad?",
      deleteAdMessage: "This action cannot be undone.",
      deleteAdCancel: "Cancel",
      deleteAdConfirm: "Yes, delete",
      
      // ==================== TOAST NOTIFICATIONS ====================
      toast: {
        savedSuccess: "Saved successfully ✓",
        photoUpdated: "Photo updated",
        profileUpdated: "Profile updated",
        invalidWhatsapp: "Please enter a valid WhatsApp number",
        invalidMessenger: "Enter a valid Messenger link or username (e.g., m.me/username)",
        photoUploadError: "Photo upload error",
        accountDeleted: "Account deleted",
        deleteAccountFailed: "Failed to delete account",
        connectionError: "Connection error",
        nameRequired: "Name is required",
        invalidPhone: "Invalid phone format",
        selectImage: "Please select an image",
        imageTooLarge: "Image too large (max 5MB)",
        comingSoon: "Coming soon",
        copied: "Copied!",
        linkCopied: "Link copied",
        shareTextCopied: "Share text copied",
        sharedSuccess: "Shared successfully",
        copyFailed: "Could not copy",
        adPublished: "Your ad has been published successfully",
        error: "An error occurred",
        // Pro PDF / Unlock features
        proPdfUnlocked: "Pro PDF unlocked! 🎉",
        paymentFailed: "Failed to start payment",
        uploadReceipt: "Please upload receipt image",
        receiptSubmitted: "Receipt submitted successfully",
        receiptFailed: "Failed to submit receipt",
        adsFailed: "Failed to start ads",
        watchFailed: "Failed to record watch",
        gameFailed: "Failed to start game",
        sessionFailed: "Failed to record session",
        // Low bandwidth
        lowBandwidthEnabled: "Low Bandwidth Mode enabled",
        lowBandwidthDisabled: "Low Bandwidth Mode disabled",
      },
      
      // ==================== MODERATION ====================
      moderation: {
        adPosted: "Ad posted successfully",
        adPending: "Your ad is pending review",
        adApproved: "Your ad has been approved",
        adRejected: "Your ad was rejected",
        adLimited: "Your ad visibility has been limited",
        adUnderReview: "Your ad is under review",
        reportReceived: "Report received. Thank you!",
        alreadyReported: "You have already reported this ad",
        forbidden: "Action not permitted",
        networkError: "Network error. Please try again.",
        // Report reasons
        reportSpam: "Spam",
        reportScam: "Scam / Fraud",
        reportHate: "Hate speech",
        reportAdult: "Adult content",
        reportViolence: "Violence",
        reportIllegal: "Illegal activity",
        reportOther: "Other",
      },
      
      // ==================== AD STATUS MESSAGES ====================
      ad: {
        pending_review: "Your ad has been submitted and is pending review",
        rejected: "Your ad was rejected for policy violations"
      },
      
      // ==================== REPORT UNAVAILABLE (P1-B) ====================
      reportUnavailable: {
        title: "Item not available?",
        description: "Help keep listings accurate by reporting unavailable items",
        reasonSold: "Already sold",
        reasonNotResponding: "Seller not responding",
        reasonWrongInfo: "Wrong information",
        submit: "Submit Report",
        cancel: "Cancel",
        successToast: "Thanks—your report helps keep listings accurate.",
        alreadyReported: "You already reported this listing.",
        suspectedBadge: "May be unavailable",
        suspectedWarning: "Reported by buyers • seller may not respond"
      },
      
      // ==================== AD STATUS LABELS ====================
      adStatus: {
        active: "Live",
        draft: "Draft",
        pendingReview: "Moderation",
        hidden: "Hidden",
        sold: "Sold",
        rejected: "Rejected",
      },

      // ==================== ACCOUNT PAGE ====================
      account: {
        title: "My Account",
        guest: "Guest",
        editInfo: "Edit Information",
        overview: "Overview",
        performance: "Performance Insights",
        myAds: "My Ads",
        favorites: "Saved",
        wallet: "Wallet",
        seeAll: "See All",
        // Form labels
        name: "Name",
        namePlaceholder: "Full name",
        phone: "Phone",
        whatsappPhone: "WhatsApp Number",
        whatsappHint: "Used for WhatsApp contact (leave blank to use phone)",
        messengerLink: "Messenger Link",
        messengerHint: "Your Facebook Messenger profile link (m.me/username)",
        country: "Country",
        searchCountry: "Search country...",
        noCountryFound: "No country found",
        stateRegion: "State/Region",
        regionPlaceholder: "e.g., Khartoum, California",
        selectState: "Select state",
        city: "City",
        optional: "Optional",
        // Actions
        save: "Save",
        saving: "Saving...",
        cancel: "Cancel",
        // Status
        active: "Active",
        pending: "Pending",
        expired: "Expired",
        // Stats
        activeAds: "Active Ads",
        totalViews: "Total Views",
        walletBalance: "Wallet Balance",
        responses: "Responses",
        noneYet: "None yet",
        noViewsYet: "No views yet",
        noResponsesYet: "No responses",
        // Empty states
        noAdsYet: "No ads yet",
        createFirstAd: "Create your first ad and start selling",
        createAd: "Create Ad",
        postAdToSeeInsights: "Post an ad to see insights",
        // Performance
        topPerformingAd: "Top Performing Ad",
        viewsToday: "Views Today",
        thisWeek: "This Week",
        // Balance
        currentBalance: "Current Balance",
        topUp: "Top Up",
        withdraw: "Withdraw",
        // Linked accounts
        linkedAccounts: "Linked Accounts",
        link: "Link",
        // Settings
        darkMode: "Dark Mode",
        lowBandwidthMode: "Low Bandwidth Mode",
        notifications: "Notifications",
        privacyPolicy: "Privacy Policy",
        termsConditions: "Terms & Conditions",
        helpSupport: "Help & Support",
        logout: "Log Out",
        deleteAccount: "Delete Account",
        deleteAccountTitle: "Delete Account?",
        deleteAccountMessage: "Deleting your account is permanent. Your account and public listings will no longer be available after deletion. Certain limited records may be retained only where reasonably necessary for security, fraud prevention, dispute handling, enforcement, accounting, or legal/regulatory compliance. See our Privacy Policy for details.",
        deleteAccountPasswordPlaceholder: "Enter your password to confirm",
        deleteWrongPassword: "Incorrect password. Please try again.",
        delete: "Delete",
        // Account Settings (NEW)
        accountSettings: "Account Settings",
        clearAppCache: "Clear Temporary Storage",
        clearCacheConfirm: "This will remove temporary cached files to free storage. Your account, ads, messages, favourites, wallet balance and settings will not be deleted.",
        tempStorageCleared: "Temporary storage cleared.",
        clearCacheSuccess: "Cache cleared successfully",
        notificationSettings: "Notification Preferences",
        pushNotifications: "Push Notifications",
        emailNotifications: "Email Notifications",
        notifChannelsSection: "Notification channels",
        notifTypesSection: "Notification types",
        listingActivity: "Listing & Ad Activity",
        savedSearchesNotif: "Saved Searches & Recommendations",
        essentialAlerts: "Essential account & security alerts",
        essentialAlertsDesc: "Required for account security and important service updates.",
        notifPrefsUpdated: "Notification preferences updated",
        notifPrefsError: "Could not save notification preferences. Please try again.",
        adsNotifications: "Ads Notifications",
        systemAlerts: "System Alerts",
        messages: "Messages",
        // Language & Onboarding Settings
        language: "Language",
        languageArabic: "العربية",
        languageEnglish: "English",
        changeProfileType: "Change Profile Type",
        resetOnboarding: "Reset Onboarding",
        resetOnboardingConfirm: "This will show the profile picker again on next visit.",
        onboardingReset: "Onboarding reset. You'll see the picker on next visit.",
        // Profile Settings (NEW)
        profileSettings: "Profile Settings",
        updateEmail: "Update Email",
        currentPassword: "Current Password",
        newEmailAddress: "New Email Address",
        verificationEmailSent: "Verification email sent",
        changePassword: "Change Password",
        newPassword: "New Password",
        confirmNewPassword: "Confirm New Password",
        passwordUpdated: "Password updated successfully",
        // Buttons & Messages
        saveChanges: "Save Changes",
        cancel: "Cancel",
        saving: "Saving…",
        changesSaved: "Changes saved successfully",
        saveFailed: "Save failed, please try again",
        // Additional keys from second account section
        guest: "Guest",
        personalInfo: "Personal Information",
        studentProfile: "Student Profile",
        settings: "Settings",
        terms: "Terms of Use",
        contactUs: "Contact Us",
        accountActions: "Account Actions",
        signOut: "Sign Out",
        signOutTitle: "Sign Out?",
        signOutMessage: "Are you sure you want to sign out of your account?",
        editProfile: "Edit Profile",
        accountType: "Account Type",
        memberSince: "Member since {{date}}",
        // Ad status labels
        recall: "Recall",
        edit: "Edit",
        draft: "Draft",
        published: "Published",
        limited: "Limited",
        underReview: "Under Review",
        rejected: "Rejected",
        generalUser: "General User"
      },
      
      // ==================== ADS MESSAGES ====================
      ads: {
        recalled: "Your ad has been recalled for editing",
        deleted: "Your ad has been deleted",
        published: "Your ad has been published successfully",
        flagged: "Your ad was flagged and limited",
        rejected: "Your ad was rejected due to policy violation",
        updated: "Your ad was updated and sent for review",
        approved: "Your ad was approved and published",
        mustRecallFirst: "You must recall the ad before editing",
        deleteNotAllowed: "You can only delete Draft or Rejected ads"
      },
      
      // ==================== PRICE DROP ====================
      priceDrop: {
        badge: "Price dropped",
        previousPrice: "was",
        dropPercent: "{{percent}}% off",
      },

      // ==================== ERRORS ====================
      errors: {
        bannedUser: "You are banned from posting ads",
        networkError: "Network error. Please try again.",
        unauthorized: "You are not authorized to perform this action"
      },
      
      // ==================== REPORTS ====================
      reports: {
        received: "Report received. Thank you.",
        alreadyReported: "You already reported this ad",
        submitReport: "Submit Report",
        reportReason: "Report Reason",
        reportDetails: "Additional Details"
      },
      
      // ==================== AUTH ====================
      welcomeTitle: "Welcome to Wassla",
      welcomeSubtitle: "One Link. Many Opportunities.",
      signInWithGoogle: "Continue with Google",
      signInWithEmail: "Continue with Email",
      orDivider: "or",
      emailLabel: "Email",
      email: "Email",
      emailPlaceholder: "Enter your email",
      passwordLabel: "Password",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      confirmPasswordLabel: "Confirm Password",
      confirmPasswordPlaceholder: "Re-enter your password",
      passwordsDoNotMatch: "Passwords do not match",
      nameLabel: "Full Name",
      namePlaceholder: "Enter your full name",
      signIn: "Sign In",
      signUp: "Sign Up",
      createAccount: "Create Account",
      alreadyHaveAccount: "Already have an account? ",
      dontHaveAccount: "Don't have an account? ",
      forgotPassword: "Forgot Password?",
      // ── Password reset modal ────────────────────────────────────
      resetStep1Sub: "Enter the email address linked to your Wassla account. We'll send a 6-digit code to reset your password.",
      resetSendCode: "Send reset code",
      resetAlreadyHaveCode: "I already have a code",
      resetStep2Title: "Reset your password",
      resetStep2Sub: "Enter the 6-digit code and choose a new password.",
      resetStep2SubSent: "We've sent a 6-digit code to {{email}} (if it's registered). It expires in 15 minutes. If the email is delayed, contact support.",
      resetCodeLabel: "6-digit code",
      resetCodeInvalid: "Enter the 6-digit numeric code",
      resetNewPassword: "New password",
      resetNewPasswordPlaceholder: "At least 10 characters",
      resetConfirmPassword: "Confirm new password",
      resetConfirmPasswordPlaceholder: "Re-enter new password",
      resetPasswordPolicy: "Min 10 characters, with uppercase, lowercase, number, and special character.",
      resetConfirmCta: "Update password",
      resetBackToEmail: "Use a different email",
      resetSuccess: "Password updated successfully",
      resetSuccessTitle: "Password updated",
      resetSuccessSub: "You can now sign in with your new password.",
      resetGoToLogin: "Back to sign in",
      resetRequestFailed: "Couldn't send the reset code right now. Please try again or contact support.",
      resetConfirmFailed: "Invalid or expired code. Please request a new one.",
      resetResendCode: "Resend code",
      resetResendIn: "Resend in {{count}}s",
      resetResendFailed: "Couldn't resend the code right now. Please wait a moment and try again.",
      guestSignInPrompt: "Sign in to save favorites, contact sellers faster, and see personalized offers.",
      profilePhoto: "Profile Photo",
      uploading: "Uploading...",
      showPassword: "Show password",
      hidePassword: "Hide password",
      loginBtn: "Sign In",
      signupSubmit: "Create Account",
      
      // ==================== SIGNUP SUCCESS ====================
      signupSuccessTitle: "Welcome!",
      signupSuccessSubtitle: "You've earned {coins} coins to get started!",
      signupSuccessCta: "Start Exploring",
      onboardingNext: "Next",
      
      // ==================== BOOKING HUB ====================
      bookingHubTitle: "Booking Hub",
      bookingCategories: "Booking Categories",
      carRentals: "Car Rentals",
      doctorAppointments: "Doctor Appointments",
      hallReservations: "Hall Reservations",
      otherServices: "Other Services",
      bookCar: "Book a Car",
      bookDoctor: "Book a Doctor",
      bookHall: "Book a Hall",
      bookService: "Book a Service",
      selectDate: "Select Date",
      selectTime: "Select Time",
      selectLocation: "Select Location",
      addNotes: "Additional Notes",
      bookNow: "Book Now",
      confirmBooking: "Confirm Booking",
      bookingDetails: "Booking Details",
      bookingConfirmed: "Booking Confirmed!",
      
      // ==================== SHOP ====================
      shopTitle: "Shop",
      priceRange: "Price Range",
      minPrice: "Min Price",
      maxPrice: "Max Price",
      sortBy: "Sort by",
      newest: "Newest First",
      cheapest: "Lowest Price",
      expensive: "Highest Price",
      priceLowToHigh: "Price: Low to High",
      priceHighToLow: "Price: High to Low",
      applyFilters: "Apply Filters",
      clearFilters: "Clear Filters",
      noAdsFound: "No ads found",
      tryDifferentFilters: "Try adjusting your filters",

      // ==================== SHOP PAGE (namespaced) ====================
      shopPage: {
        searchPlaceholder: "Search products…",
        recentSearches: "Recent searches",
        categories: "Categories",
        changeCategory: "Change",
        filterTitle: "Shop Filters",
        apply: "Apply",
        clearAll: "Clear All",
        sortByLabel: "Sort By",
        sortNewest: "Newest",
        sortPriceLow: "Price: Low to High",
        sortPriceHigh: "Price: High to Low",
        sortPopular: "Most Popular",
        sortPriceLowShort: "Price Low",
        sortPriceHighShort: "Price High",
        sortPopularShort: "Popular",
        sortRelevant: "Relevant",
        sortSalaryLow: "Salary Low",
        sortSalaryHigh: "Salary High",
        sortAreaSize: "Area Size",
        sortYearNewest: "Year Newest",
        priceRangeLabel: "Price Range",
        min: "Min",
        max: "Max",
        locationLabel: "Location",
        cityPlaceholder: "City name",
        showDistance: "Show Distance",
        gettingLocation: "Getting location...",
        disableDistance: "Disable Distance",
        enableDistance: "Enable Distance",
        locationDetected: "Location detected",
        distanceOn: "Distance On",
        clear: "Clear",
        filteredResults: "Filtered Results",
        browseListings: "Browse Listings",
        listingsCount: "{{count}} listings",
        listingsShowing: "Showing {{shown}} of {{total}}",
        noProductsFound: "No products found",
        tryDifferentSearch: "Try different filters or search terms",
        showAllProducts: "Show all products",
        ladiesHubBadge: "Ladies Hub",
        loadMore: "Load More",
        recentlyViewed: "Recently Viewed",
        geoNotSupported: "Geolocation not supported on this device",
        locationSuccess: "Location detected successfully",
        locationDenied: "Location permission denied",
        locationUnavailable: "Unable to determine location",
        locationTimeout: "Location request timed out",
      },

      // ==================== RECENTLY VIEWED (shared Home + Shop) ====================
      recently: {
        recentlyViewed: "Recently Viewed",
        clear: "Clear",
        confirmClear: "Tap again to clear",
      },

      // ==================== LOCATION SELECTOR (iter322) ====================
      // Multi-country, mobile-first premium picker used on Home Near You
      // (Phase A) and Shop filters + Post Ad (Phase B). Flat-namespaced.
      locationSelector: {
        title: "Choose location",
        searchPlaceholder: "Search city, area, or country",
        useCurrentLocation: "Use my current location",
        locating: "Locating…",
        gpsDetected: "We detected:",
        confirmTip: "Tap Apply to confirm, or edit below.",
        permissionHint: "Wassla uses your location to show nearby ads and help sellers add an accurate listing location. You can also choose your location manually.",
        // iter337 — Public-location safety helper.
        publicOnlyHelper: "Add a public location only. Do not write private home details.",
        allCountries: "All",
        selectCountry: "Select country",
        // iter337 — Renamed labels for the new 5-level hierarchy.
        // Level 2 = State/Region (was "Region"); Level 3 = Locality/
        // County/District (was "City"); Level 4 = City/Town/Village
        // (was "Area"). The catalog rows are unchanged.
        selectRegion: "Select State / Region",
        selectCity: "Select Locality / County / District",
        selectArea: "Select City / Town / Village",
        cityTownTypePlaceholder: "Type your city / town / village",
        cityTownTypeHint: "Don't see your town? Type it here.",
        extraDetailsLabel: "Extra location details (optional)",
        extraDetailsPlaceholder: "e.g. neighborhood, market, mall, street, pickup point, landmark",
        // Crumb roots
        crumbCountry: "Country",
        crumbRegion: "State / Region",
        crumbLocality: "Locality / County / District",
        crumbCityTown: "City / Town / Village",
        completeRequired: "Please complete the public location so buyers can find nearby ads.",
        apply: "Apply location",
        clear: "Clear location",
        cancel: "Cancel",
        noMatch: "No matches",
        chosen: "Location:",
        notSet: "Not set",
        change: "Change",
      },

      // ==================== SELLER REVIEWS & RATINGS (iter317) ====================
      reviews: {
        noReviewsYet: "No reviews yet",
        countLabel_one: "{{count}} review",
        countLabel_other: "{{count}} reviews",
        countLabel: "{{count}} reviews",
        sheetTitle: "Seller reviews",
        positivePct: "positive",
        anonymousBuyer: "Buyer",
        report: "Report",
        rateSellerCta: "Rate seller",
        leaveReviewCta: "Leave a review",
        beTheFirstToReview: "Be the first to review this seller",
        modalTitle: "Rate this seller",
        starsLabel: "Your rating",
        commentLabel: "Comment (optional)",
        commentPlaceholder: "Share details about your experience with this seller (optional)…",
        positiveTagsLabel: "What went well",
        negativeTagsLabel: "Concerns",
        submit: "Submit review",
        submitting: "Submitting…",
        errorRating: "Please choose a star rating from 1 to 5.",
        errorAuth: "Please sign in to leave a review.",
        errorGate: "Contact this seller first before leaving a review.",
        errorGeneric: "Couldn't submit your review. Please try again.",
        gate: {
          selfReview: "You cannot review your own listing.",
          notAuthenticated: "Please sign in to leave a review.",
          needsInteraction: "Contact this seller first before leaving a review.",
        },
        tag: {
          // iter346 — Operator-approved wording. Backend keys are stable;
          // only the display labels change here.
          responsive_seller: "Good communication",
          accurate_description: "Item as described",
          fair_price: "Fair price",
          fast_response: "Fast response",
          safe_transaction: "Safe transaction",
          not_responsive: "Bad communication",
          wrong_description: "Not as described",
          suspicious_behavior: "Suspicious behavior",
        },
      },

      // ==================== POST AD PAGE (namespaced) ====================
      postAd: {
        createYourListing: "Create Your Listing",
        accurateDetails: "Accurate details help attract serious buyers and increase visibility.",
        stepOf: "STEP {{current}} OF {{total}}",
        stepDetails: "Details",
        stepPrice: "Price",
        stepPhotos: "Photos",
        stepReview: "Review",
        postingInLadiesHub: "Posting in Ladies Hub",
        startWithCategory: "Start with Category Selection",
        categoryGuidance: "Choosing the correct category improves discoverability and buyer trust.",
        next: "Next",
        back: "Back",
        preview: "Preview",
        exampleLabel: "Example:",
        contactInfoOptional: "Contact Info (Optional)",
        // iter314 — Contact section is REQUIRED before publishing, so
        // the new title drops the "(Optional)" and the helper text
        // reflects what publishing actually requires.
        contactInfoTitle: "Contact Information",
        contactInfoRequiredHelper: "Add a phone or WhatsApp number so buyers can contact you.",
        contactRequiredEmpty: "Please enter a phone or WhatsApp number so buyers can contact you.",
        contactRequiredInvalid: "Please enter a valid phone number including the country code.",
        contactInfoDesc: "Add contact methods so buyers can easily reach you",
        phoneNumber: "Phone Number",
        phonePlaceholder: "e.g., 0912345678",
        useSameForWhatsapp: "Use same number for WhatsApp",
        whatsappNumber: "WhatsApp Number",
        whatsappDiffPlaceholder: "Different WhatsApp number",
        messengerLinkOptional: "Facebook/Messenger link (optional)",
        messengerPlaceholder: "Username or page link",
        messengerExample: "e.g., username or https://facebook.com/yourpage",
        emailOptional: "Email (optional)",
        noImagesAdded: "No images added yet",
        images: "Images",
        maxImages: "Maximum 5 images",
        photosSelected: "{{count}} photos selected",
        choosePhotos: "Choose photos",
        maxPhotos: "Max 5 photos",
        phoneDetails: "Phone Details",
        carDetails: "Car Details",
        propertyDetails: "Property Details",
        beds: "bed",
        baths: "bath",
        listingQuality: "Listing Quality",
        clearTitle: "Clear title",
        goodDescription: "Good description",
        threePhotos: "3+ photos",
        locationCheck: "Location",
        priceCheck: "Price",
        publishing: "Publishing...",
        publish: "Publish",
        editBtn: "Edit",
        savingDraft: "Saving...",
        saveAsDraft: "Save as draft",
        saveDraftTitle: "Save as draft?",
        saveDraftDesc: "You can finish later from My Ads \u2192 Drafts.",
        saveDraftBtn: "Save draft",
        continueEditing: "Continue editing",
        leaveWithoutSaving: "Leave without saving",
        continueDraftTitle: "Continue your draft?",
        draftListing: "Draft Listing",
        continueDraftBtn: "Continue Draft",
        draftCountMsg: "You have {{count}} draft(s). Would you like to continue or view drafts?",
        viewDrafts: "View Drafts",
        startNewAd: "Start New Ad",
        draftStepOf: "Step {{current}} of {{total}}",
        allowLocation: "Allow Location",
        locationRationale: "We use your location to detect your city automatically. You can change this later.",
        notNow: "Not now",
        continueBtn: "Continue",
        change: "Change",
        useMyLocation: "Use my location",
        gettingLocationShort: "Getting location...",
        published: "Published",
        adLiveDesc: "Your ad is now live for everyone to see!",
        publishedToLadies: "Your ad has been posted in Ladies Hub",
        backToLadiesHub: "Back to Ladies Hub",
        loginFirst: "Please log in first",
        draftSaved: "Draft saved",
        draftSaveFailed: "Failed to save draft",
        locationNotAvailableBrowser: "Location not available in this browser",
        locationNotAvailable: "Location not available",
        locationPermDenied: "Permission denied. You can enable it in phone settings.",
        locationUnavailable: "Location unavailable. Please try again.",
        locationTimeoutMsg: "Timeout. Please try again.",
        locationErrorMsg: "Error getting location",
        coordsSaved: "Could not determine location name. Coordinates saved.",
        nearLandmark: "(near {{landmark}})",
        viewImage: "View image {{num}}",
        locationFound: "Location found!",
        qualityTitleShort: "Title is too short",
        qualityDescShort: "Description is too short",
        qualityNoImages: "Add at least 1 photo",
        qualityNoLocation: "Add your location",
        qualityNoPrice: "Add a price",
        qualityNoCategory: "Select a category",
        qualityImprove: "Please improve your listing before publishing",
        duplicateWarning: "You may already have a similar active listing",
        spamRejected: "Listing rejected \u2014 suspicious content detected",
        rateLimited: "You are posting too fast. Please wait a few minutes.",
        publishFailed: "Publishing failed",
        sessionExpired: "Session expired. Please log in again.",
        accountBanned: "Your account has been banned.",
        accessDenied: "Access denied. Please log in again.",
        dailyLimitReached: "You reached today's posting limit. Your limit resets after midnight.",
        imageUploadFailed: "Image upload failed: {{message}}",
        publishedToLadiesHub: "Published to Ladies Hub",
        descHintShoes: "Describe condition, size, color, and reason for selling",
        descHintBags: "Describe bag type, material, condition",
        descHintGold: "Describe karat, weight, condition",
        descHintPerfume: "Describe perfume type, size, new or used",
        descHintLadiesDefault: "Write detailed description, condition, and any important details",
        // Enhanced UX translations
        estimatedTime: "Takes ~30 seconds",
        almostDone: "Almost done!",
        draftSavedIndicator: "Draft saved",
        photoGuidanceTitle: "Photo Tips for Better Sales",
        photoGuidanceTip1: "Use clear, well-lit photos",
        photoGuidanceTip2: "Show front, back, and details",
        photoGuidanceTip3: "Add at least 3 photos",
        photoGuidanceTip4: "Avoid blurry images",
        coverImageHint: "First photo will be the cover",
        moveUp: "Move up",
        moveDown: "Move down",
        visibilityHint: "Listings with 3+ photos usually perform better",
        visibilityHintTitle: "Clear titles help buyers find your ad faster",
        // General category hints
        descHintVehicles: "Include year, mileage, engine type, and condition",
        descHintPhones: "Include brand, storage capacity, condition, and accessories",
        descHintFashion: "Include size, brand, material, and condition",
        descHintElectronics: "Include brand, model, condition, and warranty status",
        descHintFurniture: "Include dimensions, material, condition, and assembly info",
        descHintDefault: "Include condition, brand if applicable, and key details",
      },

      // ==================== ACCOUNT PAGE EXTRA KEYS ====================
      accountExtra: {
        favorites: "Favorites",
        myAdsTab: "My Ads",
        noFavoritesDesc: "No favorites yet",
        tapHeartToSave: "Tap the heart icon to save ads",
        sold: "Sold",
        available: "Available",
        removedFromFavorites: "Removed from favorites",
        removeFromFavorites: "Remove from favorites",
        growthTips: "Growth Tips",
        getStarted: "Get Started!",
        createFirstAdTip: "Create your first ad to reach buyers",
        boostYourAds: "Boost Your Ads",
        boostDesc: "Promote to reach more people",
        shareOnFacebook: "Share on Facebook",
        shareOnFacebookDesc: "Post in buy/sell groups",
        connected: "Connected",
        notConnected: "Not Connected",
        unlinkBtn: "Unlink",
        settingsTitle: "Settings",
        editProfileMenu: "Edit Profile",
        changePasswordMenu: "Change Password",
        updateEmailMenu: "Update Email",
        languageMenu: "Language",
        shareAnonymousData: "Share anonymous usage data",
        aboutWassla: "About Wassla",
        moderationDashboard: "Moderation Dashboard",
        helpAnalyticsMenu: "Help Analytics",
        versionLabel: "Version {{version}}",
        copyrightLabel: "\u00A9 {{year}} Wassla. All rights reserved.",
        unsavedChangesTitle: "Discard changes?",
        unsavedChangesDesc: "You have unsaved profile changes. Discard them?",
        keepEditing: "Keep editing",
        countryChangeTitle: "Update location?",
        countryChangeDesc: "Your saved State/Region and City may not match the new country. Keep them or clear them?",
        keepLocationBtn: "Keep them",
        clearLocationBtn: "Clear them",
        discardBtn: "Discard",
        logoutConfirmMsg: "Are you sure you want to log out?",
        deletingAccount: "Deleting...",
        currentPasswordLabel: "Current Password",
        newPasswordLabel: "New Password",
        confirmNewPasswordLabel: "Confirm New Password",
        enterCurrentPassword: "Enter current password",
        enterNewPassword: "Enter new password (min 8 characters)",
        reenterNewPassword: "Re-enter new password",
        enterNewEmail: "Enter new email address",
        currentEmailPrefix: "Current email: ",
        updateEmailNoteLabel: "Note:",
        updateEmailNote: "Your password is required to confirm this change. The new email becomes your sign-in immediately. A confirmation email will be sent once email verification is enabled.",
        clearCacheBtn: "Clear cache",
        boostAdLabel: "Boost Ad",
        noPublishedToBoost: "No published ads to boost yet",
        adMustBePublished: "Ad must be published first",
        shareListingsText: "Check my listings on Wassla",
        copiedMsg: "Copied!",
        copyFailedMsg: "Failed to copy",
        allFieldsRequired: "All fields are required",
        passwordMinLength: "New password must be at least 8 characters",
        passwordsMismatch: "Passwords do not match",
        passwordChangedOk: "Password changed successfully",
        passwordChangeFailed: "Failed to change password",
        invalidEmailMsg: "Invalid email address",
        emailSameAsCurrent: "New email is the same as current email",
        emailUpdateFailed: "Failed to update email",
        clearCacheFailed: "Failed to clear cache",
        adRecalledOk: "Ad recalled successfully",
        recallFailed: "Failed to recall ad",
        adDeletedOk: "Ad deleted",
        deleteFailed: "Failed to delete ad",
        connectionError: "Connection error",
        recallAdTitle: "Recall this ad?",
        recallAdMsg: "\"{{title}}\" will be removed from public listings immediately. You can edit it and publish again later.",
        yesRecall: "Yes, Recall",
        deleteAdTitle: "Delete this ad?",
        deleteAdMsg: "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
        linkFacebook: "Link Facebook Account",
        linkInstagram: "Link Instagram Account",
        facebookDesc: "Enter your Facebook profile URL or username",
        facebookPlaceholder: "facebook.com/yourname or @yourname",
        instagramDesc: "Enter your Instagram username or profile URL",
        instagramPlaceholder: "@username or instagram.com/username",
        linkAccountBtn: "Link Account",
        linkingMsg: "Linking...",
        unlinkAccountTitle: "Unlink account?",
        unlinkDesc: "You'll stop sharing and syncing with this account. You can link it again anytime.",
        unlinkingMsg: "Unlinking...",
        unlinkConfirmBtn: "Unlink",
        fieldRequired: "This field is required",
        invalidFacebook: "Enter a valid Facebook profile URL or username",
        invalidInstagram: "Enter a valid Instagram username or profile URL",
        invalidFacebookShare: "Share and post links are not supported — paste your profile link (facebook.com/yourname)",
        invalidInstagramShare: "Post and reel links are not supported — enter your username or profile link",
        socialNoSpaces: "Must not contain spaces or the | symbol",
        failedToLink: "Failed to link account",
        failedToUnlink: "Failed to disconnect",
        lowBandwidthEnabled: "Low Bandwidth Mode enabled - Images and animations reduced",
        lowBandwidthDisabled: "Low Bandwidth Mode disabled",
        updateSettingFailed: "Failed to update setting",
        analyticsDisabled: "Anonymous analytics disabled",
        analyticsEnabled: "Anonymous analytics enabled",
        saveError: "Save error, please try again",
        changingMsg: "Changing...",
        cancelBtn: "Cancel",
        statusActive: "Active",
        statusDraft: "Draft",
        statusPending: "Pending",
        statusUnderReview: "Under Review",
        statusLimited: "Limited",
        statusHidden: "Hidden",
        statusRejected: "Rejected",
        statusExpired: "Expired",
        statusSold: "Sold",
        statusRemoved: "Removed",
        whatsappHint: "Used for WhatsApp contact (leave blank to use phone)",
        messengerHint: "Your Facebook Messenger profile link (m.me/username)",
        regionHint: "Enter state or region name",
        regionPlaceholder: "e.g., Khartoum, California",
        cityOptional: "Optional",
      },

      // ==================== ERRORS ====================
      errNetwork: "Network error. Please try again.",
      errNetworkOneLine: "Network error. Try again.",
      errNoInternet: "No internet connection. Please check your network.",
      errServerError: "Server error. Please try again later.",
      errAuthGeneric: "Authentication failed. Please try again.",
      errInvalidCredentials: "Wrong email or password. Please try again.",
      errEmailExists: "Email already exists",
      errPasswordMismatch: "Passwords do not match",
      errRequiredField: "This field is required",
      errInvalidEmail: "Invalid email format",
      errPasswordTooShort: "Password must be at least 6 characters",
      errUploadFailed: "Upload failed. Please try again.",
      errAccountDeleted: "This account has been permanently deleted and cannot be recovered.",
      errInvalidOtp: "Invalid or expired recovery code",
      errEmailRequired: "Email is required",
      errGeneric: "An error occurred. Please try again.",
      authEmailRequired: "Please enter your email",
      authEmailInvalid: "Please enter a valid email",
      authPasswordRequired: "Please enter your password",
      authNameRequired: "Please enter your name",
      authLoginError: "Unable to sign in. Check your email and password.",
      authCooldown: "Login temporarily paused due to too many attempts. Please try again shortly.",
      signingIn: "Signing in...",
      forgotPasswordInfo: "Password reset is coming soon. Contact support for help.",
      
      // ==================== ACCOUNT RECOVERY ====================
      accountRecoveryTitle: "Restore Your Account",
      accountRecoverySubtitle: "Your account is scheduled for deletion. Enter your email to receive a recovery code and restore your account.",
      enterOtpSubtitle: "Enter the 6-digit code sent to your email",
      sendRecoveryCode: "Send Recovery Code",
      recoveryCode: "Recovery Code",
      restoreAccount: "Restore Account",
      recoveryOtpSent: "Recovery code sent to your email",
      accountRestored: "Account restored successfully!",
      didntReceiveCode: "Didn't receive the code?",
      resendIn: "Resend in",
      resendCode: "Resend Code",
      changeEmail: "Change email",
      backToLogin: "Back to Login",
      
      // Account Banned
      accountBannedTitle: "Account Banned",
      accountBannedSubtitle: "Your account has been banned due to policy violations.",
      banReason: "Reason",
      submitAppeal: "Submit an Appeal",
      submit: "Submit",
      cancel: "Cancel",
      goToHome: "Go to Home",
      
      // Account Suspended
      accountSuspendedTitle: "Account Suspended",
      accountSuspendedSubtitle: "Your account has been temporarily suspended.",
      suspensionReason: "Reason",
      suspensionEnds: "Suspension ends",
      
      // ==================== LADIES HUB - MANUAL APPROVAL ====================
      ladiesHub: {
        title: "Ladies Hub",
        goldApprovalNotice: "Gold items require manual admin approval before publishing",
        brandedCosmeticsNotice: "Branded cosmetics require verification before publishing",
        pendingApproval: "Pending Approval",
        pendingApprovalDesc: "Your ad is being reviewed by our team. This usually takes 24-48 hours.",
        approvalRequired: "Approval Required",
        brandType: "Brand Type",
        brandOriginal: "Original / Branded",
        brandCommercial: "Commercial",
        mostPopular: "Most Popular in Ladies",
        verifiedBoutique: "Verified Boutique"
      },
      
      // ==================== AI ASSISTANT ====================
      aiAssistant: "AI Assistant",
      aiWelcome: "Hi! How can I help you today?",
      aiPlaceholder: "Ask me anything...",
      aiSend: "Send",
      close: "Close",
      
      // AI Assistant (nested for modal)
      assistant: {
        title: "AI Assistant",
        hi: "Hi 👋",
        help: "How can I help you today?",
        prompt: "What would you like to do?",
        typeMessage: "Type a message...",
        send: "Send",
        askAssistant: "Ask the AI Assistant",
        thinking: "Thinking..."
      },
      
      // ==================== STUDENT CENTRAL ====================
      studentHub: {
        title: "Student Central",
        tabs: {
          books: "Books",
          opportunities: "Opportunities"
        },
        cta: {
          postBook: "Post a Book",
          postOpportunity: "Post an Opportunity",
          completeProfile: "Complete your student profile"
        },
        search: {
          booksPlaceholder: "Search by title or author…",
          oppsPlaceholder: "Search by role or organization…"
        },
        empty: {
          books: "No books found.",
          opps: "No opportunities found.",
          recommendations: "Complete your profile to see recommendations."
        },
        recommended: "Recommended for You",
        matchScore: "Match",
        viewAll: "View All",
        filters: "Filters",
        clearFilters: "Clear Filters",
        applyFilters: "Apply",
        showFilters: "Show Filters",
        hideFilters: "Hide Filters"
      },
      books: {
        mode: { 
          sell: "Buy", 
          rent: "Rent", 
          sell_or_rent: "Buy or Rent",
          all: "All"
        },
        condition: { 
          new: "New", 
          used_good: "Used - Good", 
          used_ok: "Used - OK",
          all: "Any Condition"
        },
        rentUnit: { 
          day: "per day", 
          week: "per week", 
          month: "per month" 
        },
        fields: {
          title: "Book Title",
          author: "Author",
          subject: "Subject",
          condition: "Condition",
          price: "Price",
          currency: "Currency",
          location: "Location",
          university: "University",
          description: "Description",
          images: "Images",
          contactMethod: "Contact Method",
          rentUnit: "Rent Period",
          rentPrice: "Rent Price"
        },
        contact: {
          chat: "Chat",
          phone: "Phone",
          both: "Chat & Phone"
        },
        createTitle: "Post a Book",
        editTitle: "Edit Book",
        detailsTitle: "Book Details",
        seller: "Seller",
        postedOn: "Posted on",
        contactSeller: "Contact Seller",
        saveBook: "Save Book",
        unsaveBook: "Remove from Saved",
        report: "Report Listing"
      },
      opps: {
        type: { 
          job: "Job", 
          volunteer: "Volunteer", 
          internship: "Internship",
          all: "All Types"
        },
        orgType: { 
          ngo: "NGO", 
          civil_society: "Civil Society", 
          company: "Company",
          all: "All Organizations"
        },
        locationType: { 
          onsite: "On-site", 
          remote: "Remote", 
          hybrid: "Hybrid",
          all: "Any Location"
        },
        paid: {
          yes: "Paid",
          no: "Unpaid",
          all: "Paid & Unpaid"
        },
        fields: {
          title: "Role Title",
          orgName: "Organization",
          type: "Type",
          orgType: "Organization Type",
          location: "Location",
          locationType: "Work Mode",
          educationLevel: "Education Level",
          majors: "Majors",
          skills: "Skills",
          interests: "Interests",
          paid: "Paid",
          stipend: "Stipend/Salary",
          deadline: "Deadline",
          apply: "How to Apply",
          applyLink: "Application Link",
          duration: "Duration",
          description: "Description",
          requirements: "Requirements"
        },
        actions: { 
          apply: "Apply", 
          save: "Save", 
          unsave: "Unsave",
          chat: "Chat",
          report: "Report"
        },
        createTitle: "Post an Opportunity",
        editTitle: "Edit Opportunity",
        detailsTitle: "Opportunity Details",
        poster: "Posted by",
        postedOn: "Posted on",
        deadlineLabel: "Application Deadline",
        applyNow: "Apply Now",
        applyExternal: "Apply on External Site",
        expired: "Expired",
        noDeadline: "No deadline"
      },
      profile: {
        studentTitle: "Student Profile",
        fields: {
          university: "University",
          major: "Major",
          educationLevel: "Education Level",
          skills: "Skills",
          interests: "Interests",
          preferredTypes: "Preferred Opportunities",
          location: "Location"
        },
        save: "Save Profile",
        saving: "Saving...",
        saved: "Profile Saved!",
        educationLevels: {
          high_school: "High School",
          bachelor: "Bachelor's",
          master: "Master's",
          phd: "PhD"
        },
        skillsHint: "Add your skills (comma separated)",
        interestsHint: "Add your interests (comma separated)"
      },
      cvBuilder: {
        title: "CV Builder",
        subtitle: "Create your free CV in minutes",
        selectTemplate: "Choose a Template",
        selectType: "Choose Resume Type",
        types: {
          professional: "Professional Resume",
          normal: "Normal Resume"
        },
        templates: {
          professional: "Professional",
          simple: "Simple",
          academic: "Academic"
        },
        sections: {
          personal: "Personal Info & Contacts",
          summary: "Summary",
          employment: "Employment History",
          experience: "Work Experience",
          objective: "Career Objective",
          education: "Educational Background",
          skills: "Skills & Competences",
          languages: "Languages",
          certifications: "Certifications",
          projects: "Projects",
          volunteering: "Volunteering",
          references: "References"
        },
        fields: {
          fullName: "Full Name",
          email: "Email",
          phone: "Phone",
          state: "City / State",
          linkedin: "LinkedIn URL",
          summary: "Brief professional summary...",
          objective: "Your career objective or goal...",
          jobTitle: "Job Title",
          company: "Company",
          startDate: "Start Date",
          endDate: "End Date",
          present: "Present",
          current: "Currently working here",
          bullets: "Responsibilities / Achievements",
          addBullet: "Add point",
          notes: "Notes / Description",
          notesPlaceholder: "Brief description of your role and responsibilities...",
          degree: "Degree",
          major: "Field of Study",
          institution: "Institution",
          skill: "Skill",
          language: "Language",
          level: "Proficiency Level",
          certName: "Certification Name",
          issuer: "Issuer",
          certStart: "Start Date",
          certEnd: "End Date",
          year: "Year",
          projectName: "Project Name",
          description: "Description",
          link: "Link",
          role: "Role",
          organization: "Organization",
          referencesNote: "Available upon request",
          refFullName: "Full Name",
          refInstitution: "Institution",
          refPost: "Position / Title",
          refAddress: "Address",
          refEmail: "Email",
          refPhone: "Phone Number"
        },
        degrees: {
          diploma: "Diploma",
          bachelor: "Bachelor",
          master: "Master",
          doctorate: "Doctorate (PhD)",
          professor: "Professor",
          other: "Other"
        },
        levels: {
          native: "Native",
          fluent: "Fluent",
          advanced: "Advanced",
          intermediate: "Intermediate",
          basic: "Basic"
        },
        actions: {
          addExperience: "Add Experience",
          addEmployment: "Add Employment",
          addEducation: "Add Education",
          addSkill: "Add Skill",
          addLanguage: "Add Language",
          addCertification: "Add Certification",
          addReference: "Add Reference",
          addProject: "Add Project",
          addVolunteering: "Add Volunteering",
          remove: "Remove",
          save: "Save CV",
          preview: "Preview",
          exportPDF: "Export PDF",
          downloadCV: "Download CV",
          saving: "Saving...",
          exporting: "Generating PDF..."
        },
        autoSaved: "Draft auto-saved",
        autoSaveError: "Could not save draft",
        preview: {
          title: "CV Preview",
          unnamed: "Unnamed CV",
          printPdf: "Print / Save PDF"
        },
        messages: {
          saved: "CV saved successfully!",
          exported: "PDF generated! Downloading...",
          pdfSaved: "PDF saved successfully.",
          pdfError: "PDF could not be created. Please try again.",
          error: "Something went wrong. Please try again.",
          fillRequired: "Please fill in your name to continue.",
          insufficientCoins: "Need {{cost}} coins, you have {{balance}}",
          bankakRequested: "Export request submitted! We'll notify you when approved.",
          networkError: "Network error. Please check your connection and try again."
        },
        validation: {
          fullNameRequired: "Full Name is required",
          invalidEmail: "Please enter a valid email address",
          jobTitleRequired: "Employment #{{num}}: Job Title is required",
          companyRequired: "Employment #{{num}}: Company is required",
          startDateRequired: "Employment #{{num}}: Start Date is required",
          institutionRequired: "Education #{{num}}: Institution is required",
          degreeRequired: "Education #{{num}}: Degree is required",
          refNameRequired: "Reference #{{num}}: Full Name is required",
          moreErrors: "And {{count}} more issue(s)",
          serverError: "Server validation failed",
          exportRequiresComplete: "Please complete all required fields before export"
        },
        payment: {
          title: "Export Your CV",
          subtitle: "Choose a payment method to download your CV without watermark",
          viewPreview: "View Preview (with watermark)",
          previewNote: "Preview includes watermark. Pay to remove it.",
          payWithCoins: "Pay with Wassla Coins",
          payWithBankak: "Pay via Bank Transfer (Bankak)",
          yourBalance: "Your balance",
          payAndDownload: "Pay & Download",
          earnCoins: "Earn More Coins",
          bankName: "Bank",
          accountName: "Account Name",
          bankakNote: "Transfer the amount and we'll approve your request within 24 hours.",
          requestExport: "Submit Payment Request"
        },
        unlock: {
          title: "Your CV is ready!",
          message: "Unlock your professional CV to download.",
          freeTitle: "Free",
          freeSub: "Best for getting started",
          freeTemplate: "1 Basic Template",
          freeWatermark: "PDF export with watermark",
          freeBuilder: "Basic CV builder",
          freeBtn: "Start Free",
          proTitle: "Pro",
          proSub: "Best for serious applications",
          proPrice: "10 coins",
          proTemplates: "5+ Premium Templates",
          proNoWatermark: "No watermark",
          proCover: "Cover Letter Builder",
          proAts: "ATS Tips",
          proBtn: "Unlock Now",
          yourBalance: "Your balance",
          earnCoins: "Earn More Coins",
          watermarkText: "Made with Wassla",
          comingSoon: "This feature is coming soon",
          coinInfoTitle: "Your Coins",
          coinInfoDesc: "Coins unlock Pro features: premium templates, clean exports, and ATS tips.",
          coinInfoCta: "Upgrade to Pro"
        },
        empty: {
          title: "Start Building Your CV",
          description: "Create a CV that showcases your skills and experience."
        },
        helperText: "Complete your details to generate your free CV.",
        subtitle: "Create your free CV in minutes"
      },
      subjects: {
        medicine: "Medicine",
        pharmacy: "Pharmacy",
        dentistry: "Dentistry",
        nursing: "Nursing",
        engineering: "Engineering",
        civil_eng: "Civil Engineering",
        electrical_eng: "Electrical Engineering",
        mechanical_eng: "Mechanical Engineering",
        computer_science: "Computer Science",
        it: "Information Technology",
        data: "Data Science",
        ai: "Artificial Intelligence",
        business: "Business Administration",
        accounting: "Accounting",
        economics: "Economics",
        marketing: "Marketing",
        law: "Law",
        education: "Education",
        arts: "Arts & Design",
        languages: "Languages & Translation",
        agriculture: "Agriculture",
        environment: "Environmental Science",
        math: "Mathematics",
        physics: "Physics",
        chemistry: "Chemistry",
        biology: "Biology",
        other: "Other"
      },
      universities: {
        uofk: "University of Khartoum",
        sust: "Sudan University of Science and Technology",
        alzaiem: "Al-Zaiem Al-Azhari University",
        oiu: "Omdurman Islamic University",
        ahfad: "Ahfad University for Women",
        neelain: "University of Al-Neelain",
        karary: "Karary University",
        uofg: "University of Gezira",
        rsu: "Red Sea University",
        dongola: "University of Dongola",
        other: "Other"
      },
      report: {
        // Main CTA button
        cta: "Report this ad",
        cta_sub: "Sold, incorrect details, or policy violation",
        // Sheet content
        title: "Report this listing",
        subtitle: "Help us keep Wassla safe and accurate.",
        section_availability: "Availability issue",
        section_policy: "Safety or policy issue",
        // Availability reasons
        reason_sold: "Already sold",
        reason_not_responding: "Seller not responding",
        reason_wrong_info: "Incorrect information",
        // Policy reasons
        reason_scam: "Scam or fraud",
        reason_prohibited: "Prohibited item",
        reason_spam: "Duplicate or spam",
        reason_offensive: "Offensive content",
        reason_other: "Other",
        // Form
        details_label: "Additional details (optional)",
        details_ph: "Provide more information to help us review this listing.",
        // Evidence upload
        evidence_title: "Evidence photo (optional)",
        evidence_sub: "A screenshot or photo helps us review faster.",
        add_photo: "Add photo",
        evidence_limit: "Up to 2 photos • JPG/PNG",
        evidence_max_reached: "You can attach up to 2 photos.",
        remove_photo: "Remove photo",
        // Acknowledgment
        ack_text: "I confirm this report is truthful. False reports may lead to account suspension.",
        // Actions
        cancel: "Cancel",
        continue: "Continue",
        back: "Back",
        send: "Send report",
        sending: "Sending...",
        uploading: "Uploading...",
        submit: "Submit report",
        done: "Done",
        // Confirmation
        confirm_title: "Confirm your report",
        confirm_reason: "Reason",
        confirm_details: "Details",
        confirm_evidence: "Evidence",
        false_warning: "Submitting false reports may lead to suspension of your Wassla account.",
        // Success
        success_title: "Report submitted",
        // Feedback
        thanks: "Thank you. Our team will review this listing.",
        reported: "Reported",
        already_reported: "You already reported this listing.",
        // Legacy keys for backward compatibility
        reason: "Reason",
        details: "Additional Details",
        reasons: {
          spam: "Spam or misleading",
          inappropriate: "Inappropriate content",
          scam: "Suspected scam",
          duplicate: "Duplicate listing",
          other: "Other"
        },
        submitted: "Report Submitted",
        submitting: "Submitting..."
      },
      // ==================== PROFILE TYPE PICKER ====================
      profilePicker: {
        title: "What describes you best?",
        subtitle: "Pick the option that best describes you.\nYou can always change it later.",
        heroTitle: "Welcome to Wassla",
        heroSubtitle: "Buy, sell, offer services, and discover a trusted marketplace — all in one place.",
        supportingLine: "Choose how you want to use Wassla — you can always change it later.",
        trustTitle: "A trusted marketplace experience",
        trustSubline: "Simple • Clear • Direct",
        slogan: "One link, many possibilities",
        selectLabel: "Choose profile type",
        confirm: "Confirm",
        later: "Later",
        types: {
          seller: {
            label: "Sell Something",
            desc: "Post ads, boost visibility, and reach real buyers."
          },
          buyer: {
            label: "Browse & Shop",
            desc: "Discover products, message sellers, and find what you need."
          },
          student: {
            label: "Student",
            desc: "Access books and CV builder tools in one place."
          },
          service: {
            label: "Offer a Service",
            desc: "List your services and get discovered by clients."
          },
          professional: {
            label: "Professional",
            desc: "Build your presence and connect with more customers."
          },
          general: {
            label: "General User",
            desc: "Browse marketplace & all categories."
          }
        }
      },
      // ==================== ROLES ====================
      roles: {
        selectTitle: "What best describes you?",
        selectSubtitle: "Pick the option that best describes you.\nYou can always change it later.",
        seller: "Sell Something",
        sellerDesc: "Post ads, boost visibility, and reach thousands of buyers",
        buyer: "Browse & Shop",
        buyerDesc: "Discover deals, message sellers, and find what you need",
        student: "Student",
        studentDesc: "Access books, summaries, and CV Builder tools.",
        service: "Offer a Service",
        serviceDesc: "List your professional services and get discovered by clients",
        professional: "Professional",
        professionalDesc: "Post ads, manage listings, and connect with buyers",
        general: "General User",
        generalDesc: "Browse, post ads & explore marketplace",
        // Backward compat for old DB values
        trader: "Sell Something",
        traderDesc: "Post ads, boost visibility, and reach thousands of buyers",
        service_provider: "Offer a Service",
        service_providerDesc: "List your professional services and get discovered by clients",
        individual: "General User",
        individualDesc: "Browse, post ads & explore marketplace",
        skipForNow: "Skip for Now",
        changeNote: "You can change your account type anytime from Profile Settings",
        accountType: "Account Type",
        changeRole: "Change Account Type",
        accountTypeUpdated: "Account type updated successfully"
      },
      // ==================== LEGAL PAGES ====================
      legal: {
        privacyTitle: "Privacy Policy",
        termsTitle: "Terms of Use",
        contactTitle: "Contact Us",
        lastUpdated: "Last Updated",
        privacy: {
          section1Title: "Your Privacy Matters",
          section1Content: "At Wassla, we respect your privacy and are committed to protecting your personal information. We collect only the data necessary to provide you with the best marketplace experience.",
          section2Title: "Data We Collect",
          section2Content: "We collect information you provide directly, such as your name, email, and listings. We also collect usage data to improve our services and provide personalized recommendations.",
          section3Title: "How We Use Your Data",
          section3Content: "Your data is used solely to improve your experience on Wassla. We do not sell your personal information to third parties. Data is used for account management, customer support, and service improvements.",
          section4Title: "Your Rights",
          section4Content: "You have the right to access, correct, or delete your personal data at any time. You can request account deletion from your account settings. Deletion is permanent; certain limited records may be retained only where reasonably necessary — see our Privacy Policy."
        },
        terms: {
          section1Title: "Acceptance of Terms",
          section1Content: "By using Wassla, you agree to these Terms of Use. If you do not agree with any part of these terms, please do not use our services.",
          section2Title: "User Responsibilities",
          section2Content: "Users are responsible for the content they post. All listings must be accurate and legal. Prohibited content includes illegal items, fraudulent listings, and content that violates local laws.",
          section3Title: "Prohibited Activities",
          section3Content: "Users may not use Wassla for illegal purposes, government-related transactions without authorization, or any activities that could harm other users. We reserve the right to remove content and suspend accounts that violate these terms.",
          section4Title: "Service Changes",
          section4Content: "Wassla reserves the right to modify or discontinue services at any time. Continued use of the platform after changes constitutes acceptance of the new terms."
        },
        contact: {
          subtitle: "We'd love to hear from you!",
          subject: "Subject",
          message: "Message",
          send: "Send Message",
          thankYou: "Thank You!",
          successMessage: "Your message has been sent. We'll reply to you by email.",
          backToAccount: "Back to Account"
        }
      },
      
      // ==================== ADMIN MODERATION ====================
      admin: {
        title: "Admin Dashboard",
        refresh: "Refresh",
        loading: "Loading...",
        accessDenied: "Access Denied",
        notAuthorized: "You are not authorized to access this page",
        exitAdmin: "Exit",
        back: "Back",
        
        // Stats
        totalUsers: "Total Users",
        pendingReview: "Pending Review",
        pendingReports: "Pending Reports",
        lowTrustUsers: "Low Trust Users",
        bannedUsers: "Banned Users",
        
        // Tabs
        overview: "Overview",
        ads: "Ads",
        opportunities: "Opportunities",
        books: "Books",
        payments: "Payments",
        reviewQueue: "Review Queue",
        reports: "Reports",
        users: "Users",
        blocklist: "Blocklist",
        
        // Overview
        dashboardOverview: "Dashboard Overview",
        userStats: "User Statistics",
        listingStats: "Listing Statistics",
        opportunitiesStats: "Opportunities Statistics",
        booksStats: "Books Statistics",
        reportsStats: "Reports Statistics",
        paymentsStats: "Payment Statistics",
        paymentStats: "Payment Statistics",
        new7d: "New (7 days)",
        new30d: "New (30 days)",
        adsApproved: "Ads Approved",
        adsPending: "Ads Pending",
        adsRejected: "Ads Rejected",
        adsHidden: "Ads Hidden",
        approved: "Approved",
        pending: "Pending",
        rejected: "Rejected",
        totalReports: "Total Reports",
        reviewAds: "Review Ads",
        reviewOpportunities: "Review Opportunities",
        reviewPayments: "Review Payments",
        reviewReports: "Review Reports",
        
        // Review Queue
        pendingAds: "Pending Ads",
        pendingOpportunities: "Pending Opportunities",
        pendingBooks: "Pending Books",
        pendingPayments: "Pending Payments",
        approvedPayments: "Approved Payments",
        rejectedPayments: "Rejected Payments",
        noPaymentsPending: "No pending payments",
        noPendingAds: "No pending ads",
        allClear: "All clear! No items need review.",
        owner: "Owner",
        adOwner: "Owner",
        riskScore: "Risk Score",
        reportsCount: "Reports",
        createdAt: "Created",
        amount: "Amount",
        method: "Method",
        viewReceipt: "View Receipt",
        
        // Actions
        approve: "Approve",
        limit: "Limit",
        reject: "Reject",
        requestEdit: "Request Edit",
        hide: "Hide",
        unhide: "Unhide",
        viewDetails: "View Details",
        approveSuccess: "Item approved successfully",
        approveFailed: "Failed to approve item",
        rejectSuccess: "Item rejected successfully",
        rejectFailed: "Failed to reject item",
        requestEditSuccess: "Edit request sent to user",
        requestEditFailed: "Failed to send edit request",
        hideSuccess: "Item hidden successfully",
        unhideSuccess: "Item unhidden successfully",
        hideFailed: "Failed to hide/unhide item",
        
        // Reject Modal
        rejectAd: "Reject Ad",
        rejectPayment: "Reject Payment",
        rejectReason: "Rejection Reason",
        rejectReasonRequired: "Please provide a reason for rejection",
        rejectReasonPlaceholder: "Explain why this ad is being rejected...",
        paymentRejectReasonPlaceholder: "Please provide a reason (e.g., Invalid receipt, Incorrect amount)",
        confirmReject: "Confirm Reject",
        
        // Payment Actions
        paymentApproved: "Payment verified successfully!",
        paymentRejected: "Payment rejected",
        paymentApproveFailed: "Failed to approve payment",
        paymentRejectFailed: "Failed to reject payment",
        
        // Ad Details Drawer
        adDetails: "Ad Details",
        images: "Images",
        description: "Description",
        moderationHistory: "Moderation History",
        relatedReports: "Related Reports",
        noHistory: "No moderation history",
        noReportsForAd: "No reports for this ad",
        
        // Reports
        noReports: "No reports",
        allReportsResolved: "All reports have been resolved.",
        reporter: "Reporter",
        reportReason: "Reason",
        reportNote: "Note",
        reportStatus: "Status",
        markValid: "Valid",
        markInvalid: "Invalid",
        dismiss: "Dismiss",
        resolved: "Resolved",
        takeAction: "Take Action",
        
        // Users
        searchUsers: "Search users by email or name...",
        trustScore: "Trust Score",
        joinDate: "Join Date",
        sortBy: "Sort by",
        ascending: "Ascending",
        descending: "Descending",
        adsCount: "Ads",
        rejectedCount: "Rejected",
        userReports: "Reports",
        ban: "Ban",
        unban: "Unban",
        resetTrust: "Reset Trust",
        viewUserAds: "View Ads",
        adminBadge: "ADMIN",
        bannedBadge: "BANNED",
        
        // Banned Users
        bannedUsersList: "Banned Users List",
        noBannedUsers: "No banned users",
        banReason: "Ban Reason",
        bannedOn: "Banned On",
        
        // Blocklist
        blockedWords: "Blocked Words",
        hardBlock: "Hard Block (Immediate)",
        softBlock: "Soft Block (Flags Content)",
        addWord: "Add",
        newWord: "New word...",
        softLabel: "Soft (Flag)",
        hardLabel: "Hard (Block)",
        
        // Actions
        actionSuccess: "Action completed successfully",
        actionFailed: "Action failed",
        
        // Status
        status: {
          published: "Published",
          limited: "Limited",
          under_review: "Under Review",
          rejected: "Rejected",
          draft: "Draft"
        },
        
        // Trust levels
        trust: {
          high: "High Trust",
          medium: "Medium Trust",
          low: "Low Trust",
          critical: "Critical"
        }
      },
      
      // ==================== AVAILABILITY STATUS ====================
      availability: {
        available: "Available",
        reserved: "Reserved",
        sold: "Sold",
        expired: "Expired",
        unavailable: "Unavailable",
        hidden: "Hidden",
        // Status hints
        stale_hint: "May be unavailable",
        updated_ago: "Updated {{n}} days ago",
        reserved_until: "Reserved until {{date}}",
        not_available_banner: "This listing is not available.",
        // Action labels
        mark_sold: "Mark as Sold",
        mark_reserved: "Mark as Reserved",
        mark_available: "Mark as Available",
        renew: "Renew",
        hide: "Hide",
        // Durations
        duration_24h: "24 hours",
        duration_48h: "48 hours",
        duration_7d: "7 days",
        // Confirmations
        confirm_mark_sold: "Mark this item as sold?",
        confirm_hide: "Hide this listing?",
        renewed_success: "Ad renewed successfully",
        marked_sold: "Marked as sold",
        marked_reserved: "Marked as reserved",
        marked_available: "Marked as available"
      },

      // ==================== AUTO-MIGRATED i18n KEYS ====================
      "authReferralBonus": "Invited by a friend! You'll get 5 coins on signup",
      "messagesStartChat": "Start a chat from any ad's Contact button",
      // --- PublishSuccessScreen ---
      "ps.title": "Published successfully!",
      "ps.subtitle": "Your ad is now visible to everyone.",
      "ps.liveMsg1": "Your ad is now live in the marketplace.",
      "ps.liveMsg2": "Buyers can contact you immediately.",
      "ps.statsViews": "Views",
      "ps.statsInterested": "Interested",
      "ps.statsMessages": "Messages",
      "ps.tip": "Tip: Add WhatsApp & location to get faster buyers.",
      "ps.viewAd": "View Ad",
      "ps.backLadies": "Back to Ladies Hub",
      "ps.backHome": "Back to Home",
      "ps.postAnother": "Post new ad",
      "ps.postAnotherHint": "Every new ad increases your chances of selling.",
      "ps.shareTitle": "Share your ad to find buyers faster",
      "ps.waShare": "Share via WhatsApp",
      "ps.copyLink": "Copy link",
      "ps.copied": "Link copied!",
      "ps.safety": "Ads are automatically checked to protect users from fraud.",
      "ps.pendingTitle": "Pending review",
      "ps.pendingBody": "Your ad is published but may be reviewed to protect users.",
      "ps.rewardStreak": "+1 listing • Streak: {{streak}} days",
      "ps.editAd": "Edit your ad",
      "ps.sellFaster": "Sell faster:",
      "ps.tipWhatsApp": "Add WhatsApp contact",
      "ps.tipPhotos": "Upload at least 3 photos",
      "ps.tipDescription": "Write a detailed description",
      "ps.keepPosting": "Keep posting to grow your shop.",
      "ps.tipPrice": "Set a competitive price",
      // --- acco ---
      "acco.completeYourProfileNameAddress": "Complete your profile (name, address, photo) to earn +2 coins!",
      "acco.connectionErrorCheckYourInternet": "Connection error - check your internet",
      "acco.couldNotSaveDataEndpoint": "Could not save data (endpoint not found). Please refresh the app.",
      "acco.currentEmail": "Current email: ",
      "acco.failedToUpdateProfileType": "Failed to update profile type",
      "acco.sessionExpiredPleaseLogIn": "Session expired. Please log in again.",
      "acco.someFieldsAreInvalidPlease": "Some fields are invalid. Please review the data.",
      "acco.text": "العربية",
      "acco.youDoNotHavePermission": "You do not have permission for this action.",
      "acco.youEarned2CoinsFor": "You earned +2 coins for completing your profile! 🎉",
      "acco.yourProfileTypeHasBeen": "Your profile type has been updated!",
      // --- accobann ---
      "accobann.anErrorOccurred": "An error occurred",
      "accobann.explainWhyYouBelieveThis": "Explain why you believe this ban is unfair. Your appeal will be reviewed within 48-72 hours.",
      "accobann.fraudulentActivity": "Fraudulent activity",
      "accobann.lowTrustScore": "Low trust score",
      "accobann.multipleReports": "Multiple reports",
      "accobann.pleaseWriteYourAppealMessage": "Please write your appeal message",
      "accobann.policyViolation": "Policy violation",
      "accobann.spamActivity": "Spam activity",
      "accobann.tooManyRejectedAds": "Too many rejected ads",
      "accobann.writeYourMessageHere": "Write your message here...",
      "accobann.yourAppealHasBeenSubmitted": "Your appeal has been submitted",
      "accobann.yourAppealHasBeenSubmitted2": "Your appeal has been submitted successfully. It will be reviewed within 48-72 hours.",
      "accobann.yourPreviousAppealWasRejected": "Your previous appeal was rejected. You cannot submit another appeal.",
      // --- accoreco ---
      "accoreco.enus": "en-US",
      // --- accoresp ---
      "accoresp.buyer": "Buyer",
      "accoresp.failedToLoadResponses": "Failed to load responses",
      "accoresp.inbox": "Inbox",
      "accoresp.noResponsesYet": "No responses yet",
      "accoresp.pleaseLogIn": "Please log in",
      "accoresp.responses": "Responses",
      "accoresp.whenBuyersContactYouMessages": "When buyers contact you, messages will appear here",
      // --- accosusp ---
      "accosusp.afterTheSuspensionEndsYou": "After the suspension ends, you can log in normally",
      "accosusp.reviewOurPoliciesToAvoid": "Review our policies to avoid future violations",
      "accosusp.suspensionEnded": "Suspension ended",
      "accosusp.waitUntilTheSuspensionPeriod": "Wait until the suspension period ends",
      "accosusp.whatCanYouDo": "What can you do?",
      // --- accoview ---
      "accoview.byAd": "By Ad",
      "accoview.failedToLoadViews": "Failed to load views",
      "accoview.noViewsDataYet": "No views data yet",
      "accoview.total": "Total",
      "accoview.views": "Views",
      "accoview.viewsWillAppearHereWhen": "Views will appear here when people view your ads",
      // --- adshar ---
      "adshar.copyLink": "Copy Link",
      "adshar.copyText": "Copy Text",
      "adshar.price": "Price:",
      "adshar.share": "Share ad",
      // iter312 — Social-share platform labels.
      "adshar.whatsappStatus": "WhatsApp Status",
      "adshar.whatsappGroup": "WhatsApp Group",
      "adshar.facebookGroup": "Facebook Group",
      "adshar.captionCopiedHint": "Caption copied — paste it after picking the group on Facebook.",
      // iter313 — Seller-facing share-analytics card on My Ads.
      // {count} is interpolated by i18next. Top-platform labels are
      // short, sentence-case so they fit on a single mobile line next
      // to "Top platform:".
      "adshar.sharedTimes_one": "Shared {{count}} time",
      "adshar.sharedTimes_other": "Shared {{count}} times",
      "adshar.topPlatform": "Top platform",
      "adshar.platform.whatsapp_status": "WhatsApp",
      "adshar.platform.whatsapp_group": "WhatsApp",
      "adshar.platform.facebook_group": "Facebook",
      "adshar.platform.native_share": "Share sheet",
      "adshar.platform.copy_link": "Copy Link",
      "adshar.platform.copy_text": "Copy Text",
      "adshar.noSharesYet": "Not shared yet",
      // --- alp ---
      "alp.chooseYourAcademicLevel": "Choose your academic level",
      "alp.skip": "Skip",
      "alp.wellPersonalizeContentForYou": "We'll personalize content for you.",
      // --- bam ---
      "bam.appearsAtTopOfSearch": "Appears at top of search results",
      "bam.boostBenefits": "Boost benefits:",
      "bam.boostFailed": "Boost failed",
      "bam.boostNow": "Boost Now",
      "bam.boostYourAd": "Boost Your Ad",
      "bam.boosted": "Boosted!",
      "bam.boostedBadgeOnYourAd": '"Boosted" badge on your ad',
      "bam.boosting": "Boosting...",
      "bam.cancel": "Cancel",
      "bam.connectionError": "Connection error",
      "bam.cost": "Cost:",
      "bam.insufficientBalanceTopUpYour": "Insufficient balance. Top up your coins first.",
      "bam.insufficientCoins": "Insufficient coins",
      // --- bfb ---
      "bfb.allGenres": "All Genres",
      // --- bfs ---
      "bfs.affectsAllSections": "(affects all sections)",
      "bfs.allLevels": "All Levels",
      "bfs.location": "Location",
      "bfs.country": "Country",
      "bfs.city": "City",
      "bfs.searchCountry": "Search country...",
      "bfs.searchCity": "Search city...",
      "bfs.priceSdg": "Price (SDG)",
      "bfs.type": "Type",
      "bfs.clearAll": "Clear All",
      "bfs.applyFilters": "Apply Filters",
      // --- bookdeta ---
      "bookdeta.addDetails": "Add details...",
      "bookdeta.additionalDetails": "Additional details",
      "bookdeta.back": "Back",
      "bookdeta.bookDetails": "Book Details",
      "bookdeta.call": "Call",
      "bookdeta.description": "Description",
      "bookdeta.duplicate": "Duplicate",
      "bookdeta.free": "Free",
      "bookdeta.inappropriate": "Inappropriate",
      "bookdeta.other": "Other",
      "bookdeta.posted": "Posted",
      "bookdeta.reason": "Reason",
      "bookdeta.reportListing": "Report Listing",
      "bookdeta.reportThisListing": "Report this listing",
      "bookdeta.save": "Save",
      "bookdeta.scam": "Scam",
      "bookdeta.selectReason": "Select reason",
      "bookdeta.seller": "Seller",
      "bookdeta.spam": "Spam",
      "bookdeta.scamFraud": "Scam / Fraud",
      "bookdeta.wrongCategory": "Wrong Category",
      "bookdeta.offensiveContent": "Offensive Content",
      "bookdeta.fakeItem": "Fake Item",
      "bookdeta.additionalNote": "Additional note (optional)",
      "bookdeta.addNote": "Any extra details...",
      "bookdeta.fileUnavailable": "File not available yet",
      "bookdeta.fakeItemWarning": "False reports affect trust in the platform. Please submit this only if you are confident the listing is misleading, fake, or abusive.",
      "bookdeta.confirmReport": "Confirm Report",
      "bookdeta.confirmReportMsg": "Are you sure you want to submit this report?",
      "bookdeta.yesSubmit": "Yes, submit",
      "bookdeta.submit": "Submit",
      "bookdeta.submitting": "Submitting...",
      "bookdeta.preview": "Preview",
      "bookdeta.viewSample": "View Sample",
      "bookdeta.noPreview": "No preview available",
      "bookdeta.previewPages": "Preview Pages",
      "bookdeta.uploadPreview": "Upload Preview",
      "bookdeta.optionalPreview": "Optional — upload 1-2 sample pages",
      "bookdeta.previewOf": "of",
      "bookdeta.booksShared": "Books Shared",
      "bookdeta.downloads": "Downloads",
      "bookdeta.rating": "Rating",
      "bookdeta.reviews": "Reviews",
      "bookdeta.verifiedStudent": "Verified Student",
      "bookdeta.rateThisBook": "Rate this book",
      "bookdeta.writeReview": "Write a review (optional)",
      "bookdeta.submitRating": "Submit Rating",
      "bookdeta.ratingSubmitted": "Rating submitted!",
      "bookdeta.loginToRate": "Login to rate",
      "bookdeta.recentReviews": "Reviews",
      "bookdeta.moreFromSeller": "More from this seller",
      "bookdeta.showLess": "Show less",
      "bookdeta.noOtherListings": "No other listings",
      "bookdeta.contactOptions": "Contact Options",
      "bookdeta.chatInWassla": "Chat in Wassla",
      "bookdeta.contactSellerCTA": "Contact Seller",
      "bookdeta.reportFalseWarning": "False or abusive reports may result in account restrictions.",
      "bookdeta.whatsapp": "WhatsApp",
      "bookdeta.email": "Email",
      "bookdeta.editContacts": "Edit contact methods",
      "bookdeta.contactsUpdated": "Contact methods updated",
      "bookdeta.updateFailed": "Could not update contact methods",
      "bookdeta.messenger": "Messenger",
      "fap.title": "Welcome to Wassla 👋",
      "fap.text": "Start by posting your first ad or explore what's around you.",
      "fap.postAd": "Post an ad",
      "fap.browse": "Explore listings",
      "bookdeta.sellerUnavailable": "Seller contact is unavailable",
      "bookdeta.noReviews": "No reviews yet",
      "bookdeta.yourRating": "Your rating",
      // --- bookhub ---
      "bookhub.bookInSeconds": "Book in seconds",
      // --- boosmoda ---
      "boosmoda.adBoostedSuccessfully": "Ad boosted successfully!",
      "boosmoda.adMustBePublishedFirst": "Ad must be published first",
      "boosmoda.boostFailedPleaseTryAgain": "Boost failed. Please try again.",
      "boosmoda.cannotBoostAHiddenAd": "Cannot boost a hidden ad",
      "boosmoda.cannotBoostASoldAd": "Cannot boost a sold ad",
      "boosmoda.insufficientBalance": "Insufficient balance",
      "boosmoda.thisAdIsAlreadyBoosted": "This ad is already boosted",
      // --- bottnav ---
      "bottnav.home": "Home",
      "bottnav.messages": "Messages",
      "bottnav.myAccount": "My Account",
      "bottnav.sell": "Sell",
      "bottnav.shop": "Shop",
      // --- bsm ---
      "bsm.chooseABoostType": "Choose a boost type",
      "bsm.duration": "Duration:",
      "bsm.purchase": "Purchase",
      "bsm.purchasing": "Purchasing...",
      "bsm.selectABoostType": "Select a boost type",
      // --- catehead ---
      "catehead.goBack": "Go back",
      // --- cont ---
      "cont.afterLoggingInTapThe": 'After logging in, tap the "+" button at the bottom of the screen, then select the appropriate category and fill in the ad details.',
      "cont.contactUs": "Contact Us",
      "cont.copied": "Copied!",
      "cont.copy": "Copy",
      "cont.email": "Email",
      "cont.errorPleaseTryAgain": "Error, please try again",
      "cont.faqs": "FAQs",
      "cont.frequentlyAskedQuestions": "Frequently Asked Questions",
      "cont.goBack": "Go Back",
      "cont.goToSettingsAccountDelete": "Go to My Account > Settings > Delete Account. Deletion is permanent — all your ads, messages, and data will be removed and cannot be recovered.",
      "cont.deleteAccount.intro": "Deleting your account removes your ads, messages, and profile. Here's how:",
      "cont.deleteAccount.step1": "Open the My Account tab from the bottom bar.",
      "cont.deleteAccount.step2": "Tap the menu icon at the top right to open Settings.",
      "cont.deleteAccount.step3": "Scroll past the settings list (Edit Profile, Language, Dark Mode, …).",
      "cont.deleteAccount.step4": "Tap Delete Account at the bottom, then confirm.",
      "cont.deleteAccount.warning": "This is permanent. Your ads, chats, favourites, and wallet balance will be lost and cannot be restored.",
      "cont.deleteAccount.support": "Need help? Contact support before deleting — we may be able to fix the issue instead.",
      "cont.helpSupport": "Help & Support",
      "cont.howDoIContactA": "How do I contact a seller?",
      "cont.howDoICreateA": "How do I create a new account?",
      "cont.howDoIDeleteMy": "How do I delete my account?",
      "cont.howDoIPostAn": "How do I post an ad?",
      "cont.howDoIReportA": "How do I report a violation?",
      "cont.instantResponse": "Contact us on WhatsApp",
      "cont.message": "Message",
      "cont.messageSentSuccessfully": "Message sent successfully!",
      "cont.name": "Name",
      "cont.openTheAdTapReport": 'Open the ad, tap the three-dot menu (⋮) at the top, choose "Report", select a reason, and submit. Our team will review the report.',
      "cont.privacyPolicy": "Privacy Policy",
      "cont.responseWithin24Hours": "We'll reply to you by email",
      "cont.send": "Send",
      "cont.sendAMessage": "Send a support request",
      "cont.emailSupport": "Email Support",
      "cont.whatsappSupport": "WhatsApp Support",
      "cont.supportFormHelper1": "This form sends an email to Wassla Support.",
      "cont.supportFormHelper2": "We usually respond within 24–48 hours.",
      "cont.supportFormHelper3": "If you don't see our reply, check your spam folder.",
      "cont.supportRequestSent": "Your support request has been sent.",
      "cont.supportRequestReplyNote": "Wassla will reply to you by email.",
      "cont.duplicateRequest": "We already received this message. We'll reply to you by email.",
      "cont.sending": "Sending...",
      "cont.subject": "Subject",
      "cont.tapTheContactSellerButton": "Open the ad page and use the WhatsApp, Message, or Call buttons to contact the seller directly.",
      "cont.termsOfUse": "Terms of Use",
      "cont.thankYouForReachingOut": "Thank you for reaching out!",
      "cont.wasslaClassifiedsPlatform": "Wassla - Classifieds Platform",
      "cont.wellGetBackToYou": "We'll get back to you as soon as possible.",
      "cont.wereHereToHelpYou": "We're here to help you",
      "cont.whatsapp": "WhatsApp",
      "cont.youCanCreateANew": 'You can create a new account by clicking "Log in" and selecting "Create account". You can register with email or Google account.',
      // --- crophome ---
      "crophome.beTheFirstToPost": "Be the first to post in this area!",
      "crophome.browseCrops": "Browse Crops",
      "crophome.latestListings": "Latest Listings",
      "crophome.loadMore": "Load More",
      "crophome.loading": "Loading...",
      "crophome.noCropsFound": "No crops found",
      "crophome.postYourCrop": "Post Your Crop",
      "crophome.postYourFirstAd": "Post Your First Ad",
      "crophome.sample": "Sample",
      "crophome.searchCrops": "Search crops...",
      "crophome.signInToContinue": "Sign in to continue",
      "crophome.theseAreSampleAdsPost": "💡 These are sample ads - Post your real listing!",
      // --- csb ---
      "csb.search": "Search",
      "csb.wellShowVisuallySimilarItems": "We'll show visually similar items. We don't store these images.",
      // --- gsii ---
      "gsii.continueWithGoogle": "Continue with Google",
      "gsii.googleSigninFailed": "Google sign-in failed",
      "gsii.signedInSuccessfully": "Signed in successfully",
      // --- had ---
      "had.contactAttempts": "Contact Attempts",
      "had.contactClicks": "Contact Clicks",
      "had.copyClicks": "Copy Clicks",
      "had.dataWillAppearHereWhen": "Data will appear here when users interact with the Help page",
      "had.eventBreakdown": "Event Breakdown",
      "had.failedToLoadAnalytics": "Failed to load analytics",
      "had.faqOpens": "FAQ Opens",
      "had.helpSearches": "Help Searches",
      "had.helpSupportAnalytics": "Help & Support Analytics",
      "had.last14Days": "Last 14 days",
      "had.last30Days": "Last 30 days",
      "had.last7Days": "Last 7 days",
      "had.last90Days": "Last 90 days",
      "had.loadingAnalytics": "Loading analytics...",
      "had.noDataYet": "No data yet",
      "had.pageViews": "Page Views",
      "had.retry": "Retry",
      "had.topContactMethods": "Top Contact Methods",
      "had.topFaqs": "Top FAQs",
      "had.uniqueSessions": "unique sessions",
      "had.userFunnel": "User Funnel",
      // --- hag ---
      "hag.startExploring": "Start Exploring",
      // --- hmr ---
      "hmr.exploreHubs": "EXPLORE HUBS",
      "hmr.tapToBrowse": "Tap to browse",
      // --- home ---
      "home.basedOnYourActivity": "Based on your activity",
      "home.clearAll": "Clear all",
      // --- saved searches ---
      "savedSearches.title": "Saved Searches",
      "savedSearches.subtitle": "We'll notify you when new ads match these filters.",
      "savedSearches.save": "Save search",
      "savedSearches.saved": "Search saved — you'll get alerts",
      "savedSearches.alreadySaved": "This search is already saved",
      "savedSearches.needFilters": "Add a search term or filter first",
      "savedSearches.saveFailed": "Couldn't save — please try again",
      "savedSearches.limitReached": "You've reached the limit of 25 saved searches",
      "savedSearches.authRequired": "Please sign in to save searches",
      "savedSearches.emptyTitle": "No saved searches yet",
      "savedSearches.emptyHint": "Run a search on Home and tap \"Save search\" to get alerts.",
      "savedSearches.viewResults": "View",
      "savedSearches.delete": "Delete",
      "savedSearches.deleted": "Saved search removed",
      "savedSearches.deleteFailed": "Couldn't delete — please try again",
      "savedSearches.loadFailed": "Couldn't load saved searches",
      "savedSearches.defaultLabel": "Saved search",
      "savedSearches.pillCategory": "Category: {{value}}",
      "savedSearches.pillLocation": "Location: {{value}}",
      "account.alerts": "Saved Searches",
      "home.clearImageSearch": "✕ Clear image search",
      "home.enterCityOrArea": "Enter city or area",
      "home.filters": "Filters",
      "home.filtersApplied": "Filters applied",
      "home.forYou": "For You",
      "home.imageSearchActive": "🔍 Image search active",
      "home.justPosted": "Just Posted",
      "home.listingsNearby": "Listings nearby",
      "home.loadingProducts": "Loading products...",
      "home.location": "Location",
      "home.location2": "Location:",
      "home.max": "Max",
      "home.min": "Min",
      "home.mostPopularRightNow": "Most popular right now",
      "home.mostViewed": "Most Viewed",
      "home.nearMe": "Near me",
      "home.nearYou": "Near You",
      // iter319 — Premium Near Me card. Five message states (A→E)
      // map onto a single bilingual notice that lives inside the
      // tab heading. Texts are short and punchy on purpose so the
      // mobile viewport never overflows in RTL.
      "home.nearMe.searching": "Finding ads near you…",
      "home.nearMe.showingNearby": "Showing ads near your current location",
      "home.nearMe.showingNearbyWithin": "Showing ads within {{km}} km of you",
      "home.nearMe.showingLiveFallback": "Showing live ads until location is available.",
      "home.nearMe.noNearbyButLive": "No ads very close to you yet. Showing other live ads instead.",
      "home.nearMe.noNearbyMatches": "No nearby ads found",
      // Location permission CTA + feedback.
      "home.nearMe.useMyLocation": "Use my location",
      "home.nearMe.refreshLocation": "Refresh my location",
      "home.nearMe.requestingLocation": "Locating…",
      "home.nearMe.permissionDenied": "Location access is off. Turn it on to see nearby ads.",
      "home.nearMe.locationError": "We couldn't read your location. Try again or choose your city manually.",
      // iter319 — Manual fallback (city picker) used when GPS is
      // denied / fails / unsupported.
      "home.nearMe.chooseCity": "Choose your city",
      "home.nearMe.chooseCityPrompt": "Pick a city",
      "home.nearMe.apply": "Apply",
      "home.nearMe.cancel": "Cancel",
      // iter324 — Guest-friendly idle copy. Signed-out users who tap
      // Near Me but haven't asked for GPS yet should NOT see the
      // permission-denied message. They get a welcoming card that
      // offers all 3 paths: GPS, manual city, or sign-in (optional).
      "home.nearMe.guestIdleTitle": "See ads near you. Use your location once, choose your city, or sign in to save your preferences.",
      "home.nearMe.userIdleTitle": "See ads near you. Use your location or choose your city.",
      "home.nearMe.signIn": "Sign in",
      "home.nearMe.guestGpsHelper": "Sign in to save your location preferences.",
      "home.nearMe.tryAgain": "Try again",
      "home.nearMe.chooseCityInstead": "Choose city instead",
      "home.nearMe.signInBeforeGps": "Please sign in first, then allow location access to see nearby ads.",
      // iter327 — WasslaImage fallback caption shown when an ad/listing
      // image fails to load or times out. Single shared key so every
      // surface (Home / Shop / Favorites / Admin) speaks the same line.
      "image.unavailable": "Image unavailable",
      // iter322 Phase A refinement — Strict manual location filter empty state.
      // Shown when user picked a country/region/city in the picker but no
      // ad in the marketplace matches that location yet.
      "home.nearMe.emptyManualTitle": "No ads found in this location yet",      "home.nearMe.emptyManualHint": "Try a nearby city or clear the location filter.",
      "home.nearMe.changeLocation": "Change location",
      "home.nearMe.clearLocation": "Clear location",
      "home.nearMe.strictModeShowing": "Showing ads in {{label}} only",
      "home.newListings": "New listings",
      "home.newest": "Newest",
      "home.new": "NEW",
      "home.negotiable": "Negotiable",
      "home.noExactMatchesFound": "No exact matches found",
      "home.priceHighToLow": "Price: High to Low",
      "home.priceHighlow": "Price: High-Low",
      "home.priceLowToHigh": "Price: Low to High",
      "home.priceLowhigh": "Price: Low-High",
      "home.priceRange": "Price Range",
      "home.recentSearches": "Recent searches",
      "home.searchProductsServicesJobs": "Search products & services",
      "home.showAllProducts": "Show all products",
      "home.topSearch": "Top search",
      "home.topSearched": "Top Searched",
      "home.trending": "Trending",
      "home.tryDifferentKeywordsOrBrowse": "Try different keywords or browse suggestions below",
      "home.trySearchingFor": "Try searching for:",
      "home.whatOthersAreSearching": "What others are searching",
      "home.youMightAlsoLike": "You might also like",
      "home.yourPreferenceHasBeenSaved": "Your preference has been saved!",
      // --- lcr ---
      "lcr.academicLevels": "Academic Levels",
      "lcr.scrollNext": "Scroll next",
      "lcr.scrollPrevious": "Scroll previous",
      "lcr.seeAll": "See all",
      "lcr.trustedSellersWithHighRatings": "Trusted sellers with high ratings",
      // --- lms ---
      "lms.allCategories": "All Categories",
      "lms.noResultsFound": "No results found",
      "lms.searchCategories": "Search categories...",
      // --- lsr ---
      "lsr.level": "Level:",
      // --- mess ---
      "mess.aboutOptional": "About (optional)",
      "mess.backToMessages": "Back to Messages",
      "mess.conversationNotFound": "Conversation not found",
      "mess.deleteConversation": "Delete conversation",
      "mess.deleteConversationTitle": "Delete conversation?",
      "mess.deleteConversationBody": "This will permanently remove this conversation from your inbox.",
      "mess.delete": "Delete",
      "mess.cancel": "Cancel",
      "mess.deleted": "Conversation deleted",
      "mess.deleteFailed": "Couldn't delete conversation. Please try again.",
      "mess.create": "Create",
      "mess.nameTitle": "Name / Title",
      "mess.newConversation": "New Conversation",
      "mess.noConversationsYet": "No conversations yet",
      "mess.productName": "Product name",
      "mess.searchConversations": "Search conversations...",
      "mess.sellerNameOrAdTitle": "Seller name or ad title",
      "mess.thanksNotedWhatPriceAre": "Thanks — noted. What price are you offering?",
      "mess.typeAMessage": "Type a message...",
      // --- more ---
      "more.account": "Account",
      "more.admin": "Admin",
      "more.allAdditionalFeaturesInOne": "All additional features in one place",
      "more.boostAd": "Boost Ad",
      "more.growth": "Growth",
      "more.moderation": "Moderation",
      "more.money": "Money",
      "more.more": "More",
      "more.profile": "Profile",
      "more.referRewards": "Refer & Rewards",
      "more.safetyCenter": "Safety Center",
      "more.settings": "Settings",
      "more.tools": "Tools",
      "more.transactions": "Transactions",
      "more.translationHistory": "Translation History",
      "more.walletCoins": "Wallet & Coins",
      // --- onborole ---
      "onborole.academicLevel": "Academic Level",
      "onborole.anErrorOccurredPleaseTry": "An error occurred. Please try again.",
      "onborole.continue": "Start using Wassla",
      "onborole.iAmA": "Choose how you want to use Wassla",
      "onborole.saving": "Setting up...",
      "onborole.selectYourProfileTypeTo": "Pick the option that best describes you.\nYou can always change it later.",
      "onborole.welcomeToWassla": "Welcome to Wassla",
      "onborole.youCanChangeThisLater": "You can change this anytime in Settings",
      "onborole.stepLabel": "",
      "onborole.sellerLabel": "Sell Something",
      "onborole.sellerDesc": "Post ads, boost visibility, and reach thousands of buyers.",
      "onborole.buyerLabel": "Browse & Shop",
      "onborole.buyerDesc": "Discover deals, message sellers, and find what you need.",
      "onborole.studentLabel": "Student",
      "onborole.studentDesc": "Access books, summaries, and CV Builder tools.",
      "onborole.serviceLabel": "Offer a Service",
      "onborole.serviceDesc": "List your professional services and get discovered by clients.",
      "onborole.proLabel": "Professional",
      "onborole.proDesc": "Post ads, manage listings, and connect with buyers.",
      "onborole.generalLabel": "General User",
      "onborole.generalDesc": "Browse the marketplace and explore all categories.",
      // --- psb ---
      "psb.clear": "Clear",
      "psb.noRecentSearchesYet": "No recent searches yet",
      "psb.searchWithImage": "Search with image",
      "psb.searching": "Searching...",
      "psb.selectAnExistingPhoto": "Select an existing photo",
      "psb.takePhoto": "Take photo",
      "psb.wellShowVisuallySimilarAds": "We'll show visually similar ads. We don't store these images. Used only for search.",
      // --- pss ---
      "pss.apply": "Apply",
      "pss.clearAll": "Clear All",
      "pss.sortBy": "Sort by",
      // --- ptp ---
      "ptp.text": "التبديل للعربية",
      "ptp.text2": "عربي",
      // --- ptw ---
      "ptw.popularThisWeek": "Popular This Week",
      "ptw.viewAll": "View All",
      // --- ras ---
      "ras.anErrorOccurredPleaseTry": "An error occurred, please try again",
      // --- rolesele ---
      "rolesele.accountTypeUpdatedSuccessfully": "Account type updated successfully",
      "rolesele.close": "Close",
      // --- savefab ---
      "savefab.saved": "Saved",
      // --- sbp ---
      "sbp.changeLevel": "Change Level",
      "sbp.tryAnotherLevelOrPost": "Try another level or post the first book",
      "sbp.addBook": "Add Book",
      "sbp.loginToPost": "Log in to post",
      "sbp.filter": "Filter",
      "sbp.preview": "Preview",
      "sbp.previewUnavailable": "Preview unavailable",
      "sbp.paid": "Paid",
      "sbp.free": "Free",
      "sbp.all": "All",
      "sbp.pastPapers": "Exam Sheets",
      "sbp.lectureNotes": "Lecture Notes",
      "sbp.textbooks": "Books",
      "sbp.labManuals": "Lab Manuals",
      "sbp.summaries": "Summaries",
      "sbp.slides": "Slides",
      "sbp.notebook": "Notebook",
      "sbp.pdf": "PDF",
      "sbp.magazine": "Magazine",
      "sbp.newest": "Newest",
      "sbp.priceLowHigh": "Price: Low → High",
      "sbp.priceHighLow": "Price: High → Low",
      "sbp.freeFirst": "Free First",
      "sbp.downloads": "Downloads",
      "sbp.subject": "Subject",
      "sbp.university": "University",
      "sbp.level": "Level",
      "sbp.department": "Department",
      "sbp.location": "Location",
      "sbp.sortBy": "Sort by",
      "sbp.views": "views",
      "sbp.saves": "saves",
      "sbp.document": "Document",
      "sbp.notes": "Notes",
      "sbp.textbook": "Textbook",
      "sbp.pastExam": "Past Exam",
      "sbp.labManual": "Lab Manual",
      "sbp.summary": "Summary",
      "sbp.pdf": "PDF",
      // --- scg ---
      "scg.browseSubcategories": "Browse subcategories",
      "scg.shopByCategory": "Shop by category",
      // --- selltrus ---
      "selltrus.phoneVerified": "Phone Verified",
      "selltrus.repliesFast": "Replies fast",
      "selltrus.verifiedSeller": "Verified Seller",
      "selltrus.trustedSeller": "Trusted Seller",
      "selltrus.activeSeller": "Active Seller",
      // --- sett ---
      "sett.aboutWassla": "About Wassla",
      "sett.dark": "Dark",
      "sett.editProfile": "Edit Profile",
      "sett.english": "English",
      "sett.language": "Language",
      "sett.light": "Light",
      "sett.manageYourAppAndAccount": "Manage your app and account preferences",
      "sett.termsConditions": "Terms & Conditions",
      "sett.theme": "Theme",
      // --- shc ---
      "shc.level": "Level",
      // --- shh ---
      "shh.booksOpportunitiesCvBuilder": "Books • Opportunities • CV Builder",
      "shh.booksScholarshipsOpportunitiesCvBuilder": "Books • Summaries • CV Builder",
      "shh.filter": "Filter",
      "shh.investInYourFutureToday": "Invest in your future today.",
      "shh.learnBuildGrow": "Learn • Build • Grow",
      "shh.searchHistory": "Search History",
      "shh.studentHub": "Student Hub",
      "shf.comingSoon": "Coming Soon",
      "shf.featureComingSoonDesc": "This feature is under development and will be available soon.",
      "shf.backToStudentHub": "Back to Student Hub",
      "shf.yourAcademicLevel": "Your academic level",
      // --- shl ---
      "shl.later": "Skip for now",
      "shl.selectACategoryToBegin": "Select a category to begin or search directly",
      "shl.selectYourAcademicLevel": "Select your academic level",
      "shl.updated": "Updated",
      "shl.wellPersonalizeContentBasedOn": "We'll show books and learning materials that match your academic level.",
      "shl.secondary": "Secondary",
      "shl.university": "University",
      "shl.postgrad": "Postgrad",
      "shl.vocational": "Vocational",
      "shl.vocationalHint": "Technical / training institutes",
      "shl.other": "Other",
      "shl.levelSelected": "{{level}} selected",
      "shl.editLevel": "Edit level",
      "shl.changeAcademicLevel": "Change academic level",
      "shl.yourLevel": "Your level",
      "shl.levelUpdated": "Academic level updated",
      // --- slp ---
      "slp.admission": "Admission",
      "slp.all": "All",
      "slp.clearFilters": "Clear Filters",
      "slp.course": "Course",
      "slp.deadline": "Deadline:",
      "slp.guide": "Guide",
      "slp.hybrid": "Hybrid",
      "slp.internship": "Internship",
      "slp.job": "Job",
      "slp.noResultsForThisLevel": "No results for this level",
      "slp.oldest": "Oldest",
      "slp.onsite": "On-site",
      "slp.opportunity": "Opportunity",
      "slp.paid": "Paid",
      "slp.remote": "Remote",
      "slp.scholarship": "Scholarship",
      "slp.select": "Select",
      "slp.selectLevel": "Select level",
      "slp.sortBy": "Sort By",
      "slp.volunteer": "Volunteer",
      "slp.workType": "Work Type",
      // --- studgami ---
      "studgami.allBadges": "All Badges",
      "studgami.greatJobKeepGoing": "Great job! Keep going!",
      "studgami.levelUp": "Level Up!",
      "studgami.unlocked": "Unlocked!",
      // --- studhub ---
      "studhub.dailyVisit": "Daily visit",
      "studhub.postABook": "Post a Book",
      // --- studpage ---
      "studpage.additionalTools": "Additional Tools",
      "studpage.available": "Available",
      "studpage.availableTemplates": "Available Templates",
      "studpage.benefits": "Benefits",
      "studpage.bestValue": "Best Value",
      "studpage.chooseYourPlan": "Choose Your Plan",
      "studpage.getCoins": "Get Coins",
      "studpage.itemUnlockedSuccessfully": "Item unlocked successfully!",
      "studpage.locked": "Locked",
      "studpage.notEnoughCoins": "Not enough coins",
      "studpage.price": "Price",
      "studpage.pro": "Pro",
      "studpage.somethingWentWrong": "Something went wrong",
      "studpage.startFree": "Start Free",
      "studpage.unlockNow": "Unlock Now",
      "studpage.unlocked": "Unlocked",
      "studpage.unlocking": "Unlocking...",
      "studpage.useTemplates": "Use Templates",
      "studpage.yourBalance": "Your balance:",
      // --- trusbadg ---
      "trusbadg.boosted": "Boosted",
      "trusbadg.buyerProtection": "Buyer Protection",
      "trusbadg.safeContact": "Safe Contact",
      "trusbadg.shopSafelyNeverPayUpfront": "Shop safely. Never pay upfront to unverified sellers.",
      "trusbadg.trustSafety": "Trust & Safety",
      "trusbadg.verified": "Verified",
      // --- upcm ---
      "upcm.15MinutesOfAds": "15 Minutes of Ads",
      "upcm.accountName": "Account Name:",
      "upcm.ads": "Ads",
      "upcm.afterPayingUploadTheReceipt": "After paying, upload the receipt to continue",
      "upcm.alreadyUnlocked": "Already Unlocked!",
      "upcm.amount": "Amount:",
      "upcm.bankak": "Bankak",
      "upcm.bestScore": "Best Score",
      "upcm.channel": "Channel:",
      "upcm.checking": "Checking...",
      "upcm.chooseAMethodToUnlock": "Choose a method to unlock professional PDF export",
      "upcm.demoModeRealAppWill": "(Demo mode - real app will show actual ads)",
      "upcm.demoModeRealAppWill2": "(Demo mode - real app will show actual game)",
      "upcm.game": "Game",
      "upcm.great": "Great!",
      "upcm.onetimePayment": "One-time payment",
      "upcm.paymentInstructions": "Payment Instructions",
      "upcm.pendingApproval": "Pending Approval",
      "upcm.playEarn": "Play & Earn!",
      "upcm.playFor15MinutesAnd": "Play for 15 minutes and score 120 points to unlock for free",
      "upcm.playSession2Min": "Play Session (2 min)",
      "upcm.playTime": "Play Time",
      "upcm.receiptImageUrl": "Receipt image URL",
      "upcm.startBankakPayment": "Start Bankak Payment",
      "upcm.startGame": "Start Game",
      "upcm.startWatchingAds": "Start Watching Ads",
      "upcm.submitReceipt": "Submit Receipt",
      "upcm.unlockProCvPdf": "Unlock Pro CV (PDF)",
      "upcm.uploadReceipt": "Upload Receipt",
      "upcm.uploadReceiptImage": "Upload Receipt Image",
      "upcm.watchAd1Minute": "Watch Ad (1 minute)",
      "upcm.watchProgress": "Watch Progress",
      "upcm.watchShortAdsForA": "Watch short ads for a total of 15 minutes to unlock for free",
      "upcm.youCanNowExportYour": "You can now export your CV as a professional PDF",
      "upcm.youCanUploadTheImage": "You can upload the image to any cloud service and paste the URL here",
      "upcm.yourReceiptHasBeenSubmitted": "Your receipt has been submitted and is under review. You will be notified once approved.",
      // --- wall ---
      "wall.boostMyAd": "Boost My Ad",
      "viewAllHistory": "View All",
      "noTransactions": "No transactions yet",
      "wall.codeCopied": "Code copied!",
      "wall.coinRules": "Coin Rules",
      "wall.coins": "Coins",
      "wall.coinsAreNotTransferableAnd": "Coins are not transferable and cannot be converted to cash",
      "wall.coinsCanBeUsedFor": "Coins can be used for boosts and premium tools",
      "wall.dailyLoginStreaksIncreaseBonuses": "Daily login streaks increase bonuses",
      "wall.earn10CoinsWhenYour": "Earn 10 coins when your friend posts their first ad!",
      "wall.earnedCoinsExpireAfter60": "Earned coins expire after 60 days",
      "wall.failedToCopy": "Failed to copy",
      "wall.increaseVisibilityInstantly": "Increase visibility instantly",
      "wall.inviteFriends": "Invite Friends",
      "wall.joinWassla": "Join Wassla!",
      "wall.linkCopied": "Link copied!",
      "wall.orShareTheLink": "Or share the link",
      "wall.postAnAdToStart": "Post an ad to start boosting",
      "wall.referrals": "Referrals",
      "wall.yourReferralCode": "Your Referral Code",
      // --- wallhist ---
      "wallhist.loadMore": "Load more",
      "wallhist.noTransactionsYet": "No transactions yet",
      "wallhist.startEarningCoinsThroughDaily": "Start earning coins through daily tasks",
      "wallhist.transactionHistory": "Transaction History",
      // --- whp ---
      "whp.encryptedSecure": "Encrypted & Secure",
      "whp.history": "History",
      "whp.myWallet": "My Wallet",
      "whp.today": "Today",
      "whp.coins": "coins",
      "whp.yesterday": "Yesterday",
      "whp.noTransactionsYet": "No transactions yet",
      "whp.yourWalletActivityWill": "Your wallet activity will appear here once you start using coins",
      "whp.viewAll": "View All",
      // --- wph ---
      "wph.youHaveUnsavedChangesExit": "You have unsaved changes. Exit anyway?",
    }
  },
  ar: {
    translation: {
      // ==================== BOTTOM NAVIGATION ====================
      home: "الرئيسية",
      shop: "المتجر",
      addAd: "إضافة إعلان",
      bookingHub: "الحجوزات",
      navAccount: "الحساب",
      navStudentHub: "قسم الطلاب",
      navFarmHub: "الزراعة",
      
      // ==================== SELECT COMPONENT ====================
      select: "اختر",
      search: "بحث…",
      noResults: "لا توجد نتائج",
      close: "إغلاق",
      apply: "تطبيق",
      selectCategory: "اختر القسم",
      selectState: "اختر الولاية",
      selectCity: "اختر المدينة",
      selectOption: "اختر خيار",
      
      // ==================== HEADER ====================
      login: "تسجيل الدخول / التسجيل",
      logout: "تسجيل الخروج",
      
      // ==================== NOTIFICATIONS ====================
      notifications: "الإشعارات",
      notifTitle: "الإشعارات",
      notifEmpty: "لا توجد إشعارات",
      notifClear: "مسح الكل",
      notifClearTitle: "مسح جميع الإشعارات؟",
      notifClearMessage: "سيؤدي هذا إلى حذف جميع إشعاراتك. لا يمكن التراجع عن هذا الإجراء.",
      notifClearCancel: "إلغاء",
      notifClearConfirm: "نعم، امسح الكل",
      no_notifications: "لا توجد إشعارات",
      clear_notifications: "مسح الإشعارات",
      notification_ad_published: "تم نشر إعلانك '{{title}}' بنجاح",
      notification_ad_pending: "إعلانك '{{title}}' قيد المراجعة",
      notification_ad_approved: "تمت الموافقة على إعلانك '{{title}}'",
      notification_ad_rejected: "تم رفض إعلانك '{{title}}'{{reasonSuffix}}",
      notification_ad_rejected_reason_suffix: ". السبب: {{reason}}",
      notification_ad_limited: "تم تقييد ظهور إعلانك '{{title}}'",
      notification_ad_under_review: "إعلانك '{{title}}' قيد المراجعة من الإدارة",
      notification_booking_confirmed: "تم تأكيد حجزك",
      notification_account_banned: "تم حظر حسابك",
      notification_account_suspended: "تم إيقاف حسابك مؤقتاً",
      notification_ad_removed: "تم حذف إعلانك '{{title}}'",
      notification_ad_flagged: "تم الإبلاغ عن إعلانك '{{title}}'",
      notification_welcome: "مرحباً بك في وصلة!",
      notification_message_received: "وصلتك رسالة من {{from}}",
      notification_generic: "إشعار",
      
      // ==================== CATEGORIES (nested for dropdown) ====================
      categoriesTitle: "الفئات",
      seeAll: "عرض الكل",
      allCategories: "كل الفئات",
      cat: {
        // ===== SIMPLIFIED CATEGORY KEYS (matching constants/categories.js) =====
        "vehicles": "المركبات والدراجات النارية",
        "spare_parts": "قطع غيار وإكسسوارات المركبات",
        "electronics": "الإلكترونيات والإكسسوارات",
        "industrial": "الآلات الصناعية",
        "equipment": "المعدات والأدوات",
        "real_estate": "العقارات",
        "agriculture": "الزراعة",
        "food": "الأغذية والمشروبات",
        "jewelry": "المجوهرات",
        "gifts": "الهدايا والحرف",
        "pets": "الحيوانات الأليفة والماشية",
        "metals": "المعادن والسبائك",
        "fabrics": "الأقمشة والمواد الخام",
        "garden": "الحدائق والديكور",
        "it": "معدات تقنية المعلومات وخدمات البرمجيات",
        "manufacturing": "التصنيع",
        "jobs": "وظائف",
        "medical": "الأجهزة الطبية",
        "security": "الأمن والسلامة",
        "energy": "الطاقة",
        "services": "الخدمات",
        "home": "مستلزمات المنزل",
        "furniture": "الأثاث",
        "office": "مستلزمات المكاتب والمدارس",
        "apparel": "الملابس والإكسسوارات",
        "beauty": "النساء والجمال",
        "environment": "البيئة",
        // New categories
        "commodities": "السلع",
        "mobile_accessories": "الموبايلات والإكسسوارات",
        "laptops_accessories": "اللابتوبات والإكسسوارات",
        "sports_equipment": "معدات ولوازم الرياضة",
        "games_toys": "الألعاب والدمى",
        "clothes_shoes": "الملابس والأحذية",
        "health_fitness": "الصحة واللياقة",
        
        // ===== LADIES HUB CATEGORIES =====
        "bags": "شنط",
        "shoes": "أحذية",
        "wedding": "فساتين زفاف",
        "wedding_dress": "فساتين زفاف",
        "dresses": "فساتين",
        "henna": "حنة",
        "perfume": "عطور وبخور",
        "toub": "توب سوداني",
        "gold": "ذهب ومجوهرات",
        "african_fabric": "أقمشة أفريقية",
        "muslim_wear": "ملابس إسلامية وحجاب",
        "makeup": "مكياج",
        "hair": "شعر وعناية",
        "skincare": "عناية بالبشرة",
        "underwear": "ملابس داخلية",
        "salons": "صالونات",
        "home_business": "مشاريع منزلية",
        
        // ===== LEGACY KEYS for backward compatibility =====
        "electronics_accessories": "الإلكترونيات والإكسسوارات",
        "vehicles_motorbikes": "المركبات والدراجات النارية",
        "vehicle_spare_parts": "قطع غيار وإكسسوارات المركبات",
        "industrial_machinery": "الآلات الصناعية",
        "equipment_tools": "المعدات والأدوات",
        "food_beverage": "الأغذية والمشروبات",
        "gifts_crafts": "الهدايا والحرف",
        "pets_livestock": "الحيوانات الأليفة والماشية",
        "pets_cattle": "الحيوانات الأليفة والماشية",
        "metals_alloys": "المعادن والسبائك",
        "fabrics_raw_materials": "الأقمشة والمواد الخام",
        "fabric_raw_materials": "الأقمشة والمواد الخام",
        "garden_decorations": "الحدائق والديكور",
        "it_equipment_software": "معدات تقنية المعلومات وخدمات البرمجيات",
        "it_equipment_software_services": "معدات تقنية المعلومات وخدمات البرمجيات",
        "medical_devices": "الأجهزة الطبية",
        "security_safety": "الأمن والسلامة",
        "home_supplies": "مستلزمات المنزل",
        "office_school_supplies": "مستلزمات المكاتب والمدارس",
        "apparel_accessories": "الملابس والإكسسوارات",
        "womens_beauty": "النساء والجمال",
        "jewellery": "المجوهرات",
        
        // Legacy dash-based keys
        "cv-builder": "منشئ السيرة الذاتية",
        "food-beverages": "الأطعمة والمشروبات",
        "others": "أخرى"
      },
      // Legacy flat keys for backward compat
      categories: "الفئات",
      vehicles: "المركبات والدراجات النارية",
      spareParts: "قطع غيار وإكسسوارات المركبات",
      electronics: "الإلكترونيات والإكسسوارات",
      industrialMachinery: "الآلات الصناعية",
      equipmentTools: "المعدات والأدوات",
      realEstate: "العقارات",
      agriculture: "الزراعة",
      foodBeverage: "الأغذية والمشروبات",
      energy: "الطاقة",
      services: "الخدمات",
      medicalDevices: "الأجهزة الطبية",
      apparel: "الملابس والإكسسوارات",
      womensBeauty: "النساء والجمال",
      furniture: "الأثاث",
      homeSupplies: "مستلزمات المنزل",
      officeSchool: "مستلزمات المكاتب والمدارس",
      jewellery: "المجوهرات",
      giftsCrafts: "الهدايا والحرف",
      petsCattle: "الحيوانات الأليفة والماشية",
      metalsAlloys: "المعادن والسبائك",
      fabricMaterials: "الأقمشة والمواد الخام",
      gardenDecorations: "الحدائق والديكور",
      itEquipmentSoftware: "معدات تقنية المعلومات وخدمات البرمجيات",
      securitySafety: "الأمن والسلامة",
      jobs: "وظائف",
      others: "أخرى",
      
      // ==================== COMMON ====================
      cancel: "إلغاء",
      delete: "حذف",
      loading: "جاري التحميل...",
      back: "رجوع",
      edit: "تعديل",
      save: "حفظ",
      search: "بحث",
      filter: "تصفية",
      sort: "ترتيب",
      clear: "مسح",
      confirm: "تأكيد",
      success: "تم بنجاح!",
      error: "حدث خطأ",
      tryAgain: "حاول مرة أخرى",
      noResults: "لا توجد نتائج",
      comingSoon: "قريباً",
      name: "الاسم",
      searchCurrency: "ابحث عن عملة أو رمز...",
      selectCurrency: "اختر العملة",
      chat: "محادثة",
      call: "اتصال",
      phone: "رقم الهاتف",
      phoneRequired: "رقم الهاتف مطلوب لطريقة التواصل هذه",
      state: "الولاية",
      selectState: "اختر الولاية",
      allStates: "كل الولايات",
      close: "إغلاق",
      coins: "عملة",
      free: "مجاني",
      recommended: "موصى به",
      premium: "مميز",
      unitMinutes: "دقيقة",
      unitPoints: "نقطة",
      unitAds: "إعلان",
      unitOpens: "مرة",
      unitClicks: "نقرة",
      unitWeek: "الأسبوع",
      orDivider: "أو",
      boostValidDays: "صالح لمدة {{days}} أيام",

      // ==================== AD DETAILS PAGE ====================
      adDetails: {
        // Availability statuses
        sold: "مباع",
        expired: "منتهي",
        unavailable: "غير متاح",
        reserved: "محجوز",
        available: "متاح",
        // Banners
        notAvailable: "غير متاح",
        soldOrExpiredBanner: "هذا الإعلان مباع أو منتهي. تم تعطيل التواصل.",
        priceWarning: "السعر أقل بكثير من القيمة السوقية المعتادة. تحقق من البائع قبل الدفع.",
        mayBeUnavailable: "قد يكون الإعلان غير متاح",
        adNotFound: "الإعلان غير موجود",
        listingHidden: "تم إخفاء الإعلان",
        hideConfirmTitle: "إخفاء هذا الإعلان؟",
        hideConfirmSubtext: "سيتم إخفاء هذا الإعلان من عرض التصفح لديك. لن يتم حذف الإعلان أو الإبلاغ عنه.",
        hideConfirmBtn: "إخفاء",
        hideCancel: "إلغاء",
        signInToContact: "سجّل الدخول للتواصل مع البائع",
        // Price
        priceOnRequest: "السعر عند الطلب",
        // Facts row
        condition: "الحالة",
        negotiable: "قابل للتفاوض",
        views: "مشاهدة",
        // Price Insight
        priceInsight: "مقارنة الأسعار",
        typicalRange: "النطاق المعتاد",
        belowTypical: "أقل من المعتاد",
        aboveTypical: "أعلى من المعتاد",
        fairPrice: "سعر معقول",
        // Safety tip (replaces Price Insight on public Ad Details, MVP)
        safetyTipTitle: "نصيحة أمان",
        safetyTipBody: "قارن الإعلان مع إعلانات مشابهة قبل الدفع. تجنب الدفع المسبق وقابل البائع في مكان عام وآمن.",
        // Actions
        report: "إبلاغ",
        reported: "تم الإبلاغ",
        hide: "إخفاء",
        save: "حفظ",
        saved: "تم الحفظ",
        message: "رسالة",
        savedToFavorites: "تم حفظ الإعلان في المفضلة",
        browseSimilar: "تصفح مشابه",
        boostAd: "تعزيز الإعلان",
        // Description
        descriptionTitle: "الوصف",
        noDescription: "لا يوجد وصف بعد.",
        readMore: "قراءة المزيد",
        readLess: "عرض أقل",
        // Seller
        seller: "البائع",
        memberSince: "عضو منذ",
        notAvailableShort: "غير متوفر",
        viewProfile: "عرض البائع",
        peopleContacted: "{{count}} شخص تواصلوا مع البائع",
        phoneVerified: "هاتف موثق",
        repliesFast: "رد سريع",
        // Share
        shareThisAd: "مشاركة الإعلان",
        // iter312 — Social sharing upgrade
        promoteThisAd: "روّج إعلانك",
        // Post Details Modal
        postDetails: "تفاصيل النشر",
        postedAt: "تاريخ النشر",
        lastUpdated: "آخر تحديث",
        done: "تم",
        // WhatsApp
        whatsappMessage: "مرحباً، مهتم بالإعلان: {{title}}",
        // Similar/Related Ads
        similarAds: "إعلانات مشابهة قد تعجبك",
        moreInCategory: "المزيد في هذا القسم",
        sponsored: "إعلان ممول",
        seeAll: "عرض الكل",
        noSimilarAds: "لا توجد إعلانات مشابهة حالياً.",
        couldNotLoadRelated: "تعذر تحميل الإعلانات المشابهة. حاول لاحقاً.",
        noImage: "لا توجد صورة",
        ad: "إعلان",
        priceNotSet: "السعر غير محدد",
        locationNotSet: "الموقع غير محدد",
        // More from seller
        moreFromSeller: "المزيد من هذا البائع",
        seeAllListings: "عرض جميع الإعلانات",
        // Last active
        activeToday: "نشط اليوم",
        activeThisWeek: "نشط هذا الأسبوع",
        activeRecently: "نشط مؤخراً",
        // Profile completeness
        profileCompleteness: "قوة الملف",
        // Safety tips
        safetyTipsTitle: "نصائح الأمان",
        safetyTip1: "قابل في مكان عام آمن",
        safetyTip2: "تحقق من المنتج قبل الدفع",
        safetyTip3: "تجنب الدفع المسبق للغرباء",
        // Seller profile page
        sellerListings: "الإعلانات",
        activeListings: "إعلان نشط",
        showMore: "عرض المزيد",
        noListings: "لا توجد إعلانات بعد",
        joinedOn: "انضم",
        responseVeryFast: "رد سريع جداً",
        responseFast: "رد سريع",
        responseHours: "يرد خلال ساعات",
      },

      // ==================== CURRENCIES (ISO 4217) ====================
      currency: {
        // Africa - East
        SDG: "الجنيه السوداني",
        SSP: "الجنيه الجنوب سوداني",
        KES: "الشلن الكيني",
        UGX: "الشلن الأوغندي",
        TZS: "الشلن التنزاني",
        ETB: "البر الإثيوبي",
        ERN: "الناكفا الإريترية",
        DJF: "الفرنك الجيبوتي",
        SOS: "الشلن الصومالي",
        RWF: "الفرنك الرواندي",
        BIF: "الفرنك البوروندي",
        // Africa - Central
        CDF: "الفرنك الكونغولي",
        XAF: "فرنك وسط أفريقيا CFA",
        // Africa - West
        XOF: "فرنك غرب أفريقيا CFA",
        NGN: "النايرا النيجيرية",
        GHS: "السيدي الغاني",
        SLL: "الليون السيراليوني",
        LRD: "الدولار الليبيري",
        GMD: "الدالاسي الغامبي",
        GNF: "الفرنك الغيني",
        CVE: "الإسكودو الرأس أخضري",
        MRU: "الأوقية الموريتانية",
        // Africa - North
        EGP: "الجنيه المصري",
        LYD: "الدينار الليبي",
        TND: "الدينار التونسي",
        DZD: "الدينار الجزائري",
        MAD: "الدرهم المغربي",
        // Africa - Southern
        ZAR: "الراند الجنوب أفريقي",
        ZMW: "الكواشا الزامبية",
        MWK: "الكواشا الملاوية",
        MZN: "الميتيكال الموزمبيقي",
        AOA: "الكوانزا الأنغولية",
        BWP: "البولا البوتسوانية",
        NAD: "الدولار الناميبي",
        SZL: "الليلانجيني السوازيلندي",
        LSL: "اللوتي الليسوتي",
        ZWL: "الدولار الزيمبابوي",
        // Africa - Islands
        MUR: "الروبية الموريشية",
        SCR: "الروبية السيشلية",
        KMF: "الفرنك القمري",
        MGA: "الأرياري المدغشقري",
        STN: "الدوبرا الساوتومية",
        // MENA - Gulf
        SAR: "الريال السعودي",
        AED: "الدرهم الإماراتي",
        QAR: "الريال القطري",
        KWD: "الدينار الكويتي",
        BHD: "الدينار البحريني",
        OMR: "الريال العماني",
        // MENA - Levant
        JOD: "الدينار الأردني",
        LBP: "الليرة اللبنانية",
        SYP: "الليرة السورية",
        IQD: "الدينار العراقي",
        ILS: "الشيكل الإسرائيلي",
        // MENA - Other
        YER: "الريال اليمني",
        IRR: "الريال الإيراني",
        // Global - Major
        USD: "الدولار الأمريكي",
        EUR: "اليورو",
        GBP: "الجنيه الإسترليني",
        CHF: "الفرنك السويسري",
        JPY: "الين الياباني",
        CNY: "اليوان الصيني",
        INR: "الروبية الهندية",
        PKR: "الروبية الباكستانية",
        BDT: "التاكا البنغلاديشية",
        TRY: "الليرة التركية",
        RUB: "الروبل الروسي",
        BRL: "الريال البرازيلي",
        MXN: "البيزو المكسيكي",
        CAD: "الدولار الكندي",
        AUD: "الدولار الأسترالي",
        NZD: "الدولار النيوزيلندي",
        SGD: "الدولار السنغافوري",
        HKD: "الدولار الهونغ كونغي",
        KRW: "الوون الكوري",
        THB: "البات التايلندي",
        MYR: "الرينغيت الماليزي",
        IDR: "الروبية الإندونيسية",
        PHP: "البيزو الفلبيني",
        VND: "الدونغ الفيتنامي"
      },
      
      // Currency region labels
      currencyRegionAfrica: "أفريقيا",
      currencyRegionMena: "الشرق الأوسط وشمال أفريقيا",
      currencyRegionGlobal: "عملات عالمية",
      
      // ==================== WELCOME PAGE ====================
      welcomePageTitle: "مرحباً بك في وصلة",
      welcomePageSubtitle: "رابط واحد، فرص متعددة",
      signUpWithGoogle: "متابعة مع جوجل",
      signUpWithEmail: "متابعة بالبريد الإلكتروني",
      alreadyAccount: "لديك حساب بالفعل؟ ",
      signInLink: "تسجيل الدخول",
      
      // ==================== ADD AD (SUDAN-FRIENDLY ARABIC) ====================
      addAdTitle: "إضافة إعلان",
      step1Title: "تفاصيل الإعلان",
      step2Title: "السعر والموقع",
      step3Title: "الوصف والصور",
      step4Title: "معاينة",
      editBtn: "تعديل",
      publishBtn: "نشر",
      previewTitle: "معاينة",
      
      // Sudan-friendly assistant messages
      assistantPriceTip: "ضع سعر مناسب عشان الناس ترد عليك بسرعة 💰",
      assistantStart: "خلينا نعمل إعلانك ✨\nابدأ باختيار الفئة المناسبة.",
      assistantPhotoTip: "الصور الواضحة بتجيب مشاهدات أكتر! 📸",
      
      // Location warnings and messages (Sudan-friendly)
      locationWarning: "من فضلك أضف موقعك عشان الناس تقدر توصل ليك بسهولة.",
      locationRequired: "لازم تضيف الموقع عشان تقدر تنشر الإعلان.",
      
      // Distance display
      distanceAway: "يبعد {{distance}} كم",
      distanceUnknown: "المسافة غير معروفة",
      
      // Image quality warnings (Sudan-friendly)
      imageQualityWarning: "الصورة ما واضحة شديد. الصور الواضحة بتجيب مشاهدات أكتر.",
      imageBlurry: "ضبابية",
      imageDark: "معتمة شديد",
      imageQualityTip: "الصور الكويسة بتجيب ردود أكتر",
      
      // Moderation flags (Arabic)
      flagMissingLocation: "الموقع ناقص",
      flagNoImages: "ما في صور",
      flagLowQualityImages: "صور غير واضحة",
      flagShortTitle: "العنوان قصير شديد",
      flagShortDescription: "الوصف قصير شديد",
      
      currencyLabel: "العملة",
      currencySdg: "الجنيه السوداني (SDG)",
      currencyUsd: "الدولار الأمريكي (USD)",
      currencyEgp: "الجنيه المصري (EGP)",
      currencyEth: "البر الإثيوبي (ETB)",
      currencySsp: "الجنيه الجنوب سوداني (SSP)",
      currencySar: "الريال السعودي (SAR)",
      currencyAed: "الدرهم الإماراتي (AED)",
      currencyEur: "اليورو (EUR)",
      currencyGbp: "الجنيه الإسترليني (GBP)",
      currencyQar: "الريال القطري (QAR)",
      currencyKwd: "الدينار الكويتي (KWD)",
      currencyBhd: "الدينار البحريني (BHD)",
      currencyOmr: "الريال العماني (OMR)",
      currencyJod: "الدينار الأردني (JOD)",
      currencyLbp: "الليرة اللبنانية (LBP)",
      currencyIqd: "الدينار العراقي (IQD)",
      currencyTry: "الليرة التركية (TRY)",
      currencyMad: "الدرهم المغربي (MAD)",
      currencyTnd: "الدينار التونسي (TND)",
      currencyDzd: "الدينار الجزائري (DZD)",
      currencyLyd: "الدينار الليبي (LYD)",
      currencyEtb: "البر الإثيوبي (ETB)",
      currencyKes: "الشلن الكيني (KES)",
      currencyUgx: "الشلن الأوغندي (UGX)",
      currencyTzs: "الشلن التنزاني (TZS)",
      currencyNgn: "النايرا النيجيرية (NGN)",
      currencyGhs: "السيدي الغاني (GHS)",
      currencyZar: "الراند الجنوب أفريقي (ZAR)",
      currencyZmw: "الكواشا الزامبية (ZMW)",
      currencyRwf: "الفرنك الرواندي (RWF)",
      currencySos: "الشلن الصومالي (SOS)",
      currencyXof: "فرنك غرب أفريقيا (XOF)",
      currencyXaf: "فرنك وسط أفريقيا (XAF)",
      currencyGroupPopular: "العملات الشائعة",
      currencyGroupMena: "الشرق الأوسط وشمال أفريقيا",
      currencyGroupAfrica: "أفريقيا",
      priceLabel: "السعر",
      pricePlaceholder: "أدخل السعر",
      discountLabel: "نسبة الخصم %",
      discountPlaceholder: "0-100",
      locationLabel: "الموقع",
      locationHint: "أدخل المدينة/المنطقة",
      locationPlaceholder: "أدخل الموقع",
      useMyLocation: "استخدم موقعي الحالي",
      pickFromMap: "اختر من الخريطة",
      gettingLocation: "جاري تحديد موقعك...",
      locationPermissionDenied: "تم رفض إذن الموقع. أدخل الموقع يدوياً.",
      locationError: "ما قدرنا نحدد موقعك. حاول تاني.",
      locationFound: "تم تحديد الموقع!",
      mapPickerHint: "أدخل الإحداثيات لتحديد موقعك",
      mapComingSoon: "الخريطة التفاعلية قريباً",
      latitude: "خط العرض",
      longitude: "خط الطول",
      
      // Preview Step
      noImagesYet: "لا توجد صور مرفوعة بعد",
      
      descLabel: "الوصف",
      descPlaceholder: "اوصف المنتج أو الخدمة بوضوح...",
      descHint: "اكتب وصف تفصيلي",
      descHelper: "اشرح الحالة، المميزات، المقاس، تفاصيل السعر، الموقع، أو تفاصيل الخدمة.",
      titleLabel: "اسم المنتج / الخدمة *",
      titlePlaceholder: "مثال: آيفون 13 برو، صالة أفراح، خدمة سباكة",
      titleHelper: "اكتبي اسمًا قصيرًا وواضحًا فقط",
      categoryLabel: "القسم",
      categoryPlaceholder: "اختر القسم",
      categoryTitle: "اختر الفئة",
      selectCategory: "اختر القسم",
      imagesLabel: "الصور",
      imagesHint: "ارفع حتى 5 صور",
      imagesTitle: "الصور",
      imagesMax: "الحد الأقصى 5",
      network: {
        offline: "لا يوجد اتصال بالإنترنت",
        restored: "تم استعادة الاتصال",
        loadError: "تعذر تحميل البيانات. أعد المحاولة",
        retry: "أعد المحاولة",
        submitFailed: "فشل الإرسال بسبب انقطاع الإنترنت. تم حفظ بياناتك مؤقتًا",
        publishFailed: "لم يتم نشر الإعلان. تحقق من الاتصال ثم أعد المحاولة",
        uploadFailed: "فشل رفع الصورة. أعد المحاولة",
      },
      cb: {
        pageTitle: "أضف كتاباً",
        pageSubtitle: "شارك الكتب والملخصات والدفاتر أو المواد الدراسية مع الطلاب.",
        uploadTitle: "رفع معاينة",
        uploadSubtitle: "أضف غلاف أو صفحات نموذجية",
        tapToUpload: "اضغط لرفع الصور",
        uploadHint: "اختياري — أضف صور معاينة للمحتوى",
        upTo5: "حتى 5 صور",
        maxSize: "الحد الأقصى 5 ميغابايت لكل صورة",
        maxImages: "يمكنك رفع حتى 5 صور",
        maxFileSize: "يجب أن يكون حجم كل صورة أقل من 5 ميغابايت",
        invalidFormat: "الصيغ المدعومة: JPG، PNG، WEBP فقط",
        uploadFailed: "فشل رفع الصورة. حاول مرة أخرى.",
        basicTitle: "التفاصيل الأساسية",
        titlePlaceholder: "مثال: ملخص فيزياء",
        authorPlaceholder: "اسم المؤلف",
        selectSubject: "اختر المادة",
        selectCondition: "اختر الحالة",
        conditionUsedExcellent: "مستعمل - ممتاز",
        conditionUsedGood: "مستعمل - جيد",
        conditionUsedFair: "مستعمل - مقبول",
        listingTitle: "إعدادات الإعلان",
        listingType: "نوع الإعلان",
        modeSell: "بيع",
        modeRent: "إيجار",
        modeFree: "مجاني",
        modeDownload: "تحميل",
        academicLevel: "المستوى الأكاديمي",
        selectLevel: "اختر المستوى",
        levelPrimary: "أساسي",
        levelSecondary: "ثانوي",
        levelUniversity: "جامعي",
        levelPostgrad: "دراسات عليا",
        contentType: "نوع المحتوى",
        selectType: "اختر النوع",
        typeTextbook: "كتاب",
        typeNotes: "ملخص دراسي",
        typePastPapers: "نماذج امتحانية",
        typeLectureNotes: "مذكرات",
        typeSummary: "ملخص دراسي",
        typeSlides: "شرائح",
        typeLabManual: "دليل المختبر",
        typeNotebook: "دفتر",
        typePdf: "ملف PDF",
        typeMagazine: "مجلة",
        typeOther: "أخرى",
        classificationTitle: "التصنيف الأكاديمي",
        classificationHelper: "هذا يساعد الطلاب في إيجاد مواد مناسبة لمستواهم أو ولايتهم أو جامعتهم.",
        universityHint: "أضف جامعة فقط إذا كانت المادة خاصة بتلك المؤسسة.",
        selectUniversity: "اختر الجامعة",
        detailsLabel: "التفاصيل",
        descPlaceholder: "صف الكتاب، المادة، الطبعة، الحالة، وأي معلومة مفيدة للطلاب.",
        contactTitle: "طريقة التواصل",
        preferredContact: "طريقة التواصل المفضلة",
        contactChat: "محادثة",
        contactPhone: "هاتف",
        contactWhatsApp: "واتساب",
        contactChatPhone: "محادثة وهاتف",
        contactChatWhatsApp: "محادثة وواتساب",
        contactEmail: "البريد الإلكتروني",
        contactHint: "اختر كل الطرق التي يمكن للمشترين التواصل معك بها",
        whatsappLabel: "رقم الواتساب",
        whatsappFallbackHint: "اتركه فارغاً لاستخدام رقم هاتفك",
        emailLabel: "البريد الإلكتروني للتواصل",
        previewBtn: "معاينة",
        previewTitle: "مراجعة الإعلان",
        previewSubtitle: "راجع التفاصيل قبل النشر.",
        editBtn: "تعديل",
        publishBtn: "نشر الإعلان",
        confirmTitle: "تأكيد النشر",
        confirmMsg: "هل أنت متأكد من نشر هذا الإعلان؟",
        confirmPublish: "تأكيد النشر",
        submitHint: "تأكد من صحة العنوان والمادة والوصف قبل النشر.",
        fixErrors: "يرجى تصحيح الأخطاء قبل المتابعة",
        validationBanner: "يرجى إكمال الحقول المطلوبة المحددة.",
        currency: "العملة",
        success: "تهانينا! تم نشر إعلانك بنجاح.",
        submitError: "فشل نشر الإعلان. يرجى المحاولة مرة أخرى.",
        errTitle: "عنوان الكتاب مطلوب",
        errAuthor: "المؤلف مطلوب",
        errSubject: "المادة مطلوبة",
        errCondition: "الحالة مطلوبة",
        errListingType: "نوع الإعلان مطلوب",
        errAcademicLevel: "المستوى الأكاديمي مطلوب",
        errContentType: "نوع المحتوى مطلوب",
        errState: "الولاية مطلوبة",
        errContactMethod: "طريقة التواصل مطلوبة",
        errPrice: "السعر مطلوب لإعلانات البيع أو الإيجار",
        errPhone: "رقم الهاتف مطلوب لطريقة التواصل هذه",
        errPhoneInvalid: "أدخل رقم هاتف صحيح (مثال: +249 9xx xxx xxx)",
        errWhatsapp: "رقم الواتساب مطلوب لطريقة التواصل هذه",
        errWhatsappInvalid: "أدخل رقم واتساب صحيح (مثال: +249 9xx xxx xxx)",
        errEmail: "بريد إلكتروني صحيح مطلوب لطريقة التواصل هذه",
      },
      imagesQualityTip: "الصور الواضحة بتجيب مشترين أكتر 📸",
      uploadImages: "رفع صور",
      next: "التالي",
      nextStep: "التالي",
      prevStep: "السابق",
      step: "خطوة",
      of: "من",
      exitTitle: "عايز تلغي التغييرات؟",
      exitMessage: "لو خرجت دلوقتي هتضيع التغييرات.",
      exitCancel: "إلغاء",
      exitConfirm: "خروج",
      previewHint: "شوف إعلانك قبل ما تنشره",
      publishSuccessTitle: "تم نشر الإعلان! ✅",
      publishSuccessMsg: "إعلانك دلوقتي ظاهر للمشترين.",
      viewAdBtn: "شوف الإعلان",
      myAdsBtn: "إعلاناتي",
      addAdStartBtn: "إضافة إعلان آخر",
      errPublishFailed: "فشل النشر. يرجى المحاولة مرة أخرى.",
      
      // Category-specific description examples
      descExampleElectronics: "آيفون 13 برو مستعمل، 256 جيجابايت، نظيف جدًا، مع الشاحن الأصلي، السعر قابل للتفاوض، القضارف.",
      descExampleVehicles: "تويوتا كورولا 2012، أوتوماتيك، بحالة جيدة، مرخصة، السعر قابل للتفاوض، القضارف.",
      descExampleRealEstate: "شقة غرفتين للإيجار، كهرباء ومياه متوفرة، قريبة من السوق، إيجار شهري، القضارف.",
      descExampleServices: "خدمة سباكة احترافية، زيارات منزلية، استجابة سريعة، أسعار مناسبة.",
      descExampleJobs: "مطعم يحتاج كاشير، دوام كامل، يفضل وجود خبرة، الراتب يحدد بعد المقابلة.",
      descExampleFashion: "عقد ذهب جديد، تصميم أنيق، مناسب للهدايا، السعر قابل للتفاوض.",
      descExampleDefault: "قدم تفاصيل عن منتجك أو خدمتك لمساعدة المشترين على اتخاذ قرار مستنير.",
      
      // ==================== AD DETAILS ====================
      contactSeller: "تواصل مع البائع",
      saveToFavorites: "حفظ في المفضلة",
      removeFromFavorites: "إزالة من المفضلة",
      description: "الوصف",
      price: "السعر",
      location: "الموقع",
      postedOn: "تاريخ النشر",
      noImageAvailable: "لا توجد صورة",
      
      // ==================== CONTACT MODAL ====================
      contactOptions: "خيارات التواصل",
      emailSeller: "البريد الإلكتروني",
      callSeller: "اتصال",
      whatsappSeller: "واتساب",
      messengerSeller: "ماسنجر",
      noContactInfo: "معلومات التواصل غير متوفرة",
      inquirySubject: "استفسار عن",
      interestedIn: "مرحباً، أنا مهتم بـ",
      
      // ==================== FEATURED ====================
      featuredAds: "إعلانات مميزة",
      noListings: "لا توجد إعلانات",
      
      // ==================== SEARCH ====================
      searchPlaceholder: "ابحث عن منتج أو خدمة",
      searchHelper: "ابحث، بع، أو احجز بمساعدة الذكاء الاصطناعي",
      
      // ==================== WALLET ====================
      walletPageTitle: "محفظتي",
      balanceLabel: "رصيدك",
      walletCoinsLabel: "عملات",
      earnTitle: "اكسب عملات",
      earnDailyTitle: "تسجيل الدخول اليومي",
      walletDailyRate: "+1 عملة",
      earnDailyDesc: "سجل دخولك يومياً لتكسب عملات مجانية",
      earnDailySuccess: "ربحت {{amount}} عملة!",
      earnDailyDone: "تم التسجيل اليوم بالفعل",
      earnProfileTitle: "أكمل ملفك الشخصي",
      earnProfileDesc: "أضف اسمك وصورتك",
      earnFirstAdTitle: "أنشر إعلانك الأول",
      earnFirstAdDesc: "أنشئ وانشر إعلاناً",
      earnRefTitle: "ادعُ صديقاً",
      earnRefDesc: "ادعُ أصدقاءك للانضمام",
      bookingFirstTitle: "قم بحجز",
      bookingFirstDesc: "احجز خدمة",
      claim: "اطلب",
      claiming: "جاري الطلب...",
      rulesTitle: "قواعد العملات",
      rules1: "يمكن استخدام العملات للإعلانات المميزة",
      rules2: "يتم تصفير التسجيل اليومي عند منتصف الليل",
      rules3: "لا يمكن تحويل العملات",
      historyTitle: "سجل المعاملات",
      viewAllHistory: "عرض الكل",
      noTransactions: "لا توجد معاملات",
      reasonReward: "مكافأة",
      reasonUsage: "استخدام",
      reasonSignup: "مكافأة الترحيب",
      reasonDaily: "تسجيل الدخول اليومي",
      reasonFirstAd: "نشر أول إعلان",
      reasonFirstBooking: "أول حجز",
      reasonProfile: "اكتمال الملف الشخصي",
      reasonReferral: "إحالة صديق",
      reasonWatchAd: "مشاهدة إعلان",
      reasonFeatured: "إعلان مميز",
      // Transaction reason codes (used by backend reason_code field)
      tx: {
        DAILY_CHECKIN: "تسجيل الدخول اليومي",
        PROFILE_COMPLETE: "إكمال الملف الشخصي",
        FIRST_AD_POST: "الإعلان الأول",
        PHONE_VERIFIED: "تأكيد رقم الهاتف",
        REFERRAL_AFTER_AD_POST: "مكافأة الإحالة",
        BOOST_HIGHLIGHT_24H: "تعزيز - تمييز",
        BOOST_TOP_CATEGORY_24H: "تعزيز - أعلى الفئة",
        BOOST_HOMEPAGE_24H: "تعزيز - الصفحة الرئيسية",
        BADGE_URGENT_7D: "شارة عاجل",
        AUTO_REFRESH_24H: "تحديث تلقائي",
        UNLOCK_ANALYTICS_7D: "فتح الإحصائيات",
        EXTRA_IMAGES_1: "صورة إضافية",
        AI_REWRITE_TITLE: "إعادة كتابة العنوان",
        AI_REWRITE_DESC: "إعادة كتابة الوصف",
        signup_bonus: "مكافأة التسجيل",
        daily_checkin: "تسجيل الدخول اليومي",
        first_ad_posted: "الإعلان الأول",
        profile_completed: "إكمال الملف الشخصي",
        referral_signup: "إحالة صديق"
      },
      
      // ==================== ACCOUNT ====================
      myAds: {
        title: "إعلاناتي",
        statusPublished: "منشور",
        statusActive: "نشط",
        statusPending: "قيد المراجعة",
        statusUnderReview: "قيد المراجعة",
        rejectionReasonLabel: "السبب",
        statusLimited: "محدود",
        statusHidden: "مخفي",
        statusRejected: "مرفوض",
        statusDraft: "مسودة",
        statusSold: "تم البيع",
        statusRemoved: "أُزيل"
      },
      favoritesPage: {
        title: "المحفوظات",
        emptyTitle: "لا توجد إعلانات محفوظة بعد",
        emptySubtitle: "اضغط على رمز القلب في أي إعلان لحفظه هنا.",
        browseCta: "تصفّح الإعلانات",
        loading: "جاري تحميل المحفوظات…",
        errorTitle: "تعذّر تحميل المحفوظات",
        errorSubtitle: "يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
        retryCta: "إعادة المحاولة",
        signInRequired: "سجّل الدخول لعرض إعلاناتك المحفوظة",
        signInCta: "تسجيل الدخول",
      },
      myBookings: "حجوزاتي",
      favorites: "المفضلة",
      noAdsYet: "لا توجد إعلانات",
      noAdsSubtitle: "ابدأ البيع بإنشاء إعلانك الأول",
      noBookingsYet: "لا توجد حجوزات",
      noBookingsSubtitle: "استكشف واحجز الخدمات",
      noFavoritesYet: "لا توجد مفضلات",
      noFavoritesSubtitle: "تصفح المتجر واحفظ ما يعجبك",
      favoritesLoading: "جاري التحميل...",
      favoritesSignInRequired: "سجّل الدخول لعرض المفضلة",
      favoritesSignInCta: "تسجيل الدخول",
      favoritesBrowseCta: "تصفح المتجر",
      deleteAdTitle: "حذف هذا الإعلان؟",
      deleteAdMessage: "لا يمكن التراجع عن هذا الإجراء.",
      deleteAdCancel: "إلغاء",
      deleteAdConfirm: "نعم، احذف",
      
      // ==================== TOAST NOTIFICATIONS ====================
      toast: {
        savedSuccess: "تم الحفظ بنجاح ✓",
        photoUpdated: "تم تحديث الصورة",
        profileUpdated: "تم تحديث الملف الشخصي",
        invalidWhatsapp: "يرجى إدخال رقم واتساب صحيح",
        invalidMessenger: "أدخل رابط ماسنجر أو اسم مستخدم صحيح (مثال: m.me/username)",
        photoUploadError: "خطأ في رفع الصورة",
        accountDeleted: "تم حذف الحساب",
        deleteAccountFailed: "فشل في حذف الحساب",
        connectionError: "خطأ في الاتصال",
        nameRequired: "الاسم مطلوب",
        invalidPhone: "صيغة رقم الهاتف غير صحيحة",
        selectImage: "يرجى اختيار صورة",
        imageTooLarge: "حجم الصورة كبير جداً (الحد الأقصى 5 ميجا)",
        comingSoon: "قريباً",
        copied: "تم النسخ!",
        linkCopied: "تم نسخ الرابط",
        shareTextCopied: "تم نسخ نص المشاركة",
        sharedSuccess: "تمت المشاركة بنجاح",
        copyFailed: "فشل النسخ",
        adPublished: "تم نشر إعلانك بنجاح",
        error: "حدث خطأ",
        // Pro PDF / Unlock features
        proPdfUnlocked: "تم فتح ميزة PDF الاحترافية! 🎉",
        paymentFailed: "فشل في بدء الدفع",
        uploadReceipt: "يرجى رفع صورة الإيصال",
        receiptSubmitted: "تم إرسال الإيصال بنجاح",
        receiptFailed: "فشل في إرسال الإيصال",
        adsFailed: "فشل في بدء الإعلانات",
        watchFailed: "فشل في تسجيل المشاهدة",
        gameFailed: "فشل في بدء اللعبة",
        sessionFailed: "فشل في تسجيل الجلسة",
        // Low bandwidth
        lowBandwidthEnabled: "تم تفعيل وضع البيانات المنخفضة",
        lowBandwidthDisabled: "تم إلغاء وضع البيانات المنخفضة",
      },
      
      // ==================== MODERATION ====================
      moderation: {
        adPosted: "تم نشر الإعلان بنجاح",
        adPending: "إعلانك قيد المراجعة",
        adApproved: "تمت الموافقة على إعلانك",
        adRejected: "تم رفض إعلانك",
        adLimited: "تم تقييد ظهور إعلانك",
        adUnderReview: "إعلانك قيد المراجعة من الإدارة",
        reportReceived: "تم استلام البلاغ. شكراً لك!",
        alreadyReported: "لقد قمت بالإبلاغ عن هذا الإعلان مسبقاً",
        forbidden: "الإجراء غير مسموح",
        networkError: "خطأ في الشبكة، حاول مرة أخرى.",
        // Report reasons
        reportSpam: "بريد مزعج",
        reportScam: "احتيال",
        reportHate: "خطاب كراهية",
        reportAdult: "محتوى للبالغين",
        reportViolence: "عنف",
        reportIllegal: "نشاط غير قانوني",
        reportOther: "أخرى",
      },
      
      // ==================== AD STATUS MESSAGES ====================
      ad: {
        pending_review: "تم إرسال إعلانك وهو قيد المراجعة",
        rejected: "تم رفض الإعلان لمخالفته السياسات"
      },
      
      // ==================== REPORT UNAVAILABLE (P1-B) ====================
      reportUnavailable: {
        title: "السلعة غير متاحة؟",
        description: "ساعدنا في الحفاظ على دقة الإعلانات بالإبلاغ عن السلع غير المتاحة",
        reasonSold: "تم البيع",
        reasonNotResponding: "البائع لا يرد",
        reasonWrongInfo: "معلومات خاطئة",
        submit: "إرسال البلاغ",
        cancel: "إلغاء",
        successToast: "شكراً—بلاغك يساعد في الحفاظ على دقة الإعلانات.",
        alreadyReported: "لقد أبلغت عن هذا الإعلان مسبقاً.",
        suspectedBadge: "قد تكون غير متاحة",
        suspectedWarning: "تم الإبلاغ عنها من المشترين • البائع قد لا يرد"
      },
      
      // ==================== AD STATUS LABELS ====================
      adStatus: {
        active: "منشور",
        draft: "مسودة",
        pendingReview: "قيد المراجعة",
        hidden: "مخفي",
        sold: "مباع",
        rejected: "مرفوض",
      },

      // ==================== ACCOUNT PAGE ====================
      account: {
        title: "حسابي",
        guest: "زائر",
        editInfo: "تعديل المعلومات",
        overview: "نظرة عامة",
        performance: "الأداء والإحصائيات",
        myAds: "إعلاناتي",
        favorites: "المحفوظات",
        wallet: "المحفظة",
        seeAll: "عرض الكل",
        // Form labels
        name: "الاسم",
        namePlaceholder: "الاسم الكامل",
        phone: "رقم الهاتف",
        whatsappPhone: "رقم الواتساب",
        whatsappHint: "يُستخدم للتواصل عبر واتساب (اتركه فارغاً لاستخدام رقم الهاتف)",
        messengerLink: "رابط ماسنجر",
        messengerHint: "رابط حسابك على فيسبوك ماسنجر (m.me/اسم المستخدم)",
        country: "الدولة",
        searchCountry: "ابحث عن دولة...",
        noCountryFound: "لا توجد نتائج",
        stateRegion: "الولاية / المنطقة",
        regionPlaceholder: "مثال: الخرطوم، كاليفورنيا",
        selectState: "اختر الولاية",
        city: "المدينة",
        optional: "اختياري",
        // Actions
        save: "حفظ",
        saving: "جارٍ الحفظ...",
        cancel: "إلغاء",
        // Status
        active: "نشط",
        pending: "معلق",
        expired: "منتهي",
        // Stats
        activeAds: "إعلانات نشطة",
        totalViews: "إجمالي المشاهدات",
        walletBalance: "رصيد المحفظة",
        responses: "الردود / التواصل",
        noneYet: "لا يوجد",
        noViewsYet: "لا مشاهدات بعد",
        noResponsesYet: "لا ردود بعد",
        // Empty states
        noAdsYet: "لا توجد إعلانات بعد",
        createFirstAd: "أنشئ إعلانك الأول وابدأ البيع",
        createAd: "إنشاء إعلان",
        postAdToSeeInsights: "انشر إعلاناً لرؤية الإحصائيات",
        // Performance
        topPerformingAd: "أفضل إعلان",
        viewsToday: "مشاهدات اليوم",
        thisWeek: "تفاعلات هذا الأسبوع",
        // Balance
        currentBalance: "الرصيد الحالي",
        topUp: "شحن",
        withdraw: "سحب",
        // Linked accounts
        linkedAccounts: "الحسابات المرتبطة",
        link: "ربط",
        // Settings
        darkMode: "الوضع الداكن",
        lowBandwidthMode: "وضع توفير البيانات",
        notifications: "الإشعارات",
        privacyPolicy: "سياسة الخصوصية",
        termsConditions: "الشروط والأحكام",
        helpSupport: "المساعدة والدعم",
        logout: "تسجيل الخروج",
        deleteAccount: "حذف الحساب",
        deleteAccountTitle: "حذف الحساب؟",
        deleteAccountMessage: "حذف حسابك نهائي. لن يكون حسابك وإعلاناتك العامة متاحين بعد الحذف. قد يتم الاحتفاظ بسجلات محدودة فقط حيثما كان ذلك ضروريًا بشكل معقول لأغراض الأمان أو منع الاحتيال أو معالجة النزاعات أو إنفاذ الشروط أو المحاسبة أو الامتثال القانوني والتنظيمي. راجع سياسة الخصوصية للتفاصيل.",
        deleteAccountPasswordPlaceholder: "أدخل كلمة المرور للتأكيد",
        deleteWrongPassword: "كلمة المرور غير صحيحة. حاول مرة أخرى.",
        delete: "حذف",
        // Account Settings (NEW)
        accountSettings: "إعدادات الحساب",
        clearAppCache: "مسح ذاكرة التخزين المؤقت",
        clearCacheConfirm: "سيؤدي هذا إلى إزالة الملفات المؤقتة المخزنة لتحرير مساحة التخزين. لن يتم حذف حسابك أو إعلاناتك أو رسائلك أو مفضلتك أو رصيد محفظتك أو إعداداتك.",
        tempStorageCleared: "تم مسح التخزين المؤقت.",
        clearCacheSuccess: "تم مسح ذاكرة التخزين المؤقت بنجاح",
        notificationSettings: "تفضيلات الإشعارات",
        pushNotifications: "إشعارات التطبيق",
        emailNotifications: "إشعارات البريد الإلكتروني",
        notifChannelsSection: "قنوات الإشعارات",
        notifTypesSection: "أنواع الإشعارات",
        listingActivity: "نشاط الإعلانات والقوائم",
        savedSearchesNotif: "البحث المحفوظ والاقتراحات",
        essentialAlerts: "تنبيهات الحساب والأمان الأساسية",
        essentialAlertsDesc: "مطلوبة لأمان الحساب وتحديثات الخدمة المهمة.",
        notifPrefsUpdated: "تم تحديث تفضيلات الإشعارات",
        notifPrefsError: "تعذر حفظ تفضيلات الإشعارات. حاول مرة أخرى.",
        adsNotifications: "إشعارات الإعلانات",
        systemAlerts: "تنبيهات النظام",
        messages: "الرسائل",
        // Language & Onboarding Settings
        language: "اللغة",
        languageArabic: "العربية",
        languageEnglish: "English",
        changeProfileType: "تغيير نوع الحساب",
        resetOnboarding: "إعادة ضبط الإعداد الأولي",
        resetOnboardingConfirm: "سيظهر لك اختيار نوع الحساب في الزيارة القادمة.",
        onboardingReset: "تم إعادة الضبط. ستظهر لك نافذة الاختيار في الزيارة القادمة.",
        // Profile Settings (NEW)
        profileSettings: "إعدادات الملف الشخصي",
        updateEmail: "تحديث البريد الإلكتروني",
        currentPassword: "كلمة المرور الحالية",
        newEmailAddress: "البريد الإلكتروني الجديد",
        verificationEmailSent: "تم إرسال رسالة تأكيد إلى بريدك الإلكتروني",
        changePassword: "تغيير كلمة المرور",
        newPassword: "كلمة المرور الجديدة",
        confirmNewPassword: "تأكيد كلمة المرور الجديدة",
        passwordUpdated: "تم تحديث كلمة المرور بنجاح",
        // Buttons & Messages
        saveChanges: "حفظ التغييرات",
        cancel: "إلغاء",
        saving: "جاري الحفظ…",
        changesSaved: "تم حفظ التغييرات بنجاح",
        saveFailed: "فشل الحفظ، يرجى المحاولة مرة أخرى",
        // Additional keys
        personalInfo: "المعلومات الشخصية",
        studentProfile: "الملف الطلابي",
        settings: "الإعدادات",
        terms: "شروط الاستخدام",
        contactUs: "اتصل بنا",
        accountActions: "إجراءات الحساب",
        signOut: "تسجيل الخروج",
        signOutTitle: "تسجيل الخروج؟",
        signOutMessage: "هل أنت متأكد من رغبتك في تسجيل الخروج من حسابك؟",
        editProfile: "تعديل الملف الشخصي",
        accountType: "نوع الحساب",
        memberSince: "عضو منذ {{date}}",
        // Ad status labels
        recall: "سحب الإعلان",
        edit: "تعديل",
        draft: "مسودة",
        published: "منشور",
        limited: "مقيّد",
        underReview: "قيد المراجعة",
        rejected: "مرفوض",
        generalUser: "مستخدم عام"
      },
      
      // ==================== ADS MESSAGES ====================
      ads: {
        recalled: "تم سحب الإعلان للتعديل",
        deleted: "تم حذف الإعلان",
        published: "تم نشر إعلانك بنجاح",
        flagged: "تم تقييد إعلانك لمراجعته",
        rejected: "تم رفض إعلانك بسبب مخالفة السياسات",
        updated: "تم تحديث الإعلان وإرساله للمراجعة",
        approved: "تمت الموافقة على الإعلان ونشره",
        mustRecallFirst: "يجب سحب الإعلان قبل التعديل",
        deleteNotAllowed: "يمكن حذف الإعلانات (مسودة/مرفوض) فقط"
      },
      
      // ==================== PRICE DROP ====================
      priceDrop: {
        badge: "تخفيض",
        previousPrice: "كان",
        dropPercent: "خصم {{percent}}%",
      },

      // ==================== ERRORS ====================
      errors: {
        bannedUser: "تم حظرك من نشر الإعلانات",
        networkError: "خطأ في الشبكة. يرجى المحاولة مرة أخرى.",
        unauthorized: "غير مصرح لك بإجراء هذا الإجراء"
      },
      
      // ==================== REPORTS ====================
      reports: {
        received: "تم استلام البلاغ. شكرًا لك.",
        alreadyReported: "لقد أبلغت عن هذا الإعلان مسبقًا",
        submitReport: "إرسال البلاغ",
        reportReason: "سبب البلاغ",
        reportDetails: "تفاصيل إضافية"
      },
      
      // ==================== AUTH ====================
      welcomeTitle: "مرحباً بك في وصلة",
      welcomeSubtitle: "رابط واحد، فرص متعددة",
      signInWithGoogle: "متابعة مع جوجل",
      signInWithEmail: "متابعة بالبريد الإلكتروني",
      orDivider: "أو",
      emailLabel: "البريد الإلكتروني",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      passwordLabel: "كلمة المرور",
      password: "كلمة المرور",
      passwordPlaceholder: "أدخل كلمة المرور",
      confirmPasswordLabel: "تأكيد كلمة المرور",
      confirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
      passwordsDoNotMatch: "كلمتا المرور غير متطابقتين",
      nameLabel: "الاسم الكامل",
      namePlaceholder: "أدخل اسمك الكامل",
      signIn: "تسجيل الدخول",
      signUp: "إنشاء حساب",
      createAccount: "إنشاء حساب",
      alreadyHaveAccount: "لديك حساب بالفعل؟ ",
      dontHaveAccount: "ليس لديك حساب؟ ",
      forgotPassword: "نسيت كلمة المرور؟",
      // ── إعادة تعيين كلمة المرور ─────────────────────────────────
      resetStep1Sub: "أدخل البريد الإلكتروني المرتبط بحسابك في وصلة. سنرسل لك رمزاً مكوناً من 6 أرقام لإعادة تعيين كلمة المرور.",
      resetSendCode: "إرسال رمز إعادة التعيين",
      resetAlreadyHaveCode: "لدي رمز بالفعل",
      resetStep2Title: "إعادة تعيين كلمة المرور",
      resetStep2Sub: "أدخل الرمز المكوّن من 6 أرقام واختر كلمة مرور جديدة.",
      resetStep2SubSent: "أرسلنا رمزاً مكوّناً من 6 أرقام إلى {{email}} (إذا كان مسجّلاً). صلاحية الرمز 15 دقيقة. إذا تأخر البريد، تواصل مع الدعم.",
      resetCodeLabel: "الرمز (6 أرقام)",
      resetCodeInvalid: "أدخل الرمز المكوّن من 6 أرقام",
      resetNewPassword: "كلمة المرور الجديدة",
      resetNewPasswordPlaceholder: "10 أحرف على الأقل",
      resetConfirmPassword: "تأكيد كلمة المرور الجديدة",
      resetConfirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
      resetPasswordPolicy: "10 أحرف على الأقل، مع أحرف كبيرة وصغيرة ورقم ورمز خاص.",
      resetConfirmCta: "تحديث كلمة المرور",
      resetBackToEmail: "استخدام بريد إلكتروني مختلف",
      resetSuccess: "تم تحديث كلمة المرور بنجاح",
      resetSuccessTitle: "تم تحديث كلمة المرور",
      resetSuccessSub: "يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
      resetGoToLogin: "العودة إلى تسجيل الدخول",
      resetRequestFailed: "تعذّر إرسال رمز إعادة التعيين الآن. حاول مرة أخرى أو تواصل مع الدعم.",
      resetConfirmFailed: "رمز غير صالح أو منتهي. الرجاء طلب رمز جديد.",
      resetResendCode: "إعادة إرسال الرمز",
      resetResendIn: "إعادة الإرسال خلال {{count}} ثانية",
      resetResendFailed: "تعذّر إعادة إرسال الرمز الآن. الرجاء الانتظار قليلاً ثم المحاولة.",
      guestSignInPrompt: "سجّل الدخول لحفظ المفضلة، والتواصل مع البائعين بسرعة، ورؤية عروض مخصصة لك.",
      profilePhoto: "صورة الملف الشخصي",
      uploading: "جاري الرفع...",
      showPassword: "إظهار كلمة المرور",
      hidePassword: "إخفاء كلمة المرور",
      loginBtn: "تسجيل الدخول",
      signupSubmit: "إنشاء حساب",
      
      // ==================== SIGNUP SUCCESS ====================
      signupSuccessTitle: "أهلاً بك!",
      signupSuccessSubtitle: "لقد حصلت على {coins} عملات للبدء!",
      signupSuccessCta: "ابدأ الاستكشاف",
      onboardingNext: "التالي",
      
      // ==================== BOOKING HUB ====================
      bookingHubTitle: "مركز الحجوزات",
      bookingCategories: "فئات الحجز",
      carRentals: "تأجير سيارات",
      doctorAppointments: "مواعيد الأطباء",
      hallReservations: "حجز قاعات",
      otherServices: "خدمات أخرى",
      bookCar: "حجز سيارة",
      bookDoctor: "حجز طبيب",
      bookHall: "حجز قاعة",
      bookService: "حجز خدمة",
      selectDate: "اختر التاريخ",
      selectTime: "اختر الوقت",
      selectLocation: "اختر الموقع",
      addNotes: "ملاحظات إضافية",
      bookNow: "احجز الآن",
      confirmBooking: "تأكيد الحجز",
      bookingDetails: "تفاصيل الحجز",
      bookingConfirmed: "تم تأكيد الحجز!",
      
      // ==================== SHOP ====================
      shopTitle: "المتجر",
      priceRange: "نطاق السعر",
      minPrice: "الحد الأدنى",
      maxPrice: "الحد الأقصى",
      sortBy: "ترتيب حسب",
      newest: "الأحدث",
      cheapest: "الأرخص",
      expensive: "الأغلى",
      priceLowToHigh: "السعر: من الأقل إلى الأعلى",
      priceHighToLow: "السعر: من الأعلى إلى الأقل",
      applyFilters: "تطبيق",
      clearFilters: "مسح التصفية",
      noAdsFound: "لا توجد إعلانات",
      tryDifferentFilters: "حاول تعديل معايير البحث",

      // ==================== SHOP PAGE (namespaced) ====================
      shopPage: {
        searchPlaceholder: "ابحث في المنتجات…",
        recentSearches: "عمليات البحث الأخيرة",
        categories: "الفئات",
        changeCategory: "تغيير الفئة",
        filterTitle: "فلترة المتجر",
        apply: "تطبيق",
        clearAll: "مسح الكل",
        sortByLabel: "الترتيب",
        sortNewest: "الأحدث",
        sortPriceLow: "السعر: الأقل",
        sortPriceHigh: "السعر: الأعلى",
        sortPopular: "الأكثر شعبية",
        sortPriceLowShort: "السعر: الأقل",
        sortPriceHighShort: "السعر: الأعلى",
        sortPopularShort: "الأكثر شعبية",
        sortRelevant: "الأكثر صلة",
        sortSalaryLow: "الراتب: الأقل",
        sortSalaryHigh: "الراتب: الأعلى",
        sortAreaSize: "المساحة",
        sortYearNewest: "الأحدث سنة",
        priceRangeLabel: "نطاق السعر",
        min: "من",
        max: "إلى",
        locationLabel: "الموقع",
        cityPlaceholder: "اسم المدينة",
        showDistance: "عرض المسافة",
        gettingLocation: "جارٍ تحديد الموقع...",
        disableDistance: "إيقاف المسافة",
        enableDistance: "تفعيل المسافة",
        locationDetected: "تم تحديد موقعك",
        distanceOn: "المسافة مفعلة",
        clear: "مسح",
        filteredResults: "نتائج مفلترة",
        browseListings: "تصفح الإعلانات",
        listingsCount: "{{count}} منتج",
        listingsShowing: "عرض {{shown}} من {{total}}",
        noProductsFound: "لا توجد منتجات",
        tryDifferentSearch: "جرب تصفية مختلفة أو كلمة بحث أخرى",
        showAllProducts: "عرض جميع المنتجات",
        ladiesHubBadge: "قسم السيدات",
        loadMore: "تحميل المزيد",
        recentlyViewed: "شوهدت مؤخراً",
        geoNotSupported: "الموقع غير مدعوم على هذا الجهاز",
        locationSuccess: "تم تحديد موقعك بنجاح",
        locationDenied: "تم رفض إذن الموقع",
        locationUnavailable: "تعذر تحديد الموقع",
        locationTimeout: "انتهت مهلة تحديد الموقع",
      },

      // ==================== RECENTLY VIEWED (shared Home + Shop) ====================
      recently: {
        recentlyViewed: "شوهدت مؤخراً",
        clear: "مسح",
        confirmClear: "اضغط مرة أخرى للمسح",
      },

      // ==================== LOCATION SELECTOR (iter322) ====================
      locationSelector: {
        title: "اختر الموقع",
        searchPlaceholder: "ابحث عن مدينة أو منطقة أو دولة",
        useCurrentLocation: "استخدم موقعي الحالي",
        locating: "جاري تحديد الموقع…",
        gpsDetected: "تم اكتشاف:",
        confirmTip: "اضغط تطبيق للتأكيد، أو عدّل بالأسفل.",
        permissionHint: "يستخدم تطبيق وصلة موقعك لعرض الإعلانات القريبة ومساعدة البائعين على إضافة موقع دقيق للإعلان. يمكنك أيضاً اختيار الموقع يدوياً.",
        publicOnlyHelper: "أضف موقعاً عاماً فقط. لا تكتب تفاصيل السكن الخاصة.",
        allCountries: "الكل",
        selectCountry: "اختر الدولة",
        selectRegion: "اختر الولاية / الإقليم",
        selectCity: "اختر المحلية / المقاطعة / المنطقة",
        selectArea: "اختر المدينة / البلدة / القرية",
        cityTownTypePlaceholder: "اكتب المدينة / البلدة / القرية",
        cityTownTypeHint: "لا تجد بلدتك؟ اكتبها هنا.",
        extraDetailsLabel: "تفاصيل إضافية للموقع (اختياري)",
        extraDetailsPlaceholder: "مثلاً: الحي، السوق، المول، الشارع، نقطة الاستلام، معلم بارز",
        crumbCountry: "الدولة",
        crumbRegion: "الولاية / الإقليم",
        crumbLocality: "المحلية / المقاطعة / المنطقة",
        crumbCityTown: "المدينة / البلدة / القرية",
        completeRequired: "يرجى إكمال الموقع العام حتى يتمكن المشترون من العثور على الإعلانات القريبة.",
        apply: "تطبيق الموقع",
        clear: "مسح الموقع",
        cancel: "إلغاء",
        noMatch: "لا توجد نتائج",
        chosen: "الموقع:",
        notSet: "لم يتم التحديد",
        change: "تغيير",
      },

      // ==================== SELLER REVIEWS & RATINGS (iter317) ====================
      reviews: {
        noReviewsYet: "لا توجد تقييمات بعد",
        countLabel_one: "تقييم واحد",
        countLabel_two: "تقييمان",
        countLabel_few: "{{count}} تقييمات",
        countLabel_many: "{{count}} تقييماً",
        countLabel_other: "{{count}} تقييم",
        countLabel: "{{count}} تقييم",
        sheetTitle: "تقييمات البائع",
        positivePct: "إيجابي",
        anonymousBuyer: "مشتري",
        report: "إبلاغ",
        rateSellerCta: "قيّم البائع",
        leaveReviewCta: "أضف تقييم",
        beTheFirstToReview: "كن أول من يقيّم هذا البائع",
        modalTitle: "قيّم هذا البائع",
        starsLabel: "تقييمك",
        commentLabel: "تعليق (اختياري)",
        commentPlaceholder: "شارك تفاصيل تجربتك مع البائع (اختياري)…",
        positiveTagsLabel: "النقاط الإيجابية",
        negativeTagsLabel: "المخاوف",
        submit: "إرسال التقييم",
        submitting: "جاري الإرسال…",
        errorRating: "يرجى اختيار تقييم بالنجوم من 1 إلى 5.",
        errorAuth: "يرجى تسجيل الدخول لإضافة تقييم.",
        errorGate: "تواصل مع هذا البائع أولاً قبل كتابة تقييم.",
        errorGeneric: "تعذّر إرسال تقييمك. يرجى المحاولة مرة أخرى.",
        gate: {
          selfReview: "لا يمكنك تقييم إعلاناتك الخاصة.",
          notAuthenticated: "يرجى تسجيل الدخول لإضافة تقييم.",
          needsInteraction: "تواصل مع هذا البائع أولاً قبل كتابة تقييم.",
        },
        tag: {
          responsive_seller: "تواصل جيد",
          accurate_description: "المنتج كما هو موصوف",
          fair_price: "سعر عادل",
          fast_response: "استجابة سريعة",
          safe_transaction: "معاملة آمنة",
          not_responsive: "تواصل سيئ",
          wrong_description: "المنتج ليس كما وُصف",
          suspicious_behavior: "سلوك مريب",
        },
      },

      // ==================== POST AD PAGE (namespaced) ====================
      postAd: {
        createYourListing: "أنشئ إعلانك",
        accurateDetails: "قدّم تفاصيل دقيقة لجذب المشترين الجادين وزيادة ظهور إعلانك.",
        stepOf: "الخطوة {{current}} من {{total}}",
        stepDetails: "التفاصيل",
        stepPrice: "السعر",
        stepPhotos: "الصور",
        stepReview: "مراجعة",
        postingInLadiesHub: "إعلان في قسم السيدات",
        startWithCategory: "ابدأ باختيار الفئة",
        categoryGuidance: "اختيار الفئة الصحيحة يحسّن ظهور إعلانك وثقة المشترين.",
        next: "التالي",
        back: "السابق",
        preview: "معاينة",
        exampleLabel: "مثال:",
        contactInfoOptional: "بيانات التواصل (اختياري)",
        // iter314 — Required-contact wording (multi-country).
        contactInfoTitle: "بيانات التواصل",
        contactInfoRequiredHelper: "أضف رقم هاتف أو واتساب ليتمكن المشترون من التواصل معك.",
        contactRequiredEmpty: "يرجى إدخال رقم هاتف أو واتساب حتى يتمكن المشترون من التواصل معك.",
        contactRequiredInvalid: "يرجى إدخال رقم هاتف صحيح مع رمز الدولة.",
        contactInfoDesc: "أضف طرق التواصل ليتمكن المشترون من الوصول إليك بسهولة",
        phoneNumber: "رقم الهاتف",
        phonePlaceholder: "مثال: 0912345678",
        useSameForWhatsapp: "استخدم نفس الرقم للواتساب",
        whatsappNumber: "رقم واتساب",
        whatsappDiffPlaceholder: "رقم واتساب مختلف",
        messengerLinkOptional: "رابط فيسبوك/ماسنجر (اختياري)",
        messengerPlaceholder: "اسم المستخدم أو رابط الصفحة",
        messengerExample: "مثال: username أو https://facebook.com/yourpage",
        emailOptional: "البريد الإلكتروني (اختياري)",
        noImagesAdded: "لا توجد صور مضافة بعد",
        images: "الصور",
        maxImages: "الحد الأقصى 5 صور",
        photosSelected: "تم اختيار {{count}} صور",
        choosePhotos: "اختر الصور",
        maxPhotos: "الحد الأقصى 5 صور",
        phoneDetails: "تفاصيل الهاتف",
        carDetails: "تفاصيل السيارة",
        propertyDetails: "تفاصيل العقار",
        beds: "غرف",
        baths: "حمام",
        listingQuality: "جودة الإعلان",
        clearTitle: "عنوان واضح",
        goodDescription: "وصف كافٍ",
        threePhotos: "3+ صور",
        locationCheck: "الموقع",
        priceCheck: "السعر",
        publishing: "جارٍ النشر...",
        publish: "نشر الإعلان",
        editBtn: "تعديل",
        savingDraft: "جارٍ الحفظ...",
        saveAsDraft: "حفظ كمسودة",
        saveDraftTitle: "حفظ كمسودة؟",
        saveDraftDesc: "يمكنك إكماله لاحقًا من إعلاناتي \u2190 المسودات.",
        saveDraftBtn: "حفظ كمسودة",
        continueEditing: "متابعة التعديل",
        leaveWithoutSaving: "مغادرة بدون حفظ",
        continueDraftTitle: "متابعة المسودة؟",
        draftListing: "مسودة إعلان",
        continueDraftBtn: "متابعة المسودة",
        draftCountMsg: "لديك {{count}} مسودة. هل تريد المتابعة أو عرض المسودات؟",
        viewDrafts: "عرض المسودات",
        startNewAd: "إعلان جديد",
        draftStepOf: "الخطوة {{current}} من {{total}}",
        allowLocation: "السماح بالموقع",
        locationRationale: "نحتاج موقعك لعرض مدينتك تلقائياً. يمكنك تغيير ذلك لاحقاً.",
        notNow: "ليس الآن",
        continueBtn: "متابعة",
        change: "تغيير",
        useMyLocation: "استخدم موقعي",
        gettingLocationShort: "جاري التحديد...",
        published: "تم النشر",
        adLiveDesc: "إعلانك متاح الآن للجميع!",
        publishedToLadies: "تم نشر إعلانك في قسم السيدات",
        backToLadiesHub: "العودة لقسم السيدات",
        loginFirst: "يرجى تسجيل الدخول أولاً",
        draftSaved: "تم حفظ المسودة",
        draftSaveFailed: "فشل حفظ المسودة",
        locationNotAvailableBrowser: "الموقع غير متاح في هذا المتصفح",
        locationNotAvailable: "الموقع غير متاح",
        locationPermDenied: "تم رفض الإذن. يمكنك تفعيله من إعدادات الهاتف.",
        locationUnavailable: "تعذر تحديد الموقع. حاولي مرة أخرى.",
        locationTimeoutMsg: "انتهت المهلة. حاولي مرة أخرى.",
        locationErrorMsg: "حدث خطأ في تحديد الموقع",
        coordsSaved: "تعذر تحديد اسم الموقع. تم حفظ الإحداثيات فقط.",
        nearLandmark: "(بالقرب من {{landmark}})",
        viewImage: "عرض الصورة {{num}}",
        locationFound: "تم تحديد الموقع ✓",
        qualityTitleShort: "العنوان قصير جداً",
        qualityDescShort: "الوصف قصير جداً",
        qualityNoImages: "أضف صورة واحدة على الأقل",
        qualityNoLocation: "أضف الموقع",
        qualityNoPrice: "أضف السعر",
        qualityNoCategory: "اختر الفئة",
        qualityImprove: "يرجى تحسين الإعلان قبل النشر",
        duplicateWarning: "قد يكون لديك إعلان مشابه نشط بالفعل",
        spamRejected: "تم رفض الإعلان - يحتوي على محتوى مشبوه",
        rateLimited: "أنت تنشر بسرعة كبيرة. حاول لاحقاً",
        publishFailed: "فشل النشر",
        sessionExpired: "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
        accountBanned: "تم حظر حسابك. لا يمكنك نشر إعلانات.",
        accessDenied: "غير مسموح. يرجى تسجيل الدخول مرة أخرى.",
        dailyLimitReached: "وصلت إلى حد النشر اليومي. سيتم إعادة ضبط الحد بعد منتصف الليل.",
        imageUploadFailed: "فشل رفع الصور: {{message}}",
        publishedToLadiesHub: "تم نشر إعلانك في قسم السيدات",
        descHintShoes: "أكتبي حالة الحذاء، المقاس، اللون، والسبب للبيع",
        descHintBags: "أكتبي نوع الشنطة، الخامة، الحالة",
        descHintGold: "أكتبي العيار، الوزن، الحالة",
        descHintPerfume: "أكتبي نوع العطر، الحجم، هل مستخدم أم جديد",
        descHintLadiesDefault: "أكتبي وصف تفصيلي للمنتج، الحالة، وأي تفاصيل مهمة",
        // Enhanced UX translations
        estimatedTime: "يستغرق ~30 ثانية",
        almostDone: "تقريباً انتهيت!",
        draftSavedIndicator: "تم حفظ المسودة",
        photoGuidanceTitle: "نصائح للصور لبيع أفضل",
        photoGuidanceTip1: "استخدم صور واضحة ومضاءة جيداً",
        photoGuidanceTip2: "صور من الأمام والخلف والتفاصيل",
        photoGuidanceTip3: "أضف 3 صور على الأقل",
        photoGuidanceTip4: "تجنب الصور المشوشة",
        coverImageHint: "الصورة الأولى ستكون الغلاف",
        moveUp: "نقل لأعلى",
        moveDown: "نقل لأسفل",
        visibilityHint: "الإعلانات بـ 3+ صور تحقق نتائج أفضل",
        visibilityHintTitle: "العناوين الواضحة تساعد المشترين في العثور على إعلانك",
        // General category hints
        descHintVehicles: "اذكر السنة، الكيلومترات، نوع المحرك، والحالة",
        descHintPhones: "اذكر الماركة، سعة التخزين، الحالة، والملحقات",
        descHintFashion: "اذكر المقاس، الماركة، الخامة، والحالة",
        descHintElectronics: "اذكر الماركة، الموديل، الحالة، وحالة الضمان",
        descHintFurniture: "اذكر الأبعاد، الخامة، الحالة، ومعلومات التركيب",
        descHintDefault: "اذكر الحالة، الماركة إن وجدت، والتفاصيل المهمة",
      },

      // ==================== ACCOUNT PAGE EXTRA KEYS ====================
      accountExtra: {
        favorites: "المفضلة",
        myAdsTab: "إعلاناتي",
        noFavoritesDesc: "لا توجد إعلانات في المفضلة بعد",
        tapHeartToSave: "اضغط على أيقونة القلب لحفظ الإعلانات",
        sold: "مباع",
        available: "متاح",
        removedFromFavorites: "تمت الإزالة من المفضلة",
        removeFromFavorites: "إزالة من المفضلة",
        growthTips: "نصائح لتحسين الأداء",
        getStarted: "ابدأ الآن!",
        createFirstAdTip: "أنشئ إعلانك الأول للوصول للمشترين",
        boostYourAds: "روّج لإعلاناتك",
        boostDesc: "وصّل إعلانك لعدد أكبر من الناس",
        shareOnFacebook: "مشاركة على فيسبوك",
        shareOnFacebookDesc: "انشر في مجموعات البيع والشراء",
        connected: "متصل",
        notConnected: "غير متصل",
        unlinkBtn: "إلغاء",
        settingsTitle: "الإعدادات",
        editProfileMenu: "تعديل الملف الشخصي",
        changePasswordMenu: "تغيير كلمة المرور",
        updateEmailMenu: "تحديث البريد الإلكتروني",
        languageMenu: "اللغة",
        shareAnonymousData: "مشاركة بيانات الاستخدام المجهولة",
        aboutWassla: "عن وصلة",
        moderationDashboard: "لوحة الإشراف",
        helpAnalyticsMenu: "تحليلات المساعدة",
        versionLabel: "الإصدار {{version}}",
        copyrightLabel: "\u00A9 {{year}} وصلة. جميع الحقوق محفوظة.",
        unsavedChangesTitle: "تجاهل التغييرات؟",
        unsavedChangesDesc: "لديك تغييرات غير محفوظة في الملف الشخصي. هل تريد تجاهلها؟",
        keepEditing: "متابعة التعديل",
        countryChangeTitle: "تحديث الموقع؟",
        countryChangeDesc: "قد لا تتطابق الولاية/المنطقة والمدينة المحفوظتان مع الدولة الجديدة. هل تريد الاحتفاظ بهما أم مسحهما؟",
        keepLocationBtn: "الاحتفاظ بهما",
        clearLocationBtn: "مسحهما",
        discardBtn: "تجاهل",
        logoutConfirmMsg: "هل أنت متأكد من رغبتك في تسجيل الخروج؟",
        deletingAccount: "جارٍ الحذف...",
        currentPasswordLabel: "كلمة المرور الحالية",
        newPasswordLabel: "كلمة المرور الجديدة",
        confirmNewPasswordLabel: "تأكيد كلمة المرور الجديدة",
        enterCurrentPassword: "أدخل كلمة المرور الحالية",
        enterNewPassword: "أدخل كلمة المرور الجديدة (8 أحرف على الأقل)",
        reenterNewPassword: "أعد إدخال كلمة المرور الجديدة",
        enterNewEmail: "أدخل البريد الإلكتروني الجديد",
        currentEmailPrefix: "البريد الإلكتروني الحالي: ",
        updateEmailNoteLabel: "ملاحظة:",
        updateEmailNote: "كلمة المرور الحالية مطلوبة لتأكيد هذا التغيير. سيصبح البريد الإلكتروني الجديد هو بريد تسجيل الدخول فورًا. سيتم إرسال رسالة تأكيد بمجرد تفعيل التحقق عبر البريد الإلكتروني.",
        clearCacheBtn: "مسح الذاكرة المؤقتة",
        boostAdLabel: "عزّز الإعلان",
        noPublishedToBoost: "لا توجد إعلانات منشورة لتعزيزها",
        adMustBePublished: "يجب نشر الإعلان أولاً",
        shareListingsText: "شاهد إعلاناتي على وصلة",
        copiedMsg: "تم النسخ!",
        copyFailedMsg: "فشل النسخ",
        allFieldsRequired: "جميع الحقول مطلوبة",
        passwordMinLength: "كلمة المرور الجديدة يجب أن تكون 8 أحرف على الأقل",
        passwordsMismatch: "كلمات المرور غير متطابقة",
        passwordChangedOk: "تم تغيير كلمة المرور بنجاح",
        passwordChangeFailed: "فشل تغيير كلمة المرور",
        invalidEmailMsg: "البريد الإلكتروني غير صالح",
        emailSameAsCurrent: "البريد الإلكتروني الجديد مطابق للحالي",
        emailUpdateFailed: "فشل تحديث البريد الإلكتروني",
        clearCacheFailed: "فشل مسح ذاكرة التخزين المؤقت",
        adRecalledOk: "تم سحب الإعلان بنجاح",
        recallFailed: "فشل سحب الإعلان",
        adDeletedOk: "تم حذف الإعلان",
        deleteFailed: "فشل حذف الإعلان",
        connectionError: "خطأ في الاتصال",
        recallAdTitle: "سحب الإعلان؟",
        recallAdMsg: "سيتم إزالة الإعلان \"{{title}}\" من القوائم العامة فوراً. يمكنك تعديله ونشره مرة أخرى لاحقاً.",
        yesRecall: "نعم، سحب",
        deleteAdTitle: "حذف الإعلان؟",
        deleteAdMsg: "هل أنت متأكد من حذف \"{{title}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
        linkFacebook: "ربط حساب فيسبوك",
        linkInstagram: "ربط حساب انستقرام",
        facebookDesc: "أدخل رابط حسابك على فيسبوك أو اسم المستخدم",
        facebookPlaceholder: "facebook.com/yourname أو @yourname",
        instagramDesc: "أدخل اسم المستخدم أو رابط حسابك على انستقرام",
        instagramPlaceholder: "@username أو instagram.com/username",
        linkAccountBtn: "ربط الحساب",
        linkingMsg: "جارٍ الربط...",
        unlinkAccountTitle: "إلغاء ربط الحساب؟",
        unlinkDesc: "سيتوقف الربط والمزامنة مع هذا الحساب. يمكنك إعادة الربط في أي وقت.",
        unlinkingMsg: "جارٍ إلغاء الربط...",
        unlinkConfirmBtn: "إلغاء الربط",
        fieldRequired: "هذا الحقل مطلوب",
        invalidFacebook: "أدخل رابط ملف فيسبوك صحيح أو اسم المستخدم",
        invalidInstagram: "أدخل اسم مستخدم انستقرام صحيح أو رابط الملف الشخصي",
        invalidFacebookShare: "روابط المشاركة والمنشورات غير مدعومة — الصق رابط ملفك الشخصي (facebook.com/yourname)",
        invalidInstagramShare: "روابط المنشورات والريلز غير مدعومة — أدخل اسم المستخدم أو رابط ملفك الشخصي",
        socialNoSpaces: "يجب ألا يحتوي على مسافات أو الرمز |",
        failedToLink: "فشل ربط الحساب",
        failedToUnlink: "فشل إلغاء الربط",
        lowBandwidthEnabled: "تم تفعيل وضع توفير البيانات - سيتم تقليل جودة الصور والحركات",
        lowBandwidthDisabled: "تم إيقاف وضع توفير البيانات",
        updateSettingFailed: "فشل تحديث الإعداد",
        analyticsDisabled: "تم إيقاف مشاركة بيانات الاستخدام",
        analyticsEnabled: "تم تفعيل مشاركة بيانات الاستخدام المجهولة",
        saveError: "خطأ في الحفظ، حاول مرة أخرى",
        changingMsg: "جارٍ التغيير...",
        cancelBtn: "إلغاء",
        statusActive: "نشط",
        statusDraft: "مسودة",
        statusPending: "قيد المراجعة",
        statusUnderReview: "قيد المراجعة",
        rejectionReasonLabel: "السبب",
        statusLimited: "محدود",
        statusHidden: "مخفي",
        statusRejected: "مرفوض",
        statusExpired: "منتهي",
        statusSold: "تم البيع",
        statusRemoved: "أُزيل",
        whatsappHint: "يُستخدم للتواصل عبر واتساب (اتركه فارغاً لاستخدام رقم الهاتف)",
        messengerHint: "ضع رابط حسابك على فيسبوك ماسنجر (m.me/اسم_المستخدم)",
        regionHint: "أدخل اسم الولاية أو المنطقة",
        regionPlaceholder: "مثال: الخرطوم، دبي",
        cityOptional: "اختياري",
      },

      // ==================== ERRORS ====================
      errNetwork: "خطأ في الاتصال. يرجى المحاولة مرة أخرى.",
      errNetworkOneLine: "خطأ في الاتصال. حاول مجدداً.",
      errNoInternet: "لا يوجد اتصال بالإنترنت. تحقق من الشبكة.",
      errServerError: "حدث خطأ في الخادم. حاول لاحقاً.",
      errAuthGeneric: "فشل تسجيل الدخول. حاول مرة أخرى.",
      errInvalidCredentials: "اسم المستخدم أو كلمة المرور غير صحيحة. حاول مرة أخرى.",
      errEmailExists: "البريد الإلكتروني مستخدم بالفعل",
      errPasswordMismatch: "كلمات المرور غير متطابقة",
      errRequiredField: "هذا الحقل مطلوب",
      errInvalidEmail: "صيغة البريد الإلكتروني غير صحيحة",
      errPasswordTooShort: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
      errUploadFailed: "فشل الرفع. يرجى المحاولة مرة أخرى.",
      errAccountDeleted: "تم حذف هذا الحساب نهائياً ولا يمكن استعادته.",
      errInvalidOtp: "رمز الاستعادة غير صالح أو منتهي الصلاحية",
      errEmailRequired: "البريد الإلكتروني مطلوب",
      errGeneric: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      authEmailRequired: "يرجى إدخال البريد الإلكتروني",
      authEmailInvalid: "يرجى إدخال بريد إلكتروني صحيح",
      authPasswordRequired: "يرجى إدخال كلمة المرور",
      authNameRequired: "يرجى إدخال الاسم",
      authLoginError: "تعذر تسجيل الدخول. تحقق من البريد الإلكتروني وكلمة المرور.",
      authCooldown: "تم إيقاف المحاولة مؤقتاً بسبب تكرار المحاولات. حاول مرة أخرى بعد قليل.",
      signingIn: "جاري تسجيل الدخول...",
      forgotPasswordInfo: "إعادة تعيين كلمة المرور قريباً. تواصل مع الدعم للمساعدة.",
      
      // ==================== ACCOUNT RECOVERY ====================
      accountRecoveryTitle: "استعادة حسابك",
      accountRecoverySubtitle: "حسابك مجدول للحذف. أدخل بريدك الإلكتروني لاستلام رمز الاستعادة واستعادة حسابك.",
      enterOtpSubtitle: "أدخل الرمز المكون من 6 أرقام المرسل إلى بريدك الإلكتروني",
      sendRecoveryCode: "إرسال رمز الاستعادة",
      recoveryCode: "رمز الاستعادة",
      restoreAccount: "استعادة الحساب",
      recoveryOtpSent: "تم إرسال رمز الاستعادة إلى بريدك الإلكتروني",
      accountRestored: "تم استعادة الحساب بنجاح!",
      didntReceiveCode: "لم تستلم الرمز؟",
      resendIn: "إعادة الإرسال في",
      resendCode: "إعادة إرسال الرمز",
      changeEmail: "تغيير البريد الإلكتروني",
      backToLogin: "العودة لتسجيل الدخول",
      
      // Account Banned
      accountBannedTitle: "الحساب محظور",
      accountBannedSubtitle: "تم حظر حسابك بسبب مخالفة السياسات.",
      banReason: "السبب",
      submitAppeal: "تقديم استئناف",
      submit: "إرسال",
      cancel: "إلغاء",
      goToHome: "الذهاب للرئيسية",
      
      // Account Suspended
      accountSuspendedTitle: "الحساب معلق",
      accountSuspendedSubtitle: "تم تعليق حسابك مؤقتاً.",
      suspensionReason: "السبب",
      suspensionEnds: "ينتهي التعليق في",
      
      // ==================== LADIES HUB - MANUAL APPROVAL ====================
      ladiesHub: {
        title: "قسم السيدات",
        goldApprovalNotice: "إعلانات الذهب تتطلب موافقة إدارية قبل النشر",
        brandedCosmeticsNotice: "مستحضرات التجميل الأصلية تتطلب التحقق قبل النشر",
        pendingApproval: "في انتظار الموافقة",
        pendingApprovalDesc: "إعلانك قيد المراجعة من قبل فريقنا. عادة ما تستغرق 24-48 ساعة.",
        approvalRequired: "يتطلب موافقة",
        brandType: "نوع الماركة",
        brandOriginal: "أصلي / ماركات",
        brandCommercial: "تجاري",
        mostPopular: "الأكثر شعبية في قسم السيدات",
        verifiedBoutique: "متجر موثّق"
      },
      
      // ==================== AI ASSISTANT ====================
      aiAssistant: "المساعد الذكي",
      aiWelcome: "مرحباً! كيف يمكنني مساعدتك اليوم؟",
      aiPlaceholder: "اسألني أي شيء...",
      aiSend: "إرسال",
      close: "إغلاق",
      
      // AI Assistant (nested for modal)
      assistant: {
        title: "المساعد الذكي",
        hi: "مرحباً 👋",
        help: "كيف يمكنني مساعدتك اليوم؟",
        prompt: "ماذا تريد أن تفعل؟",
        typeMessage: "اكتب رسالة...",
        send: "إرسال",
        askAssistant: "اسأل المساعد الذكي",
        thinking: "جاري التفكير..."
      },
      
      // ==================== STUDENT CENTRAL ====================
      studentHub: {
        title: "قسم الطلاب",
        tabs: {
          books: "الكتب",
          opportunities: "الفرص"
        },
        cta: {
          postBook: "أضف كتاباً",
          postOpportunity: "أضف فرصة",
          completeProfile: "أكمل ملف الطالب"
        },
        search: {
          booksPlaceholder: "ابحث باسم الكتاب أو المؤلف…",
          oppsPlaceholder: "ابحث بالمسمى الوظيفي أو اسم الجهة…"
        },
        empty: {
          books: "لا توجد كتب مطابقة.",
          opps: "لا توجد فرص مطابقة.",
          recommendations: "أكمل ملفك لعرض توصيات مناسبة لك."
        },
        recommended: "موصى بها لك",
        matchScore: "التوافق",
        viewAll: "عرض الكل",
        filters: "التصفية",
        clearFilters: "مسح الفلاتر",
        applyFilters: "تطبيق",
        showFilters: "إظهار الفلاتر",
        hideFilters: "إخفاء الفلاتر"
      },
      books: {
        mode: { 
          sell: "شراء", 
          rent: "إيجار", 
          sell_or_rent: "شراء أو إيجار",
          all: "الكل"
        },
        condition: { 
          new: "جديد", 
          used_good: "مستعمل - جيد", 
          used_ok: "مستعمل - مقبول",
          all: "أي حالة"
        },
        rentUnit: { 
          day: "لليوم", 
          week: "للأسبوع", 
          month: "للشهر" 
        },
        fields: {
          title: "اسم الكتاب",
          author: "المؤلف",
          subject: "التخصص/المادة",
          condition: "الحالة",
          price: "السعر",
          currency: "العملة",
          location: "الموقع",
          university: "الجامعة",
          description: "الوصف",
          images: "الصور",
          contactMethod: "طريقة التواصل",
          rentUnit: "فترة الإيجار",
          rentPrice: "سعر الإيجار"
        },
        contact: {
          chat: "محادثة",
          phone: "هاتف",
          both: "محادثة وهاتف"
        },
        createTitle: "أضف كتاباً",
        editTitle: "تعديل الكتاب",
        detailsTitle: "تفاصيل الكتاب",
        seller: "البائع",
        postedOn: "تاريخ النشر",
        contactSeller: "تواصل مع البائع",
        saveBook: "حفظ الكتاب",
        unsaveBook: "إزالة من المحفوظات",
        report: "الإبلاغ عن الإعلان"
      },
      opps: {
        type: { 
          job: "وظيفة", 
          volunteer: "تطوع", 
          internship: "تدريب",
          all: "كل الأنواع"
        },
        orgType: { 
          ngo: "منظمة", 
          civil_society: "مجتمع مدني", 
          company: "شركة",
          all: "كل الجهات"
        },
        locationType: { 
          onsite: "حضوري", 
          remote: "عن بُعد", 
          hybrid: "هجين",
          all: "أي موقع"
        },
        paid: {
          yes: "مدفوع",
          no: "غير مدفوع",
          all: "مدفوع وغير مدفوع"
        },
        fields: {
          title: "المسمى",
          orgName: "الجهة",
          type: "النوع",
          orgType: "نوع الجهة",
          location: "الموقع",
          locationType: "طبيعة العمل",
          educationLevel: "المستوى التعليمي",
          majors: "التخصصات",
          skills: "المهارات",
          interests: "الاهتمامات",
          paid: "مدفوع",
          stipend: "الراتب/البدل",
          deadline: "آخر موعد",
          apply: "طريقة التقديم",
          applyLink: "رابط التقديم",
          duration: "المدة",
          description: "الوصف",
          requirements: "المتطلبات"
        },
        actions: { 
          apply: "تقديم", 
          save: "حفظ", 
          unsave: "إلغاء الحفظ",
          chat: "محادثة",
          report: "إبلاغ"
        },
        createTitle: "أضف فرصة",
        editTitle: "تعديل الفرصة",
        detailsTitle: "تفاصيل الفرصة",
        poster: "نشرت بواسطة",
        postedOn: "تاريخ النشر",
        deadlineLabel: "آخر موعد للتقديم",
        applyNow: "قدّم الآن",
        applyExternal: "التقديم في الموقع الخارجي",
        expired: "منتهية",
        noDeadline: "بدون موعد محدد"
      },
      profile: {
        studentTitle: "ملف الطالب",
        fields: {
          university: "الجامعة",
          major: "التخصص",
          educationLevel: "المستوى التعليمي",
          skills: "المهارات",
          interests: "الاهتمامات",
          preferredTypes: "الفرص المفضلة",
          location: "الموقع"
        },
        save: "حفظ الملف",
        saving: "جاري الحفظ...",
        saved: "تم حفظ الملف!",
        educationLevels: {
          high_school: "ثانوية",
          bachelor: "بكالوريوس",
          master: "ماجستير",
          phd: "دكتوراه"
        },
        skillsHint: "أضف مهاراتك (افصل بينها بفواصل)",
        interestsHint: "أضف اهتماماتك (افصل بينها بفواصل)"
      },
      cvBuilder: {
        title: "منشئ السيرة الذاتية",
        subtitle: "أنشئ سيرتك الذاتية المجانية في دقائق",
        selectTemplate: "اختر قالباً",
        selectType: "اختر نوع السيرة الذاتية",
        types: {
          professional: "سيرة ذاتية احترافية",
          normal: "سيرة ذاتية عادية"
        },
        templates: {
          professional: "احترافي",
          simple: "بسيط",
          academic: "أكاديمي"
        },
        sections: {
          personal: "المعلومات الشخصية وجهات الاتصال",
          summary: "الملخص",
          employment: "سجل التوظيف",
          experience: "الخبرة العملية",
          objective: "الهدف الوظيفي",
          education: "الخلفية التعليمية",
          skills: "المهارات والكفاءات",
          languages: "اللغات",
          certifications: "الشهادات والدورات",
          projects: "المشاريع",
          volunteering: "التطوع",
          references: "المراجع"
        },
        fields: {
          fullName: "الاسم الكامل",
          email: "البريد الإلكتروني",
          phone: "رقم الهاتف",
          state: "المدينة / الولاية",
          linkedin: "رابط لينكدإن",
          summary: "ملخص مهني موجز...",
          objective: "هدفك الوظيفي أو غايتك...",
          jobTitle: "المسمى الوظيفي",
          company: "اسم الشركة",
          startDate: "تاريخ البداية",
          endDate: "تاريخ النهاية",
          present: "حتى الآن",
          current: "أعمل هنا حالياً",
          bullets: "المسؤوليات والإنجازات",
          addBullet: "إضافة نقطة",
          notes: "ملاحظات / وصف",
          notesPlaceholder: "وصف موجز لدورك ومسؤولياتك...",
          degree: "المؤهل",
          major: "التخصص",
          institution: "اسم المؤسسة التعليمية",
          skill: "مهارة",
          language: "اللغة",
          level: "مستوى الإتقان",
          certName: "اسم الشهادة",
          issuer: "الجهة المانحة",
          certStart: "تاريخ الحصول",
          certEnd: "تاريخ الانتهاء",
          year: "السنة",
          projectName: "اسم المشروع",
          description: "الوصف",
          link: "الرابط",
          role: "الدور",
          organization: "المنظمة",
          referencesNote: "تُقدَّم عند الطلب",
          refFullName: "الاسم الكامل",
          refInstitution: "المؤسسة",
          refPost: "المنصب / الوظيفة",
          refAddress: "العنوان",
          refEmail: "البريد الإلكتروني",
          refPhone: "رقم الهاتف"
        },
        degrees: {
          diploma: "دبلوم",
          bachelor: "بكالوريوس",
          master: "ماجستير",
          doctorate: "دكتوراه",
          professor: "بروفيسور",
          other: "أخرى"
        },
        levels: {
          native: "لغة أم",
          fluent: "طلاقة",
          advanced: "متقدم",
          intermediate: "متوسط",
          basic: "مبتدئ"
        },
        actions: {
          addExperience: "إضافة خبرة",
          addEmployment: "إضافة خبرة عملية",
          addEducation: "إضافة تعليم",
          addSkill: "إضافة مهارة",
          addLanguage: "إضافة لغة",
          addCertification: "إضافة شهادة",
          addReference: "إضافة مرجع",
          addProject: "إضافة مشروع",
          addVolunteering: "إضافة تطوع",
          remove: "إزالة",
          save: "حفظ السيرة الذاتية",
          preview: "معاينة",
          exportPDF: "تصدير PDF",
          downloadCV: "تحميل السيرة الذاتية",
          saving: "جاري الحفظ...",
          exporting: "جاري إنشاء PDF..."
        },
        autoSaved: "تم الحفظ التلقائي للمسودة",
        autoSaveError: "تعذر حفظ المسودة",
        preview: {
          title: "معاينة السيرة الذاتية",
          unnamed: "سيرة ذاتية بدون اسم",
          printPdf: "طباعة / حفظ PDF"
        },
        messages: {
          saved: "تم حفظ السيرة الذاتية بنجاح!",
          exported: "تم إنشاء PDF! جاري التحميل...",
          pdfSaved: "تم حفظ ملف PDF بنجاح.",
          pdfError: "تعذّر إنشاء ملف PDF. يرجى المحاولة مرة أخرى.",
          error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
          fillRequired: "يرجى إدخال اسمك للمتابعة.",
          insufficientCoins: "تحتاج {{cost}} عملة، لديك {{balance}}",
          bankakRequested: "تم إرسال طلب التصدير! سنخطرك عند الموافقة.",
          networkError: "خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى."
        },
        validation: {
          fullNameRequired: "الاسم الكامل مطلوب",
          invalidEmail: "يرجى إدخال بريد إلكتروني صحيح",
          jobTitleRequired: "الوظيفة #{{num}}: المسمى الوظيفي مطلوب",
          companyRequired: "الوظيفة #{{num}}: اسم الشركة مطلوب",
          startDateRequired: "الوظيفة #{{num}}: تاريخ البداية مطلوب",
          institutionRequired: "التعليم #{{num}}: اسم المؤسسة مطلوب",
          degreeRequired: "التعليم #{{num}}: المؤهل مطلوب",
          refNameRequired: "المرجع #{{num}}: الاسم الكامل مطلوب",
          moreErrors: "و {{count}} مشكلة أخرى",
          serverError: "فشل التحقق من الخادم",
          exportRequiresComplete: "يرجى إكمال جميع الحقول المطلوبة قبل التصدير"
        },
        payment: {
          title: "تصدير سيرتك الذاتية",
          subtitle: "اختر طريقة الدفع لتحميل سيرتك الذاتية بدون علامة مائية",
          viewPreview: "عرض المعاينة (مع علامة مائية)",
          previewNote: "المعاينة تتضمن علامة مائية. ادفع لإزالتها.",
          payWithCoins: "ادفع بعملات وصلة",
          payWithBankak: "ادفع عبر التحويل البنكي (بنكك)",
          yourBalance: "رصيدك",
          payAndDownload: "ادفع وحمّل",
          earnCoins: "اكسب المزيد من العملات",
          bankName: "البنك",
          accountName: "اسم الحساب",
          bankakNote: "حوّل المبلغ وسنوافق على طلبك خلال 24 ساعة.",
          requestExport: "إرسال طلب الدفع"
        },
        unlock: {
          title: "سيرتك الذاتية جاهزة!",
          message: "افتح سيرتك الذاتية الاحترافية للتحميل.",
          freeTitle: "مجاني",
          freeSub: "الأفضل للبدء",
          freeTemplate: "قالب أساسي واحد",
          freeWatermark: "تصدير PDF مع علامة مائية",
          freeBuilder: "منشئ سيرة ذاتية أساسي",
          freeBtn: "ابدأ مجاناً",
          proTitle: "احترافي",
          proSub: "الأفضل للتقديمات الجادة",
          proPrice: "10 عملات",
          proTemplates: "+5 قوالب احترافية",
          proNoWatermark: "بدون علامة مائية",
          proCover: "منشئ خطاب تغطية",
          proAts: "نصائح ATS",
          proBtn: "فتح الآن",
          yourBalance: "رصيدك",
          earnCoins: "اكسب المزيد من العملات",
          watermarkText: "Made with Wassla",
          comingSoon: "هذه الميزة قادمة قريباً",
          coinInfoTitle: "عملاتك",
          coinInfoDesc: "العملات تفتح ميزات Pro: قوالب احترافية، تصدير نظيف، ونصائح ATS.",
          coinInfoCta: "ترقية إلى Pro"
        },
        empty: {
          title: "ابدأ إنشاء سيرتك الذاتية",
          description: "أنشئ سيرة ذاتية تبرز مهاراتك وخبراتك."
        },
        helperText: "أكمل بياناتك لإنشاء سيرتك الذاتية المجانية.",
        subtitle: "أنشئ سيرتك الذاتية المجانية في دقائق"
      },
      subjects: {
        medicine: "الطب",
        pharmacy: "الصيدلة",
        dentistry: "طب الأسنان",
        nursing: "التمريض",
        engineering: "الهندسة",
        civil_eng: "الهندسة المدنية",
        electrical_eng: "الهندسة الكهربائية",
        mechanical_eng: "الهندسة الميكانيكية",
        computer_science: "علوم الحاسوب",
        it: "تقنية المعلومات",
        data: "علم البيانات",
        ai: "الذكاء الاصطناعي",
        business: "إدارة الأعمال",
        accounting: "المحاسبة",
        economics: "الاقتصاد",
        marketing: "التسويق",
        law: "القانون",
        education: "التربية",
        arts: "الفنون والتصميم",
        languages: "اللغات والترجمة",
        agriculture: "الزراعة",
        environment: "علوم البيئة",
        math: "الرياضيات",
        physics: "الفيزياء",
        chemistry: "الكيمياء",
        biology: "الأحياء",
        other: "أخرى"
      },
      universities: {
        uofk: "جامعة الخرطوم",
        sust: "جامعة السودان للعلوم والتكنولوجيا",
        alzaiem: "جامعة الزعيم الأزهري",
        oiu: "جامعة أم درمان الإسلامية",
        ahfad: "جامعة الأحفاد للبنات",
        neelain: "جامعة النيلين",
        karary: "جامعة كرري",
        uofg: "جامعة الجزيرة",
        rsu: "جامعة البحر الأحمر",
        dongola: "جامعة دنقلا",
        other: "أخرى"
      },
      report: {
        // Main CTA button
        cta: "الإبلاغ عن هذا الإعلان",
        cta_sub: "مباع، معلومات غير صحيحة، أو مخالفة للسياسات",
        // Sheet content
        title: "الإبلاغ عن هذا الإعلان",
        subtitle: "ساعدنا في الحفاظ على وصلة منصة آمنة ودقيقة.",
        section_availability: "مشكلة في التوفر",
        section_policy: "مخالفة أو مشكلة تتعلق بالسلامة",
        // Availability reasons
        reason_sold: "تم البيع",
        reason_not_responding: "البائع لا يرد",
        reason_wrong_info: "معلومات غير صحيحة",
        // Policy reasons
        reason_scam: "احتيال أو نصب",
        reason_prohibited: "منتج مخالف",
        reason_spam: "إعلان مكرر أو مزعج",
        reason_offensive: "محتوى مسيء",
        reason_other: "أخرى",
        // Form
        details_label: "تفاصيل إضافية (اختياري)",
        details_ph: "أضف معلومات إضافية لمساعدتنا في مراجعة الإعلان.",
        // Evidence upload
        evidence_title: "صورة إثبات (اختياري)",
        evidence_sub: "لقطة شاشة أو صورة تساعدنا في المراجعة بسرعة.",
        add_photo: "إضافة صورة",
        evidence_limit: "حد أقصى صورتان • JPG/PNG",
        evidence_max_reached: "يمكنك إرفاق صورتين كحد أقصى.",
        remove_photo: "إزالة الصورة",
        // Acknowledgment
        ack_text: "أؤكد أن هذا البلاغ صحيح. البلاغات الكاذبة قد تؤدي إلى إيقاف الحساب.",
        // Actions
        cancel: "إلغاء",
        continue: "متابعة",
        back: "رجوع",
        send: "إرسال البلاغ",
        sending: "جارٍ الإرسال...",
        uploading: "جارٍ الرفع...",
        submit: "إرسال البلاغ",
        done: "تم",
        // Confirmation
        confirm_title: "تأكيد البلاغ",
        confirm_reason: "السبب",
        confirm_details: "التفاصيل",
        confirm_evidence: "الإثبات",
        false_warning: "البلاغات الكاذبة قد تؤدي إلى إيقاف حسابك في وصلة.",
        // Success
        success_title: "تم إرسال البلاغ",
        // Feedback
        thanks: "شكرًا لك. سيقوم فريقنا بمراجعة هذا الإعلان.",
        reported: "تم الإبلاغ",
        already_reported: "لقد أبلغت عن هذا الإعلان مسبقاً.",
        // Legacy keys for backward compatibility
        reason: "السبب",
        details: "تفاصيل إضافية",
        reasons: {
          spam: "محتوى مضلل أو مزعج",
          inappropriate: "محتوى غير لائق",
          scam: "احتيال مشتبه به",
          duplicate: "إعلان مكرر",
          other: "أخرى"
        },
        submitted: "تم إرسال البلاغ",
        submitting: "جاري الإرسال..."
      },
      // ==================== PROFILE TYPE PICKER ====================
      profilePicker: {
        title: "شنو الوصف البناسبك؟",
        subtitle: "اختر الخيار الذي يصفك بشكل أفضل.\nيمكنك تغييره لاحقًا في أي وقت.",
        heroTitle: "مرحباً بك في وصلة",
        heroSubtitle: "اشترِ وبِع، قدّم خدماتك، واكتشف تجربة سوق موثوقة في مكان واحد.",
        supportingLine: "اختر الطريقة التي تريد استخدام وصلة بها — ويمكنك تغييرها لاحقاً.",
        trustTitle: "تجربة موثوقة للتسوق والإعلانات",
        trustSubline: "بسيطة • واضحة • مباشرة",
        slogan: "رابط واحد، إمكانات متعددة",
        selectLabel: "اختر نوع الحساب",
        confirm: "تأكيد",
        later: "لاحقاً",
        types: {
          seller: {
            label: "بيع منتج",
            desc: "انشر إعلانك، زد ظهوره، وأوصل إلى مشترين حقيقيين."
          },
          buyer: {
            label: "تصفح وتسوق",
            desc: "اكتشف المنتجات، تواصل مع البائعين، واعثر على ما تحتاجه."
          },
          student: {
            label: "الطالب",
            desc: "الوصول إلى الكتب وأدوات السيرة الذاتية في مكان واحد."
          },
          service: {
            label: "قدّم خدمة",
            desc: "اعرض خدماتك وأوصل إلى عملاء جدد."
          },
          professional: {
            label: "احترافي",
            desc: "ابنِ حضورك ووسّع وصولك إلى المزيد من العملاء."
          },
          general: {
            label: "مستخدم عام",
            desc: "تصفح السوق وكل الأقسام."
          }
        }
      },
      // ==================== ROLES ====================
      roles: {
        selectTitle: "ما الذي يصفك أفضل؟",
        selectSubtitle: "اختر الخيار الذي يصفك بشكل أفضل.\nيمكنك تغييره لاحقًا في أي وقت.",
        seller: "أبيع شيء",
        sellerDesc: "انشر إعلانات، عزّز ظهورك، وأوصل إلى آلاف المشترين",
        buyer: "تصفح وتسوّق",
        buyerDesc: "اكتشف العروض، تواصل مع البائعين، واعثر على ما تحتاجه",
        student: "طالب",
        studentDesc: "الوصول إلى الكتب والملخصات وأدوات السيرة الذاتية.",
        service: "أقدم خدمة",
        serviceDesc: "اعرض خدماتك المهنية واجذب العملاء",
        professional: "محترف",
        professionalDesc: "انشر إعلانات، أدِر قوائمك، وتواصل مع المشترين",
        general: "مستخدم عام",
        generalDesc: "تصفح ونشر الإعلانات واستكشاف السوق",
        // Backward compat for old DB values
        trader: "أبيع شيء",
        traderDesc: "انشر إعلانات، عزّز ظهورك، وأوصل إلى آلاف المشترين",
        service_provider: "أقدم خدمة",
        service_providerDesc: "اعرض خدماتك المهنية واجذب العملاء",
        individual: "مستخدم عام",
        individualDesc: "تصفح ونشر الإعلانات واستكشاف السوق",
        skipForNow: "تخطي الآن",
        changeNote: "يمكنك تغيير نوع حسابك في أي وقت من إعدادات الملف الشخصي",
        accountType: "نوع الحساب",
        changeRole: "تغيير نوع الحساب",
        accountTypeUpdated: "تم تحديث نوع الحساب بنجاح"
      },
      // ==================== LEGAL PAGES ====================
      legal: {
        privacyTitle: "سياسة الخصوصية",
        termsTitle: "شروط الاستخدام",
        contactTitle: "اتصل بنا",
        lastUpdated: "آخر تحديث",
        privacy: {
          section1Title: "خصوصيتك مهمة",
          section1Content: "في وصلة، نحترم خصوصيتك ونلتزم بحماية معلوماتك الشخصية. نجمع فقط البيانات الضرورية لتقديم أفضل تجربة سوق لك.",
          section2Title: "البيانات التي نجمعها",
          section2Content: "نجمع المعلومات التي تقدمها مباشرة، مثل اسمك وبريدك الإلكتروني وإعلاناتك. كما نجمع بيانات الاستخدام لتحسين خدماتنا وتقديم توصيات مخصصة.",
          section3Title: "كيف نستخدم بياناتك",
          section3Content: "تُستخدم بياناتك فقط لتحسين تجربتك على وصلة. لا نبيع معلوماتك الشخصية لأطراف ثالثة. تُستخدم البيانات لإدارة الحساب ودعم العملاء وتحسين الخدمات.",
          section4Title: "حقوقك",
          section4Content: "لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها في أي وقت. يمكنك طلب حذف الحساب من إعدادات حسابك. الحذف نهائي؛ وقد يتم الاحتفاظ بسجلات محدودة فقط حيثما كان ذلك ضروريًا بشكل معقول — راجع سياسة الخصوصية."
        },
        terms: {
          section1Title: "قبول الشروط",
          section1Content: "باستخدام وصلة، فإنك توافق على شروط الاستخدام هذه. إذا كنت لا توافق على أي جزء من هذه الشروط، يرجى عدم استخدام خدماتنا.",
          section2Title: "مسؤوليات المستخدم",
          section2Content: "المستخدمون مسؤولون عن المحتوى الذي ينشرونه. يجب أن تكون جميع الإعلانات دقيقة وقانونية. المحتوى المحظور يشمل العناصر غير القانونية والإعلانات الاحتيالية والمحتوى الذي ينتهك القوانين المحلية.",
          section3Title: "الأنشطة المحظورة",
          section3Content: "لا يجوز للمستخدمين استخدام وصلة لأغراض غير قانونية، أو المعاملات الحكومية دون إذن، أو أي أنشطة قد تضر بالمستخدمين الآخرين. نحتفظ بالحق في إزالة المحتوى وتعليق الحسابات التي تنتهك هذه الشروط.",
          section4Title: "تغييرات الخدمة",
          section4Content: "تحتفظ وصلة بالحق في تعديل أو إيقاف الخدمات في أي وقت. يشكل الاستخدام المستمر للمنصة بعد التغييرات قبولاً للشروط الجديدة."
        },
        contact: {
          subtitle: "نحب أن نسمع منك!",
          subject: "الموضوع",
          message: "الرسالة",
          send: "إرسال الرسالة",
          thankYou: "شكراً لك!",
          successMessage: "تم إرسال رسالتك. سنرد عليك عبر البريد الإلكتروني.",
          backToAccount: "العودة للحساب"
        }
      },
      
      // ==================== ADMIN MODERATION ====================
      admin: {
        title: "لوحة الإشراف",
        refresh: "تحديث",
        loading: "جاري التحميل...",
        accessDenied: "الوصول مرفوض",
        notAuthorized: "ليس لديك صلاحية الوصول لهذه الصفحة",
        exitAdmin: "خروج",
        back: "رجوع",
        
        // Stats
        totalUsers: "إجمالي المستخدمين",
        pendingReview: "قيد المراجعة",
        pendingReports: "بلاغات معلقة",
        lowTrustUsers: "مستخدمون بثقة منخفضة",
        bannedUsers: "مستخدمون محظورون",
        
        // Tabs
        overview: "نظرة عامة",
        ads: "الإعلانات",
        opportunities: "الفرص",
        books: "الكتب",
        payments: "المدفوعات",
        reviewQueue: "قائمة المراجعة",
        reports: "البلاغات",
        users: "المستخدمون",
        blocklist: "قائمة الحظر",
        
        // Overview
        dashboardOverview: "نظرة عامة على لوحة التحكم",
        userStats: "إحصائيات المستخدمين",
        listingStats: "إحصائيات القوائم",
        opportunitiesStats: "إحصائيات الفرص",
        booksStats: "إحصائيات الكتب",
        reportsStats: "إحصائيات البلاغات",
        paymentsStats: "إحصائيات المدفوعات",
        paymentStats: "إحصائيات المدفوعات",
        new7d: "جديد (آخر 7 أيام)",
        new30d: "جديد (آخر 30 يوم)",
        adsApproved: "إعلانات مقبولة",
        adsPending: "إعلانات قيد المراجعة",
        adsRejected: "إعلانات مرفوضة",
        adsHidden: "إعلانات مخفية",
        reviewAds: "مراجعة الإعلانات",
        reviewOpportunities: "مراجعة الفرص",
        reviewPayments: "مراجعة المدفوعات",
        reviewReports: "مراجعة البلاغات",
        
        // Review Queue
        pendingAds: "إعلانات معلقة",
        pendingOpportunities: "فرص معلقة",
        pendingBooks: "كتب معلقة",
        pendingPayments: "مدفوعات معلقة",
        approvedPayments: "مدفوعات مقبولة",
        rejectedPayments: "مدفوعات مرفوضة",
        noPaymentsPending: "لا توجد مدفوعات معلقة",
        noPendingAds: "لا توجد إعلانات معلقة",
        allClear: "كل شيء تمام! لا توجد إعلانات تحتاج مراجعة.",
        adOwner: "صاحب الإعلان",
        owner: "المالك",
        riskScore: "درجة الخطورة",
        reportsCount: "البلاغات",
        createdAt: "تاريخ الإنشاء",
        amount: "المبلغ",
        method: "الطريقة",
        viewReceipt: "عرض الإيصال",
        approved: "موافق عليه",
        pending: "معلق",
        rejected: "مرفوض",
        totalReports: "إجمالي البلاغات",
        
        // Ad Actions
        approve: "موافقة",
        limit: "تقييد",
        reject: "رفض",
        hide: "إخفاء",
        unhide: "إظهار",
        viewDetails: "عرض التفاصيل",
        requestEdit: "طلب تعديل",
        
        // Success/Error Messages
        approveSuccess: "تمت الموافقة بنجاح",
        approveFailed: "فشل في الموافقة",
        rejectSuccess: "تم الرفض بنجاح",
        rejectFailed: "فشل في الرفض",
        requestEditSuccess: "تم إرسال طلب التعديل للمستخدم",
        requestEditFailed: "فشل في إرسال طلب التعديل",
        hideSuccess: "تم الإخفاء بنجاح",
        unhideSuccess: "تم الإظهار بنجاح",
        hideFailed: "فشل في الإخفاء/الإظهار",
        
        // Reject Modal
        rejectAd: "رفض الإعلان",
        rejectPayment: "رفض المدفوعة",
        rejectReason: "سبب الرفض",
        rejectReasonRequired: "يرجى تقديم سبب للرفض",
        rejectReasonPlaceholder: "اشرح سبب رفض هذا الإعلان...",
        paymentRejectReasonPlaceholder: "يرجى تقديم سبب (مثل: إيصال غير صالح، مبلغ غير صحيح)",
        confirmReject: "تأكيد الرفض",
        
        // Payment Actions
        paymentApproved: "تم التحقق من المدفوعة بنجاح!",
        paymentRejected: "تم رفض المدفوعة",
        paymentApproveFailed: "فشل في الموافقة على المدفوعة",
        paymentRejectFailed: "فشل في رفض المدفوعة",
        
        // Ad Details Drawer
        adDetails: "تفاصيل الإعلان",
        images: "الصور",
        description: "الوصف",
        moderationHistory: "سجل الإشراف",
        relatedReports: "البلاغات المتعلقة",
        noHistory: "لا يوجد سجل إشراف",
        noReportsForAd: "لا توجد بلاغات لهذا الإعلان",
        
        // Reports
        noReports: "لا توجد بلاغات",
        allReportsResolved: "تم حل جميع البلاغات.",
        reporter: "المُبلّغ",
        reportReason: "السبب",
        reportNote: "ملاحظة",
        reportStatus: "الحالة",
        markValid: "صالح",
        markInvalid: "غير صالح",
        dismiss: "إغلاق",
        resolved: "تم الحل",
        takeAction: "اتخاذ إجراء",
        
        // Users
        searchUsers: "البحث عن مستخدم بالإيميل أو الاسم...",
        trustScore: "نقاط الثقة",
        joinDate: "تاريخ الانضمام",
        sortBy: "ترتيب حسب",
        ascending: "تصاعدي",
        descending: "تنازلي",
        adsCount: "الإعلانات",
        rejectedCount: "مرفوضة",
        userReports: "البلاغات",
        ban: "حظر",
        unban: "إلغاء الحظر",
        resetTrust: "إعادة الثقة",
        viewUserAds: "عرض الإعلانات",
        adminBadge: "مشرف",
        bannedBadge: "محظور",
        
        // Banned Users
        bannedUsersList: "قائمة المحظورين",
        noBannedUsers: "لا يوجد مستخدمون محظورون",
        banReason: "سبب الحظر",
        bannedOn: "تاريخ الحظر",
        
        // Blocklist
        blockedWords: "الكلمات المحظورة",
        hardBlock: "حظر صارم (فوري)",
        softBlock: "حظر ناعم (تنبيه)",
        addWord: "إضافة",
        newWord: "كلمة جديدة...",
        softLabel: "ناعم (تنبيه)",
        hardLabel: "صارم (حظر)",
        
        // Actions
        actionSuccess: "تم تنفيذ الإجراء بنجاح",
        actionFailed: "فشل تنفيذ الإجراء",
        
        // Status
        status: {
          published: "منشور",
          limited: "مقيّد",
          under_review: "قيد المراجعة",
          rejected: "مرفوض",
          draft: "مسودة"
        },
        
        // Trust levels
        trust: {
          high: "ثقة عالية",
          medium: "ثقة متوسطة",
          low: "ثقة منخفضة",
          critical: "حرجة"
        }
      },
      
      // ==================== AVAILABILITY STATUS ====================
      availability: {
        available: "متاح",
        reserved: "محجوز",
        sold: "تم البيع",
        expired: "منتهي",
        unavailable: "غير متاح",
        hidden: "مخفي",
        // Status hints
        stale_hint: "قد لا يكون متاحاً",
        updated_ago: "آخر تحديث قبل {{n}} أيام",
        reserved_until: "محجوز حتى {{date}}",
        not_available_banner: "هذا الإعلان غير متاح.",
        // Action labels
        mark_sold: "تم البيع",
        mark_reserved: "محجوز",
        mark_available: "متاح",
        renew: "تجديد",
        hide: "إخفاء",
        // Durations
        duration_24h: "٢٤ ساعة",
        duration_48h: "٤٨ ساعة",
        duration_7d: "٧ أيام",
        // Confirmations
        confirm_mark_sold: "هل تريد تحديد هذا المنتج كمباع؟",
        confirm_hide: "هل تريد إخفاء هذا الإعلان؟",
        renewed_success: "تم تجديد الإعلان بنجاح",
        marked_sold: "تم تحديده كمباع",
        marked_reserved: "تم تحديده كمحجوز",
        marked_available: "تم تحديده كمتاح"
      },

      // ==================== AUTO-MIGRATED i18n KEYS ====================
      // --- acco ---
      "authReferralBonus": "مدعو من صديق! ستحصل على 5 عملات عند التسجيل",
      "messagesStartChat": "ابدأ محادثة من زر التواصل في أي إعلان",
      // --- PublishSuccessScreen ---
      "ps.title": "تم النشر بنجاح!",
      "ps.subtitle": "إعلانك متاح الآن للجميع.",
      "ps.liveMsg1": "تم نشر إعلانك ويظهر الآن في السوق.",
      "ps.liveMsg2": "يمكن للمشترين التواصل معك مباشرة.",
      "ps.statsViews": "مشاهدات",
      "ps.statsInterested": "مهتمين",
      "ps.statsMessages": "رسائل",
      "ps.tip": "نصيحة: أضف واتساب والموقع لتحصل على مشترين أسرع.",
      "ps.viewAd": "عرض الإعلان",
      "ps.backLadies": "العودة لقسم السيدات",
      "ps.backHome": "العودة للرئيسية",
      "ps.postAnother": "نشر إعلان جديد",
      "ps.postAnotherHint": "كل إعلان جديد يزيد فرص البيع.",
      "ps.shareTitle": "شارك إعلانك للوصول إلى المشترين أسرع",
      "ps.waShare": "مشاركة واتساب",
      "ps.copyLink": "نسخ الرابط",
      "ps.copied": "تم نسخ الرابط!",
      "ps.safety": "يتم فحص الإعلانات تلقائياً لحماية المستخدمين من الاحتيال.",
      "ps.pendingTitle": "قيد المراجعة",
      "ps.pendingBody": "تم نشر إعلانك وقد تتم مراجعته لحماية المستخدمين.",
      "ps.rewardStreak": "+1 إعلان • سلسلة: {{streak}} أيام",
      "ps.editAd": "تعديل الإعلان",
      "ps.sellFaster": "لبيع أسرع:",
      "ps.tipWhatsApp": "أضف واتساب",
      "ps.tipPhotos": "أضف 3 صور على الأقل",
      "ps.tipDescription": "اكتب وصفاً واضحاً",
      "ps.keepPosting": "استمر في النشر لتنمية متجرك.",
      "ps.tipPrice": "ضع سعراً تنافسياً",
      "acco.completeYourProfileNameAddress": "أكمل ملفك الشخصي (الاسم، العنوان، الصورة) للحصول على +2 عملة!",
      "acco.connectionErrorCheckYourInternet": "خطأ في الاتصال - تحقق من اتصالك بالإنترنت",
      "acco.couldNotSaveDataEndpoint": "تعذر حفظ البيانات (المسار غير موجود). الرجاء تحديث التطبيق.",
      "acco.currentEmail": "البريد الإلكتروني الحالي: ",
      "acco.failedToUpdateProfileType": "فشل تحديث نوع الحساب",
      "acco.sessionExpiredPleaseLogIn": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
      "acco.someFieldsAreInvalidPlease": "بعض الحقول غير صحيحة. الرجاء مراجعة البيانات.",
      "acco.text": "English",
      "acco.youDoNotHavePermission": "ليس لديك صلاحية لتنفيذ هذه العملية.",
      "acco.youEarned2CoinsFor": "حصلت على +2 عملة لإكمال ملفك الشخصي! 🎉",
      "acco.yourProfileTypeHasBeen": "تم تحديث نوع حسابك بنجاح!",
      // --- accobann ---
      "accobann.anErrorOccurred": "حدث خطأ",
      "accobann.explainWhyYouBelieveThis": "اشرح سبب اعتقادك بأن الحظر غير عادل. سيتم مراجعة استئنافك خلال 48-72 ساعة.",
      "accobann.fraudulentActivity": "نشاط احتيالي",
      "accobann.lowTrustScore": "انخفاض درجة الثقة",
      "accobann.multipleReports": "شكاوى متعددة",
      "accobann.pleaseWriteYourAppealMessage": "يرجى كتابة رسالة الاستئناف",
      "accobann.policyViolation": "مخالفة للسياسات",
      "accobann.spamActivity": "رسائل مزعجة",
      "accobann.tooManyRejectedAds": "كثرة الإعلانات المرفوضة",
      "accobann.writeYourMessageHere": "اكتب رسالتك هنا...",
      "accobann.yourAppealHasBeenSubmitted": "تم إرسال استئنافك",
      "accobann.yourAppealHasBeenSubmitted2": "تم إرسال استئنافك بنجاح. سيتم مراجعته خلال 48-72 ساعة.",
      "accobann.yourPreviousAppealWasRejected": "تم رفض استئنافك السابق. لا يمكنك تقديم استئناف آخر.",
      // --- accoreco ---
      "accoreco.enus": "ar-EG",
      // --- accoresp ---
      "accoresp.buyer": "مشتري",
      "accoresp.failedToLoadResponses": "فشل في تحميل البيانات",
      "accoresp.inbox": "صندوق الوارد",
      "accoresp.noResponsesYet": "لا توجد ردود بعد",
      "accoresp.pleaseLogIn": "يرجى تسجيل الدخول",
      "accoresp.responses": "الردود",
      "accoresp.whenBuyersContactYouMessages": "عندما يتواصل المشترون معك، ستظهر الرسائل هنا",
      // --- accosusp ---
      "accosusp.afterTheSuspensionEndsYou": "بعد انتهاء التعليق، ستتمكن من تسجيل الدخول بشكل طبيعي",
      "accosusp.reviewOurPoliciesToAvoid": "راجع سياسات الاستخدام لتجنب المخالفات المستقبلية",
      "accosusp.suspensionEnded": "انتهى التعليق",
      "accosusp.waitUntilTheSuspensionPeriod": "انتظر حتى انتهاء فترة التعليق",
      "accosusp.whatCanYouDo": "ماذا يمكنك فعله؟",
      // --- accoview ---
      "accoview.byAd": "حسب الإعلان",
      "accoview.failedToLoadViews": "فشل في تحميل البيانات",
      "accoview.noViewsDataYet": "لا توجد بيانات مشاهدات بعد",
      "accoview.total": "الإجمالي",
      "accoview.views": "المشاهدات",
      "accoview.viewsWillAppearHereWhen": "ستظهر هنا عند عرض إعلاناتك",
      // --- adshar ---
      "adshar.copyLink": "نسخ الرابط",
      "adshar.copyText": "نسخ النص",
      "adshar.price": "السعر:",
      "adshar.share": "مشاركة الإعلان",
      // iter312 — Social-share platform labels (AR).
      "adshar.whatsappStatus": "حالة واتساب",
      "adshar.whatsappGroup": "مجموعة واتساب",
      "adshar.facebookGroup": "مجموعة فيسبوك",
      "adshar.captionCopiedHint": "تم نسخ النص — الصقه بعد اختيار المجموعة في فيسبوك.",
      // iter313 — Seller-facing share-analytics card (AR).
      "adshar.sharedTimes_zero": "تمت المشاركة 0 مرة",
      "adshar.sharedTimes_one": "تمت المشاركة مرة",
      "adshar.sharedTimes_two": "تمت المشاركة مرتين",
      "adshar.sharedTimes_few": "تمت المشاركة {{count}} مرات",
      "adshar.sharedTimes_many": "تمت المشاركة {{count}} مرة",
      "adshar.sharedTimes_other": "تمت المشاركة {{count}} مرة",
      "adshar.topPlatform": "أفضل منصة",
      "adshar.platform.whatsapp_status": "واتساب",
      "adshar.platform.whatsapp_group": "واتساب",
      "adshar.platform.facebook_group": "فيسبوك",
      "adshar.platform.native_share": "قائمة المشاركة",
      "adshar.platform.copy_link": "نسخ الرابط",
      "adshar.platform.copy_text": "نسخ النص",
      "adshar.noSharesYet": "لم تتم المشاركة بعد",
      // --- alp ---
      "alp.chooseYourAcademicLevel": "اختر مرحلتك التعليمية",
      "alp.skip": "تخطي",
      "alp.wellPersonalizeContentForYou": "سنخصص المحتوى حسب مرحلتك.",
      // --- bam ---
      "bam.appearsAtTopOfSearch": "يظهر في أعلى نتائج البحث",
      "bam.boostBenefits": "مميزات التعزيز:",
      "bam.boostFailed": "فشل التعزيز",
      "bam.boostNow": "تعزيز الآن",
      "bam.boostYourAd": "تعزيز الإعلان",
      "bam.boosted": "تم التعزيز!",
      "bam.boostedBadgeOnYourAd": 'شارة "مميز" على الإعلان',
      "bam.boosting": "جارٍ...",
      "bam.cancel": "إلغاء",
      "bam.connectionError": "خطأ في الاتصال",
      "bam.cost": "التكلفة:",
      "bam.insufficientBalanceTopUpYour": "رصيدك غير كافٍ. قم بشحن عملاتك أولاً.",
      "bam.insufficientCoins": "رصيد غير كافٍ",
      // --- bfb ---
      "bfb.allGenres": "كل المواد",
      // --- bfs ---
      "bfs.affectsAllSections": "(يؤثر على جميع الأقسام)",
      "bfs.allLevels": "جميع المراحل",
      "bfs.location": "الموقع",
      "bfs.country": "البلد",
      "bfs.city": "المدينة",
      "bfs.searchCountry": "ابحث عن البلد...",
      "bfs.searchCity": "ابحث عن المدينة...",
      "bfs.priceSdg": "السعر (جنيه)",
      "bfs.type": "النوع",
      "bfs.clearAll": "مسح الكل",
      "bfs.applyFilters": "تطبيق الفلاتر",
      // --- bookdeta ---
      "bookdeta.addDetails": "أضف تفاصيل...",
      "bookdeta.additionalDetails": "تفاصيل إضافية",
      "bookdeta.back": "رجوع",
      "bookdeta.bookDetails": "تفاصيل الكتاب",
      "bookdeta.call": "اتصل",
      "bookdeta.description": "الوصف",
      "bookdeta.duplicate": "مكرر",
      "bookdeta.free": "مجاني",
      "bookdeta.inappropriate": "محتوى غير لائق",
      "bookdeta.other": "أخرى",
      "bookdeta.posted": "نُشر في",
      "bookdeta.reason": "السبب",
      "bookdeta.reportListing": "إبلاغ عن هذا الإعلان",
      "bookdeta.reportThisListing": "إبلاغ عن هذا الإعلان",
      "bookdeta.save": "حفظ",
      "bookdeta.scam": "احتيال",
      "bookdeta.selectReason": "اختر السبب",
      "bookdeta.seller": "البائع",
      "bookdeta.spam": "محتوى مزعج",
      "bookdeta.scamFraud": "احتيال / نصب",
      "bookdeta.wrongCategory": "تصنيف خاطئ",
      "bookdeta.offensiveContent": "محتوى مسيء",
      "bookdeta.fakeItem": "عنصر مزيف",
      "bookdeta.additionalNote": "ملاحظة إضافية (اختياري)",
      "bookdeta.addNote": "أي تفاصيل إضافية...",
      "bookdeta.fileUnavailable": "الملف غير متوفر بعد",
      "bookdeta.fakeItemWarning": "البلاغات الكاذبة تؤثر على الثقة في المنصة. يرجى تقديم هذا البلاغ فقط إذا كنت متأكداً أن الإعلان مضلل أو مزيف أو مسيء.",
      "bookdeta.confirmReport": "تأكيد البلاغ",
      "bookdeta.confirmReportMsg": "هل أنت متأكد من إرسال هذا البلاغ؟",
      "bookdeta.yesSubmit": "نعم، أرسل",
      "bookdeta.submit": "إرسال",
      "bookdeta.submitting": "جاري الإرسال...",
      "bookdeta.preview": "معاينة",
      "bookdeta.viewSample": "عرض العينة",
      "bookdeta.noPreview": "لا توجد معاينة",
      "bookdeta.previewPages": "صفحات المعاينة",
      "bookdeta.uploadPreview": "رفع معاينة",
      "bookdeta.optionalPreview": "اختياري — ارفع 1-2 صفحة معاينة",
      "bookdeta.previewOf": "من",
      "bookdeta.booksShared": "كتب مشاركة",
      "bookdeta.downloads": "تحميلات",
      "bookdeta.rating": "التقييم",
      "bookdeta.reviews": "مراجعات",
      "bookdeta.verifiedStudent": "طالب موثق",
      "bookdeta.rateThisBook": "قيم هذا الكتاب",
      "bookdeta.writeReview": "اكتب مراجعة (اختياري)",
      "bookdeta.submitRating": "إرسال التقييم",
      "bookdeta.ratingSubmitted": "تم إرسال التقييم!",
      "bookdeta.loginToRate": "سجل الدخول للتقييم",
      "bookdeta.recentReviews": "المراجعات",
      "bookdeta.moreFromSeller": "المزيد من هذا البائع",
      "bookdeta.showLess": "عرض أقل",
      "bookdeta.noOtherListings": "لا توجد إعلانات أخرى",
      "bookdeta.contactOptions": "خيارات التواصل",
      "bookdeta.chatInWassla": "محادثة في وصلة",
      "bookdeta.contactSellerCTA": "تواصل مع البائع",
      "bookdeta.reportFalseWarning": "البلاغات الكاذبة أو المسيئة قد تؤدي إلى تقييد حسابك.",
      "bookdeta.whatsapp": "واتساب",
      "bookdeta.email": "البريد الإلكتروني",
      "bookdeta.editContacts": "تعديل طرق التواصل",
      "bookdeta.contactsUpdated": "تم تحديث طرق التواصل",
      "bookdeta.updateFailed": "تعذر تحديث طرق التواصل",
      "bookdeta.messenger": "ماسنجر",
      "fap.title": "مرحباً بك في وصلة 👋",
      "fap.text": "ابدأ الآن بنشر إعلانك الأول أو استكشف الفرص من حولك.",
      "fap.postAd": "نشر إعلان",
      "fap.browse": "استكشاف الإعلانات",
      "bookdeta.sellerUnavailable": "معلومات اتصال البائع غير متوفرة",
      "bookdeta.noReviews": "لا توجد مراجعات بعد",
      "bookdeta.yourRating": "تقييمك",
      // --- bookhub ---
      "bookhub.bookInSeconds": "احجز بسرعة",
      // --- boosmoda ---
      "boosmoda.adBoostedSuccessfully": "تم تعزيز الإعلان بنجاح!",
      "boosmoda.adMustBePublishedFirst": "يجب نشر الإعلان أولاً",
      "boosmoda.boostFailedPleaseTryAgain": "فشل التعزيز. حاول مرة أخرى.",
      "boosmoda.cannotBoostAHiddenAd": "لا يمكن تعزيز إعلان مخفي",
      "boosmoda.cannotBoostASoldAd": "لا يمكن تعزيز إعلان مباع",
      "boosmoda.insufficientBalance": "رصيدك غير كافٍ",
      "boosmoda.thisAdIsAlreadyBoosted": "هذا الإعلان معزّز بالفعل",
      // --- bottnav ---
      "bottnav.home": "الرئيسية",
      "bottnav.messages": "الرسائل",
      "bottnav.myAccount": "حسابي",
      "bottnav.sell": "أضف إعلان",
      "bottnav.shop": "المتجر",
      // --- bsm ---
      "bsm.chooseABoostType": "اختر نوع التعزيز",
      "bsm.duration": "المدة:",
      "bsm.purchase": "شراء",
      "bsm.purchasing": "جارٍ الشراء...",
      "bsm.selectABoostType": "اختر نوع التعزيز",
      // --- catehead ---
      "catehead.goBack": "رجوع",
      // --- cont ---
      "cont.afterLoggingInTapThe": 'بعد تسجيل الدخول، اضغط على زر "+" في أسفل الشاشة، ثم اختر الفئة المناسبة واملأ تفاصيل الإعلان.',
      "cont.contactUs": "تواصل معنا",
      "cont.copied": "تم النسخ",
      "cont.copy": "نسخ",
      "cont.email": "البريد الإلكتروني",
      "cont.errorPleaseTryAgain": "حدث خطأ، حاول مرة أخرى",
      "cont.faqs": "الأسئلة الشائعة",
      "cont.frequentlyAskedQuestions": "الأسئلة الشائعة",
      "cont.goBack": "العودة",
      "cont.goToSettingsAccountDelete": "اذهب إلى حسابي > الإعدادات > حذف الحساب. الحذف نهائي — سيتم إزالة جميع إعلاناتك ورسائلك وبياناتك ولا يمكن استرجاعها.",
      "cont.deleteAccount.intro": "حذف الحساب يزيل إعلاناتك ومحادثاتك وملفك الشخصي. إليك الطريقة:",
      "cont.deleteAccount.step1": "افتح تبويب «حسابي» من الشريط السفلي.",
      "cont.deleteAccount.step2": "اضغط على أيقونة القائمة في الأعلى يمين/يسار لفتح «الإعدادات».",
      "cont.deleteAccount.step3": "مرّر للأسفل بعد قائمة الإعدادات (تعديل الملف، اللغة، الوضع الداكن…).",
      "cont.deleteAccount.step4": "اضغط على «حذف الحساب» في الأسفل، ثم أكّد العملية.",
      "cont.deleteAccount.warning": "هذا الإجراء نهائي. سيتم فقدان إعلاناتك ومحادثاتك ومفضلاتك ورصيد المحفظة بشكل دائم ولن يمكن استرجاعها.",
      "cont.deleteAccount.support": "تحتاج مساعدة؟ تواصل مع الدعم قبل الحذف — قد نتمكن من حلّ المشكلة بدلًا من ذلك.",
      "cont.helpSupport": "المساعدة والدعم",
      "cont.howDoIContactA": "كيف أتواصل مع البائع؟",
      "cont.howDoICreateA": "كيف أنشئ حساب جديد؟",
      "cont.howDoIDeleteMy": "كيف أحذف حسابي؟",
      "cont.howDoIPostAn": "كيف أنشر إعلان؟",
      "cont.howDoIReportA": "كيف أبلغ عن إعلان مخالف؟",
      "cont.instantResponse": "تواصل معنا عبر واتساب",
      "cont.message": "الرسالة",
      "cont.messageSentSuccessfully": "تم إرسال رسالتك بنجاح!",
      "cont.name": "الاسم",
      "cont.openTheAdTapReport": "افتح الإعلان، اضغط على قائمة النقاط الثلاث (⋮) في الأعلى، اختر «إبلاغ»، حدد السبب ثم أرسل البلاغ. سيقوم فريقنا بمراجعة البلاغ.",
      "cont.privacyPolicy": "سياسة الخصوصية",
      "cont.responseWithin24Hours": "سنرد عليك عبر البريد الإلكتروني",
      "cont.send": "إرسال",
      "cont.sendAMessage": "إرسال طلب دعم",
      "cont.emailSupport": "الدعم عبر البريد الإلكتروني",
      "cont.whatsappSupport": "الدعم عبر واتساب",
      "cont.supportFormHelper1": "هذا النموذج يرسل رسالة إلى دعم وصلة عبر البريد الإلكتروني.",
      "cont.supportFormHelper2": "سنرد عليك على بريدك الإلكتروني.",
      "cont.supportFormHelper3": "في حال تأخر الرد، يرجى التحقق من البريد غير الهام (Spam)",
      "cont.supportRequestSent": "تم إرسال طلب الدعم بنجاح.",
      "cont.supportRequestReplyNote": "سيرد عليك فريق وصلة عبر البريد الإلكتروني.",
      "cont.duplicateRequest": "استلمنا رسالتك هذه بالفعل. سنرد عليك عبر البريد الإلكتروني.",
      "cont.sending": "جارٍ الإرسال...",
      "cont.subject": "الموضوع",
      "cont.tapTheContactSellerButton": "افتح صفحة الإعلان واستخدم أزرار واتساب أو رسالة أو اتصال للتواصل مع البائع مباشرة.",
      "cont.termsOfUse": "شروط الاستخدام",
      "cont.thankYouForReachingOut": "شكراً لتواصلك معنا!",
      "cont.wasslaClassifiedsPlatform": "وصلة - منصة إعلانات مبوبة",
      "cont.wellGetBackToYou": "سنرد عليك في أقرب وقت ممكن.",
      "cont.wereHereToHelpYou": "نحن هنا لمساعدتك",
      "cont.whatsapp": "واتساب",
      "cont.youCanCreateANew": 'يمكنك إنشاء حساب جديد بالضغط على "تسجيل الدخول" واختيار "إنشاء حساب". يمكنك التسجيل بالبريد الإلكتروني أو حساب Google.',
      // --- crophome ---
      "crophome.beTheFirstToPost": "كن أول من ينشر في هذه المنطقة!",
      "crophome.browseCrops": "تصفح المحاصيل",
      "crophome.latestListings": "أحدث العروض",
      "crophome.loadMore": "تحميل المزيد",
      "crophome.loading": "جارٍ التحميل...",
      "crophome.noCropsFound": "لا توجد محاصيل حالياً",
      "crophome.postYourCrop": "انشر محصولك",
      "crophome.postYourFirstAd": "انشر إعلانك الأول",
      "crophome.sample": "عينة",
      "crophome.searchCrops": "ابحث عن محاصيل...",
      "crophome.signInToContinue": "سجّل الدخول للمتابعة",
      "crophome.theseAreSampleAdsPost": "💡 هذه إعلانات تجريبية - انشر إعلانك الحقيقي!",
      // --- csb ---
      "csb.search": "بحث",
      "csb.wellShowVisuallySimilarItems": "سنُظهر لك عناصر مشابهة بصريًا. لا نقوم بتخزين الصور.",
      // --- gsii ---
      "gsii.continueWithGoogle": "متابعة باستخدام Google",
      "gsii.googleSigninFailed": "فشل تسجيل الدخول بواسطة Google",
      "gsii.signedInSuccessfully": "تم تسجيل الدخول بنجاح",
      // --- had ---
      "had.contactAttempts": "محاولات التواصل",
      "had.contactClicks": "نقر على التواصل",
      "had.copyClicks": "نسخ المعلومات",
      "had.dataWillAppearHereWhen": "ستظهر البيانات هنا عندما يتفاعل المستخدمون مع صفحة المساعدة",
      "had.eventBreakdown": "تفاصيل الأحداث",
      "had.failedToLoadAnalytics": "فشل تحميل البيانات",
      "had.faqOpens": "فتح الأسئلة",
      "had.helpSearches": "بحث في المساعدة",
      "had.helpSupportAnalytics": "تحليلات المساعدة والدعم",
      "had.last14Days": "آخر 14 يوم",
      "had.last30Days": "آخر 30 يوم",
      "had.last7Days": "آخر 7 أيام",
      "had.last90Days": "آخر 90 يوم",
      "had.loadingAnalytics": "جارٍ التحميل...",
      "had.noDataYet": "لا توجد بيانات بعد",
      "had.pageViews": "مشاهدات الصفحة",
      "had.retry": "إعادة المحاولة",
      "had.topContactMethods": "طرق التواصل الأكثر استخداماً",
      "had.topFaqs": "أكثر الأسئلة شيوعاً",
      "had.uniqueSessions": "جلسة فريدة",
      "had.userFunnel": "مسار المستخدم",
      // --- hag ---
      "hag.startExploring": "استكشف الآن",
      // --- hmr ---
      "hmr.exploreHubs": "استكشف الأقسام",
      "hmr.tapToBrowse": "اضغط للتصفح",
      // --- home ---
      "home.basedOnYourActivity": "بناءً على نشاطك",
      "home.clearAll": "مسح الكل",
      // --- saved searches ---
      "savedSearches.title": "عمليات البحث المحفوظة",
      "savedSearches.subtitle": "سنخبرك عندما تظهر إعلانات جديدة مطابقة لهذه الفلاتر.",
      "savedSearches.save": "حفظ البحث",
      "savedSearches.saved": "تم حفظ البحث — ستصلك إشعارات",
      "savedSearches.alreadySaved": "هذا البحث محفوظ مسبقًا",
      "savedSearches.needFilters": "أضف كلمة بحث أو فلترًا أولًا",
      "savedSearches.saveFailed": "تعذّر الحفظ — حاول مرة أخرى",
      "savedSearches.limitReached": "وصلت إلى الحد الأقصى (٢٥ بحث محفوظ)",
      "savedSearches.authRequired": "سجّل الدخول لحفظ عمليات البحث",
      "savedSearches.emptyTitle": "لا توجد عمليات بحث محفوظة",
      "savedSearches.emptyHint": "شغّل بحثًا في الصفحة الرئيسية واضغط «حفظ البحث» لتصلك الإشعارات.",
      "savedSearches.viewResults": "عرض",
      "savedSearches.delete": "حذف",
      "savedSearches.deleted": "تم حذف البحث المحفوظ",
      "savedSearches.deleteFailed": "تعذّر الحذف — حاول مرة أخرى",
      "savedSearches.loadFailed": "تعذّر تحميل عمليات البحث المحفوظة",
      "savedSearches.defaultLabel": "بحث محفوظ",
      "savedSearches.pillCategory": "الفئة: {{value}}",
      "savedSearches.pillLocation": "الموقع: {{value}}",
      "account.alerts": "عمليات البحث المحفوظة",
      "home.clearImageSearch": "✕ مسح البحث بالصورة",
      "home.enterCityOrArea": "أدخل المدينة أو المنطقة",
      "home.filters": "الفلترة",
      "home.filtersApplied": "تم تطبيق الفلاتر",
      "home.forYou": "لك",
      "home.imageSearchActive": "🔍 البحث بالصورة مفعل",
      "home.justPosted": "أضيف حديثاً",
      "home.listingsNearby": "إعلانات قريبة",
      "home.loadingProducts": "جارٍ تحميل المنتجات...",
      "home.location": "الموقع",
      "home.location2": "الموقع:",
      "home.max": "الحد الأقصى",
      "home.min": "الحد الأدنى",
      "home.mostPopularRightNow": "الأكثر مشاهدة",
      "home.mostViewed": "الأكثر مشاهدة",
      "home.nearMe": "بالقرب مني",
      "home.nearYou": "بالقرب منك",
      // iter319 — Premium Near Me card (AR).
      "home.nearMe.searching": "جاري البحث عن إعلانات قريبة منك…",
      "home.nearMe.showingNearby": "نعرض لك الإعلانات الأقرب لموقعك الحالي",
      "home.nearMe.showingNearbyWithin": "نعرض لك الإعلانات في نطاق {{km}} كم من موقعك",
      "home.nearMe.showingLiveFallback": "نعرض الإعلانات المتاحة حالياً إلى أن يتوفر الموقع.",
      "home.nearMe.noNearbyButLive": "لا توجد إعلانات قريبة جداً منك حالياً. نعرض لك إعلانات نشطة أخرى.",
      "home.nearMe.noNearbyMatches": "لا توجد إعلانات قريبة حالياً",
      // Location permission CTA + feedback.
      "home.nearMe.useMyLocation": "استخدم موقعي",
      "home.nearMe.refreshLocation": "تحديث موقعي",
      "home.nearMe.requestingLocation": "جارٍ تحديد الموقع…",
      "home.nearMe.permissionDenied": "الوصول للموقع غير مفعل. فعّله لعرض الإعلانات القريبة منك.",
      "home.nearMe.locationError": "لم نتمكن من قراءة موقعك. حاول مرة أخرى أو اختر مدينتك يدوياً.",
      // iter319 — Manual fallback (AR).
      "home.nearMe.chooseCity": "اختر مدينتك",
      "home.nearMe.chooseCityPrompt": "اختر مدينة",
      "home.nearMe.apply": "تطبيق",
      "home.nearMe.cancel": "إلغاء",
      // iter324 — Guest-friendly idle copy (AR).
      "home.nearMe.guestIdleTitle": "اعرض الإعلانات القريبة منك. استخدم موقعك مرة واحدة، اختر مدينتك، أو سجل الدخول لحفظ تفضيلاتك.",
      "home.nearMe.userIdleTitle": "اعرض الإعلانات القريبة منك. استخدم موقعك أو اختر مدينتك.",
      "home.nearMe.signIn": "تسجيل الدخول",
      "home.nearMe.guestGpsHelper": "سجل الدخول لحفظ تفضيلات الموقع.",
      "home.nearMe.tryAgain": "حاول مرة أخرى",
      "home.nearMe.chooseCityInstead": "اختر المدينة بدلاً من ذلك",
      "home.nearMe.signInBeforeGps": "يرجى تسجيل الدخول أولاً، ثم السماح بالوصول للموقع لعرض الإعلانات القريبة منك.",
      // iter327 — WasslaImage fallback caption (AR).
      "image.unavailable": "الصورة غير متاحة",
      // iter322 Phase A refinement — Strict manual location filter empty state (AR).
      "home.nearMe.emptyManualTitle": "لا توجد إعلانات في هذا الموقع حتى الآن",
      "home.nearMe.emptyManualHint": "جرّب مدينة قريبة أو امسح فلتر الموقع.",
      "home.nearMe.changeLocation": "تغيير الموقع",
      "home.nearMe.clearLocation": "مسح الموقع",
      "home.nearMe.strictModeShowing": "نعرض إعلانات في {{label}} فقط",
      "home.newListings": "إعلانات جديدة",
      "home.newest": "الأحدث",
      "home.new": "جديد",
      "home.negotiable": "قابل للتفاوض",
      "home.noExactMatchesFound": "لا توجد نتائج مطابقة",
      "home.priceHighToLow": "السعر: من الأعلى للأقل",
      "home.priceHighlow": "السعر: تنازلي",
      "home.priceLowToHigh": "السعر: من الأقل للأعلى",
      "home.priceLowhigh": "السعر: تصاعدي",
      "home.priceRange": "نطاق السعر",
      "home.recentSearches": "عمليات البحث الأخيرة",
      "home.searchProductsServicesJobs": "ابحث عن منتجات، خدمات…",
      "home.showAllProducts": "عرض جميع المنتجات",
      "home.topSearch": "الأكثر بحثًا",
      "home.topSearched": "الأكثر بحثاً",
      "home.trending": "الرائج",
      "home.tryDifferentKeywordsOrBrowse": "جرب كلمة بحث أخرى أو تصفح الاقتراحات",
      "home.trySearchingFor": "جرب البحث عن:",
      "home.whatOthersAreSearching": "ما يبحث عنه الآخرون",
      "home.youMightAlsoLike": "قد يعجبك أيضاً",
      "home.yourPreferenceHasBeenSaved": "تم حفظ اختيارك بنجاح!",
      // --- lcr ---
      "lcr.academicLevels": "المراحل الدراسية",
      "lcr.scrollNext": "تمرير للتالي",
      "lcr.scrollPrevious": "تمرير للسابق",
      "lcr.seeAll": "عرض الكل",
      "lcr.trustedSellersWithHighRatings": "بائعون موثوقون مع تقييمات عالية",
      // --- lms ---
      "lms.allCategories": "جميع الفئات",
      "lms.noResultsFound": "لا توجد نتائج",
      "lms.searchCategories": "ابحث عن فئة...",
      // --- lsr ---
      "lsr.level": "المرحلة:",
      // --- mess ---
      "mess.aboutOptional": "الموضوع (اختياري)",
      "mess.backToMessages": "العودة",
      "mess.conversationNotFound": "المحادثة غير موجودة",
      "mess.deleteConversation": "حذف المحادثة",
      "mess.deleteConversationTitle": "حذف المحادثة؟",
      "mess.deleteConversationBody": "سيؤدي هذا إلى إزالة هذه المحادثة نهائياً من صندوق الرسائل.",
      "mess.delete": "حذف",
      "mess.cancel": "إلغاء",
      "mess.deleted": "تم حذف المحادثة",
      "mess.deleteFailed": "تعذّر حذف المحادثة. حاول مرة أخرى.",
      "mess.create": "إنشاء",
      "mess.nameTitle": "الاسم",
      "mess.newConversation": "محادثة جديدة",
      "mess.noConversationsYet": "لا توجد محادثات",
      "mess.productName": "اسم المنتج",
      "mess.searchConversations": "بحث في المحادثات...",
      "mess.sellerNameOrAdTitle": "اسم البائع أو الإعلان",
      "mess.thanksNotedWhatPriceAre": "شكراً، تم الاستلام.",
      "mess.typeAMessage": "اكتب رسالة...",
      // --- more ---
      "more.account": "الحساب",
      "more.admin": "الإدارة",
      "more.allAdditionalFeaturesInOne": "جميع الميزات الإضافية في مكان واحد",
      "more.boostAd": "تعزيز الإعلانات",
      "more.growth": "النمو",
      "more.moderation": "المراجعة",
      "more.money": "المال",
      "more.more": "المزيد",
      "more.profile": "الملف الشخصي",
      "more.referRewards": "الإحالة والمكافآت",
      "more.safetyCenter": "مركز الأمان",
      "more.settings": "الإعدادات",
      "more.tools": "أدوات",
      "more.transactions": "سجل المعاملات",
      "more.translationHistory": "سجل الترجمة",
      "more.walletCoins": "المحفظة والعملات",
      // --- onborole ---
      "onborole.academicLevel": "المرحلة الدراسية",
      "onborole.anErrorOccurredPleaseTry": "حدث خطأ. حاول مرة أخرى.",
      "onborole.continue": "ابدأ استخدام وصلة",
      "onborole.iAmA": "كيف تريد استخدام وصلة؟",
      "onborole.saving": "جاري الإعداد...",
      "onborole.selectYourProfileTypeTo": "اختر الخيار الذي يصفك بشكل أفضل.\nيمكنك تغييره لاحقًا في أي وقت.",
      "onborole.welcomeToWassla": "مرحباً بك في وصلة",
      "onborole.youCanChangeThisLater": "يمكنك تغيير هذا في أي وقت من الإعدادات",
      "onborole.stepLabel": "",
      "onborole.sellerLabel": "أبيع شيء",
      "onborole.sellerDesc": "انشر إعلانات، عزّز ظهورك، وأوصل إلى آلاف المشترين.",
      "onborole.buyerLabel": "تصفح وتسوّق",
      "onborole.buyerDesc": "اكتشف العروض، تواصل مع البائعين، واعثر على ما تحتاجه.",
      "onborole.studentLabel": "الطالب",
      "onborole.studentDesc": "الوصول إلى الكتب والملخصات وأدوات السيرة الذاتية.",
      "onborole.serviceLabel": "أقدم خدمة",
      "onborole.serviceDesc": "اعرض خدماتك المهنية واجذب العملاء.",
      "onborole.proLabel": "محترف",
      "onborole.proDesc": "انشر إعلانات، أدِر قوائمك، وتواصل مع المشترين.",
      "onborole.generalLabel": "مستخدم عام",
      "onborole.generalDesc": "تصفح السوق واستكشف كل الأقسام.",
      // --- psb ---
      "psb.clear": "مسح",
      "psb.noRecentSearchesYet": "لا يوجد بحث حديث",
      "psb.searchWithImage": "البحث بالصورة",
      "psb.searching": "جارٍ البحث...",
      "psb.selectAnExistingPhoto": "اختيار صورة موجودة",
      "psb.takePhoto": "التقاط صورة",
      "psb.wellShowVisuallySimilarAds": "سنُظهر لك إعلانات مشابهة بصريًا. لا نقوم بتخزين هذه الصور. تُستخدم للبحث فقط.",
      // --- pss ---
      "pss.apply": "تطبيق",
      "pss.clearAll": "مسح الكل",
      "pss.sortBy": "ترتيب حسب",
      // --- ptp ---
      "ptp.text": "Switch to English",
      "ptp.text2": "English",
      // --- ptw ---
      "ptw.popularThisWeek": "الأكثر رواجاً هذا الأسبوع",
      "ptw.viewAll": "عرض الكل",
      // --- ras ---
      "ras.anErrorOccurredPleaseTry": "حدث خطأ، يرجى المحاولة لاحقاً",
      // --- rolesele ---
      "rolesele.accountTypeUpdatedSuccessfully": "تم تحديث نوع الحساب بنجاح",
      "rolesele.close": "إغلاق",
      // --- savefab ---
      "savefab.saved": "محفوظ",
      // --- sbp ---
      "sbp.changeLevel": "تغيير المرحلة",
      "sbp.tryAnotherLevelOrPost": "جرب مرحلة أخرى أو أضف أول كتاب",
      "sbp.addBook": "إضافة كتاب",
      "sbp.loginToPost": "سجل دخول للنشر",
      "sbp.filter": "تصفية",
      "sbp.preview": "معاينة",
      "sbp.previewUnavailable": "المعاينة غير متاحة",
      "sbp.paid": "مدفوع",
      "sbp.free": "مجاني",
      "sbp.all": "الكل",
      "sbp.pastPapers": "نماذج امتحانية",
      "sbp.lectureNotes": "مذكرات",
      "sbp.textbooks": "كتب",
      "sbp.labManuals": "أدلة المختبر",
      "sbp.summaries": "ملخصات",
      "sbp.slides": "شرائح",
      "sbp.notebook": "دفتر",
      "sbp.pdf": "ملف PDF",
      "sbp.magazine": "مجلة",
      "sbp.newest": "الأحدث",
      "sbp.priceLowHigh": "السعر: من الأقل للأعلى",
      "sbp.priceHighLow": "السعر: من الأعلى للأقل",
      "sbp.freeFirst": "المجاني أولاً",
      "sbp.downloads": "التنزيلات",
      "sbp.subject": "المادة",
      "sbp.university": "الجامعة",
      "sbp.level": "المستوى",
      "sbp.department": "القسم",
      "sbp.location": "الموقع",
      "sbp.sortBy": "ترتيب حسب",
      "sbp.views": "مشاهدات",
      "sbp.saves": "حفظ",
      "sbp.document": "مستند",
      "sbp.notes": "مذكرة",
      "sbp.textbook": "كتاب دراسي",
      "sbp.pastExam": "امتحان سابق",
      "sbp.labManual": "دليل مختبر",
      "sbp.summary": "ملخص",
      "sbp.pdf": "PDF",
      // --- scg ---
      "scg.browseSubcategories": "اختر القسم الفرعي",
      "scg.shopByCategory": "تسوق حسب القسم",
      // --- selltrus ---
      "selltrus.phoneVerified": "هاتف موثق",
      "selltrus.repliesFast": "رد سريع",
      "selltrus.verifiedSeller": "بائع موثق",
      "selltrus.trustedSeller": "بائع موثوق",
      "selltrus.activeSeller": "بائع نشط",
      // --- sett ---
      "sett.aboutWassla": "عن وصلة",
      "sett.dark": "داكن",
      "sett.editProfile": "تعديل الملف الشخصي",
      "sett.english": "العربية",
      "sett.language": "اللغة",
      "sett.light": "فاتح",
      "sett.manageYourAppAndAccount": "إدارة تفضيلات الحساب والتطبيق",
      "sett.termsConditions": "الشروط والأحكام",
      "sett.theme": "المظهر",
      // --- shc ---
      "shc.level": "المرحلة",
      // --- shh ---
      "shh.booksOpportunitiesCvBuilder": "كتب • فرص • سيرة ذاتية",
      "shh.booksScholarshipsOpportunitiesCvBuilder": "كتب • ملخصات • سيرة ذاتية",
      "shh.filter": "فلتر",
      "shh.investInYourFutureToday": "استثمر في مستقبلك اليوم",
      "shh.learnBuildGrow": "تعلّم • طوّر • انطلق",
      "shh.searchHistory": "سجل البحث",
      "shh.studentHub": "قسم الطلاب",
      "shf.comingSoon": "قريباً",
      "shf.featureComingSoonDesc": "هذه الميزة قيد التطوير وستكون متاحة قريباً.",
      "shf.backToStudentHub": "العودة لقسم الطلاب",
      "shf.yourAcademicLevel": "مستواك الدراسي",
      // --- shl ---
      "shl.later": "لاحقاً",
      "shl.selectACategoryToBegin": "اختر فئة للبدء أو ابحث مباشرة",
      "shl.selectYourAcademicLevel": "اختر مستواك الدراسي",
      "shl.updated": "تم التحديث",
      "shl.wellPersonalizeContentBasedOn": "سنقوم بعرض الكتب والمواد التعليمية المناسبة لمستواك الدراسي.",
      "shl.secondary": "الثانوي",
      "shl.university": "الجامعة",
      "shl.postgrad": "الدراسات العليا",
      "shl.vocational": "التعليم المهني",
      "shl.vocationalHint": "المعاهد التقنية والتدريبية",
      "shl.other": "أخرى",
      "shl.levelSelected": "تم اختيار {{level}}",
      "shl.editLevel": "تعديل المستوى",
      "shl.changeAcademicLevel": "تغيير المستوى الدراسي",
      "shl.yourLevel": "مستواك الدراسي",
      "shl.levelUpdated": "تم تحديث المستوى الدراسي",
      // --- slp ---
      "slp.admission": "تقديم",
      "slp.all": "الكل",
      "slp.clearFilters": "مسح الفلاتر",
      "slp.course": "دورة",
      "slp.deadline": "آخر موعد:",
      "slp.guide": "دليل",
      "slp.hybrid": "مختلط",
      "slp.internship": "تدريب",
      "slp.job": "وظيفة",
      "slp.noResultsForThisLevel": "لا توجد نتائج لهذه المرحلة",
      "slp.oldest": "الأقدم",
      "slp.onsite": "حضوري",
      "slp.opportunity": "فرصة",
      "slp.paid": "مدفوع",
      "slp.remote": "عن بعد",
      "slp.scholarship": "منحة",
      "slp.select": "اختر",
      "slp.selectLevel": "اختر المرحلة",
      "slp.sortBy": "الترتيب",
      "slp.volunteer": "تطوع",
      "slp.workType": "نوع العمل",
      // --- studgami ---
      "studgami.allBadges": "جميع الشارات",
      "studgami.greatJobKeepGoing": "أحسنت! استمر في التقدم",
      "studgami.levelUp": "ترقية!",
      "studgami.unlocked": "مفتوح!",
      // --- studhub ---
      "studhub.dailyVisit": "زيارة يومية",
      "studhub.postABook": "أضف كتاباً",
      // --- studpage ---
      "studpage.additionalTools": "أدوات إضافية",
      "studpage.available": "متاح",
      "studpage.availableTemplates": "القوالب المتاحة",
      "studpage.benefits": "المميزات",
      "studpage.bestValue": "الأفضل",
      "studpage.chooseYourPlan": "اختر خطتك",
      "studpage.getCoins": "احصل على عملات",
      "studpage.itemUnlockedSuccessfully": "تم فتح العنصر بنجاح!",
      "studpage.locked": "مقفل",
      "studpage.notEnoughCoins": "لا توجد عملات كافية",
      "studpage.price": "السعر",
      "studpage.pro": "متقدم",
      "studpage.somethingWentWrong": "حدث خطأ",
      "studpage.startFree": "ابدأ مجاناً",
      "studpage.unlockNow": "فتح الآن",
      "studpage.unlocked": "مفتوح",
      "studpage.unlocking": "جاري الفتح...",
      "studpage.useTemplates": "استخدام القوالب",
      "studpage.yourBalance": "رصيدك:",
      // --- trusbadg ---
      "trusbadg.boosted": "مميز",
      "trusbadg.buyerProtection": "حماية المشتري",
      "trusbadg.safeContact": "تواصل آمن",
      "trusbadg.shopSafelyNeverPayUpfront": "تواصل بأمان. لا تدفع مقدماً لبائعين غير موثقين.",
      "trusbadg.trustSafety": "إشارات الثقة",
      "trusbadg.verified": "موثّق",
      // --- upcm ---
      "upcm.15MinutesOfAds": "15 دقيقة إعلانات",
      "upcm.accountName": "اسم الحساب:",
      "upcm.ads": "إعلانات",
      "upcm.afterPayingUploadTheReceipt": "بعد الدفع، قم برفع صورة الإيصال للمتابعة",
      "upcm.alreadyUnlocked": "تم فتح الميزة!",
      "upcm.amount": "المبلغ:",
      "upcm.bankak": "بنكك",
      "upcm.bestScore": "أفضل نتيجة",
      "upcm.channel": "القناة:",
      "upcm.checking": "جاري التحقق...",
      "upcm.chooseAMethodToUnlock": "اختر طريقة لفتح ميزة تصدير السيرة الذاتية بصيغة PDF احترافية",
      "upcm.demoModeRealAppWill": "(وضع تجريبي - في التطبيق الفعلي ستظهر إعلانات حقيقية)",
      "upcm.demoModeRealAppWill2": "(وضع تجريبي - في التطبيق الفعلي ستظهر لعبة حقيقية)",
      "upcm.game": "لعبة",
      "upcm.great": "رائع!",
      "upcm.onetimePayment": "دفعة واحدة",
      "upcm.paymentInstructions": "تعليمات الدفع",
      "upcm.pendingApproval": "في انتظار الموافقة",
      "upcm.playEarn": "العب واكسب!",
      "upcm.playFor15MinutesAnd": "العب لمدة 15 دقيقة وحقق 120 نقطة لفتح الميزة مجاناً",
      "upcm.playSession2Min": "العب جلسة (دقيقتان)",
      "upcm.playTime": "وقت اللعب",
      "upcm.receiptImageUrl": "رابط صورة الإيصال",
      "upcm.startBankakPayment": "بدء الدفع عبر بنكك",
      "upcm.startGame": "بدء اللعبة",
      "upcm.startWatchingAds": "بدء مشاهدة الإعلانات",
      "upcm.submitReceipt": "إرسال الإيصال",
      "upcm.unlockProCvPdf": "فتح السيرة الذاتية الاحترافية",
      "upcm.uploadReceipt": "رفع الإيصال",
      "upcm.uploadReceiptImage": "رفع صورة الإيصال",
      "upcm.watchAd1Minute": "مشاهدة إعلان (دقيقة واحدة)",
      "upcm.watchProgress": "تقدم المشاهدة",
      "upcm.watchShortAdsForA": "شاهد إعلانات قصيرة لمدة 15 دقيقة إجمالاً لفتح الميزة مجاناً",
      "upcm.youCanNowExportYour": "يمكنك الآن تصدير سيرتك الذاتية بصيغة PDF احترافية",
      "upcm.youCanUploadTheImage": "يمكنك رفع الصورة على أي خدمة سحابية ولصق الرابط هنا",
      "upcm.yourReceiptHasBeenSubmitted": "تم إرسال إيصالك وهو قيد المراجعة. سيتم إعلامك عند الموافقة.",
      // --- wall ---
      "wall.boostMyAd": "عزّز إعلاني",
      "viewAllHistory": "عرض الكل",
      "noTransactions": "لا توجد معاملات بعد",
      "wall.codeCopied": "تم نسخ الرمز!",
      "wall.coinRules": "قواعد العملات",
      "wall.coins": "عملات",
      "wall.coinsAreNotTransferableAnd": "العملات غير قابلة للتحويل أو للتحويل إلى نقد",
      "wall.coinsCanBeUsedFor": "العملات تستخدم للتعزيزات والأدوات المميزة",
      "wall.dailyLoginStreaksIncreaseBonuses": "سلسلة الدخول اليومية تزيد المكافآت",
      "wall.earn10CoinsWhenYour": "احصل على 10 عملات عندما ينشر صديقك إعلانه الأول!",
      "wall.earnedCoinsExpireAfter60": "العملات المكتسبة تنتهي بعد 60 يوم",
      "wall.failedToCopy": "فشل النسخ",
      "wall.increaseVisibilityInstantly": "زيادة ظهور إعلانك فوراً",
      "wall.inviteFriends": "ادعُ أصدقاءك",
      "wall.joinWassla": "انضم إلى وصلة!",
      "wall.linkCopied": "تم نسخ الرابط!",
      "wall.orShareTheLink": "أو شارك الرابط",
      "wall.postAnAdToStart": "انشر إعلان للبدء في التعزيز",
      "wall.referrals": "إحالات",
      "wall.yourReferralCode": "رمز الإحالة الخاص بك",
      // --- wallhist ---
      "wallhist.loadMore": "تحميل المزيد",
      "wallhist.noTransactionsYet": "لا توجد معاملات",
      "wallhist.startEarningCoinsThroughDaily": "ابدأ بكسب العملات من خلال المهام اليومية",
      "wallhist.transactionHistory": "سجل المعاملات",
      // --- whp ---
      "whp.encryptedSecure": "آمن ومشفر",
      "whp.history": "السجل",
      "whp.myWallet": "محفظتي",
      "whp.today": "اليوم",
      "whp.coins": "عملة",
      "whp.yesterday": "أمس",
      "whp.noTransactionsYet": "لا توجد معاملات بعد",
      "whp.yourWalletActivityWill": "سيظهر نشاط محفظتك هنا عند بدء استخدام العملات",
      "whp.viewAll": "عرض الكل",
      // --- wph ---
      "wph.youHaveUnsavedChangesExit": "لديك تغييرات غير محفوظة. هل تريد الخروج؟",
    }
  }
};

// Detect device/browser language
function detectDeviceLanguage() {
  try {
    const deviceLang = (navigator.language || (navigator.languages && navigator.languages[0]) || 'en').toLowerCase();
    return deviceLang.startsWith('ar') ? 'ar' : 'en';
  } catch (e) {
    return 'en';
  }
}

// Get saved language or detect from device
const savedLang = localStorage.getItem("lang");
const initialLang = savedLang || detectDeviceLanguage();

// If no saved language, persist detected language
if (!savedLang) {
  try {
    localStorage.setItem("lang", initialLang);
  } catch (e) {
    console.warn("Could not save default language to localStorage");
  }
}

// Apply RTL/LTR direction to document
function applyLangDirection(lang) {
  if (typeof document !== 'undefined') {
    const normalizedLang = lang?.startsWith('ar') ? 'ar' : lang?.startsWith('en') ? 'en' : 'en';
    document.documentElement.lang = normalizedLang;
    document.documentElement.dir = normalizedLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.classList.toggle('rtl', normalizedLang === 'ar');
    document.documentElement.classList.toggle('ltr', normalizedLang !== 'ar');
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: "en", // Fallback to English
    interpolation: { escapeValue: false }
  });

// Apply direction on initial load
applyLangDirection(initialLang);

// Listen for language changes and apply direction
i18n.on('languageChanged', (lng) => {
  applyLangDirection(lng);
  // Persist language change
  try {
    localStorage.setItem("lang", lng);
  } catch (e) {
    console.warn("Could not save language preference");
  }
});

export default i18n;
